/*
 * Obrah - PDP jun26 — UI nova de acabamento
 * (c) 2026 Obrah. All rights reserved.
 *
 * Sobrescreve a UI montada por custom-moldura.js#setupPP26MolduraCorUI:
 *   - 3 pills primarios: canvas / padrao / sem moldura
 *   - 3 modificadores (so quando padrao ativo): + profundidade / + fino / + paspatur
 *   - Mutex prof/fino
 *   - Resolve variant Shopify a partir da combinacao
 *
 * Por enquanto NAO bloqueia combinacoes invalidas nem oculta Qty=0/9999 —
 * isso entra na proxima iteracao.
 */
(function () {
  'use strict';

  var VARIANT_MAP = {
    'canvas|0|0|0': 'canvas',
    'sem moldura|0|0|0': 'sem moldura',
    'padrão|0|0|0': 'padrão',
    'padrão|0|0|1': 'padrão com paspatur',
    'padrão|1|0|0': 'caixa',
    'padrão|1|0|1': 'caixa com paspatur',
    'padrão|0|1|0': 'slim',
    'padrão|0|1|1': 'slim com paspatur',
  };

  // Disponibilidade de TIPO DE MOLDURA por TAMANHO, lida das variants reais do
  // produto (/products/{handle}.js). Estrutura: { '100x100': { caixa:true, ... } }.
  // Carregada 1x e cacheada. Usada pra desabilitar combinações que não existem
  // no tamanho selecionado (ex: 100x100 só tem caixa/canvas/sem moldura — padrão
  // raso e paspatur não existem nesse tamanho).
  var MOLD_BY_SIZE = null;
  // Preço (em centavos) por TAMANHO → MOLDURA, lido das mesmas variants.
  // Usado pra calcular o "+ R$ X" dos modificadores dinamicamente (varia por
  // tamanho; o mock do Paper é só ilustrativo).
  var PRICE_BY_SIZE = null;
  function loadMoldBySize(cb) {
    if (MOLD_BY_SIZE) { if (cb) cb(); return; }
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { MOLD_BY_SIZE = {}; PRICE_BY_SIZE = {}; if (cb) cb(); return; }
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var names = (p.options || []).map(function (o) { return (o && o.name) || o; });
        var molPos = names.findIndex(function (n) { return /tipo de moldura/i.test(n); });
        var sizePos = names.findIndex(function (n) { return /tamanho/i.test(n); });
        var map = {}, prices = {};
        if (molPos > -1 && sizePos > -1) {
          (p.variants || []).forEach(function (v) {
            var mol = v.options[molPos], sz = v.options[sizePos];
            (map[sz] = map[sz] || {})[mol] = true;
            (prices[sz] = prices[sz] || {})[mol] = v.price;
          });
        }
        MOLD_BY_SIZE = map;
        PRICE_BY_SIZE = prices;
        if (cb) cb();
      })
      .catch(function () { MOLD_BY_SIZE = {}; PRICE_BY_SIZE = {}; if (cb) cb(); });
  }

  // Fallback global: se uma <img> com src "jun26-*.webp" falhar (404 porque a
  // moldura nova ainda não foi subida), troca pelo arquivo sem prefix do tema
  // antigo. Roda em qualquer página, mas só ativa em src "jun26-*".
  function setupFrameFallback() {
    document.addEventListener('error', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'IMG') return;
      var src = t.src || '';
      if (src.indexOf('/jun26-') === -1) return;
      if (t.dataset.jun26FallbackTried) return;
      t.dataset.jun26FallbackTried = '1';
      var next = src.replace('/jun26-', '/');
      // Mantém o query string (?v=xxx) — Shopify CDN exige cache-buster
      t.src = next;
    }, true);
  }

  // Ferramenta de calibração de cor — aparece com ?colortool=1 ou ?colortool=COR
  function setupColorTool() {
    var params = new URLSearchParams(location.search);
    if (!params.has('colortool')) return;
    var target = params.get('colortool') || '1';
    var matchSrc = target === '1' ? 'pinus' : target;
    function injectPanel() {
      if (document.getElementById('jun26-color-tool')) return;
      var imgs = document.querySelectorAll('img[src*="' + matchSrc + '"]');
      if (!imgs.length) return;
      var panel = document.createElement('div');
      panel.id = 'jun26-color-tool';
      panel.style.cssText = 'position:fixed;top:80px;right:20px;background:#fff;border:1px solid #111;padding:16px;z-index:9999;font:12px Archivo,system-ui,sans-serif;width:300px;box-shadow:0 8px 24px rgba(0,0,0,.15);border-radius:4px';
      panel.innerHTML = ''
        + '<div style="font-weight:600;margin-bottom:12px;letter-spacing:.05em;text-transform:uppercase">Ajuste cor moldura — ' + matchSrc + '</div>'
        + '<div style="margin-bottom:10px"><label>Hue (matiz): <span id="ct-h">0</span>°</label><input id="ct-hue" type="range" min="-60" max="60" value="0" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Saturação: <span id="ct-s">1.00</span></label><input id="ct-sat" type="range" min="0" max="200" value="100" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Brilho: <span id="ct-b">1.00</span></label><input id="ct-br" type="range" min="50" max="150" value="100" style="width:100%"></div>'
        + '<div style="margin-bottom:10px"><label>Sépia: <span id="ct-sp">0</span></label><input id="ct-sep" type="range" min="0" max="100" value="0" style="width:100%"></div>'
        + '<button id="ct-close" style="position:absolute;top:8px;right:8px;width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:14px Archivo;color:#999;padding:0;line-height:1" aria-label="Ocultar">×</button>'
        + '<div style="display:flex;gap:6px;flex-wrap:wrap">'
        + '<button id="ct-reset" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo">RESET</button>'
        + '<button id="ct-export" style="padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo">COPIAR</button>'
        + '</div>'
        + '<div id="ct-out" style="margin-top:8px;font-family:monospace;font-size:10px;background:#f4f4f5;padding:6px;display:none;word-break:break-all"></div>';
      document.body.appendChild(panel);
      function curImgs() { return document.querySelectorAll('img[src*="' + matchSrc + '"]'); }
      function buildFilter() {
        var h = panel.querySelector('#ct-hue').value;
        var s = (panel.querySelector('#ct-sat').value / 100).toFixed(2);
        var b = (panel.querySelector('#ct-br').value / 100).toFixed(2);
        var sp = (panel.querySelector('#ct-sep').value / 100).toFixed(2);
        panel.querySelector('#ct-h').textContent = h;
        panel.querySelector('#ct-s').textContent = s;
        panel.querySelector('#ct-b').textContent = b;
        panel.querySelector('#ct-sp').textContent = sp;
        return 'hue-rotate(' + h + 'deg) saturate(' + s + ') brightness(' + b + ') sepia(' + sp + ')';
      }
      function apply() {
        var f = buildFilter();
        curImgs().forEach(function(i){ i.style.filter = f; });
        return f;
      }
      panel.querySelectorAll('input').forEach(function(i){ i.addEventListener('input', apply); });
      panel.querySelector('#ct-reset').onclick = function() {
        panel.querySelector('#ct-hue').value = 0;
        panel.querySelector('#ct-sat').value = 100;
        panel.querySelector('#ct-br').value = 100;
        panel.querySelector('#ct-sep').value = 0;
        curImgs().forEach(function(i){ i.style.filter = ''; });
        apply();
      };
      panel.querySelector('#ct-export').onclick = function() {
        var f = buildFilter();
        panel.querySelector('#ct-out').textContent = f;
        panel.querySelector('#ct-out').style.display = 'block';
        if (navigator.clipboard) navigator.clipboard.writeText(f);
      };
      // Ocultar painel (X). Cria mini-botão flutuante pra reabrir.
      panel.style.position = 'fixed';
      panel.querySelector('#ct-close').onclick = function() {
        panel.style.display = 'none';
        var open = document.getElementById('jun26-ct-reopen');
        if (!open) {
          open = document.createElement('button');
          open.id = 'jun26-ct-reopen';
          open.textContent = 'AJUSTAR COR';
          open.style.cssText = 'position:fixed;top:80px;right:20px;padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:9999;border-radius:0;box-shadow:0 4px 12px rgba(0,0,0,.15)';
          document.body.appendChild(open);
          open.onclick = function() {
            panel.style.display = '';
            open.remove();
          };
        }
      };
    }
    // Tenta injetar agora + observa DOM pra re-injetar quando o variant troca
    injectPanel();
    var mo = new MutationObserver(function(){
      if (!document.getElementById('jun26-color-tool')) injectPanel();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // Régua de calibração de moldura — ativa com ?ruler=1
  // Mostra grid 5%/25% sobre o stage, deixa arrastar a moldura com mouse,
  // redimensionar via handle BR, e copiar os valores pra mim aplicar via magick.
  function setupRuler() {
    var params = new URLSearchParams(location.search);
    if (!params.has('ruler')) return;
    var STORAGE = 'jun26-ruler-state';
    function getState() {
      try { return JSON.parse(localStorage.getItem(STORAGE) || '{}'); }
      catch (e) { return {}; }
    }
    // Converte translate em px pra % do stage (pra ser viewport-agnostic)
    function pxToPct(translateStr) {
      var stage = document.querySelector('.pp26__perspective-stage');
      if (!stage) return translateStr || '0% 0%';
      var sw = stage.offsetWidth || 1;
      var sh = stage.offsetHeight || 1;
      var parts = (translateStr || '0px 0px').trim().split(/\s+/);
      var x = parseFloat(parts[0]) || 0;
      var y = parseFloat(parts[1]) || 0;
      // Se já está em %, mantém
      if ((parts[0] || '').indexOf('%') > -1) return parts.join(' ');
      return (x / sw * 100).toFixed(3) + '% ' + (y / sh * 100).toFixed(3) + '%';
    }
    // Converte % de volta pra px ao restaurar
    function pctToPx(translateStr) {
      var stage = document.querySelector('.pp26__perspective-stage');
      if (!stage) return translateStr || '0px 0px';
      var sw = stage.offsetWidth || 1;
      var sh = stage.offsetHeight || 1;
      var parts = (translateStr || '0% 0%').trim().split(/\s+/);
      var raw0 = parts[0] || '0';
      var raw1 = parts[1] || '0';
      var x, y;
      if (raw0.indexOf('%') > -1) x = parseFloat(raw0) / 100 * sw;
      else x = parseFloat(raw0) || 0;
      if (raw1.indexOf('%') > -1) y = parseFloat(raw1) / 100 * sh;
      else y = parseFloat(raw1) || 0;
      return Math.round(x) + 'px ' + Math.round(y) + 'px';
    }
    function setStateVal(k, v) {
      var s = getState(); s[k] = v;
      localStorage.setItem(STORAGE, JSON.stringify(s));
    }
    // Torna painel arrastável pelo header. Persiste posição em localStorage
    // por chave única (ex: 'panel-ruler', 'panel-tree').
    function makeDraggable(panel, headerEl, storageKey) {
      // Restaura posição salva
      var st = getState();
      var pos = st.panelPos && st.panelPos[storageKey];
      if (pos) {
        panel.style.top = pos.top + 'px';
        panel.style.left = pos.left + 'px';
        panel.style.right = 'auto';
      }
      headerEl.style.cursor = 'move';
      headerEl.style.userSelect = 'none';
      var dragging = false, sx, sy, sLeft, sTop;
      headerEl.addEventListener('mousedown', function (e) {
        // Não inicia drag se clicar num botão dentro do header
        if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
        dragging = true;
        sx = e.clientX; sy = e.clientY;
        var rect = panel.getBoundingClientRect();
        sLeft = rect.left; sTop = rect.top;
        // Cleanup right/bottom pra usar só left/top
        panel.style.right = 'auto';
        panel.style.bottom = 'auto';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var nLeft = sLeft + (e.clientX - sx);
        var nTop = sTop + (e.clientY - sy);
        // Clamp dentro da viewport
        nLeft = Math.max(0, Math.min(window.innerWidth - 100, nLeft));
        nTop = Math.max(0, Math.min(window.innerHeight - 50, nTop));
        panel.style.left = nLeft + 'px';
        panel.style.top = nTop + 'px';
      });
      document.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        var st = getState();
        st.panelPos = st.panelPos || {};
        st.panelPos[storageKey] = {
          top: parseInt(panel.style.top, 10),
          left: parseInt(panel.style.left, 10)
        };
        localStorage.setItem(STORAGE, JSON.stringify(st));
      });
    }
    function attempt() {
      var stage = document.querySelector('.pp26__perspective-stage');
      var frame = stage && stage.querySelector('.pp26__frame');
      var art = stage && stage.querySelector('.pp26__art');
      if (!stage || !frame || !art) { setTimeout(attempt, 200); return; }
      injectGrid(stage);
      injectFrameInteractions(stage, frame);
      injectArtWarpHandles(stage, art);
      injectPanel(stage, art);
      hookJun26Checkboxes(frame);
    }

    // Hook nos checkboxes (+ profundidade / + fino / + paspatur) e pills
    // do jun26.js: quando resolver pra variant que o Shopify oculta
    // (slim, slim-com-paspatur, caixa-com-paspatur), simula frame.src direto.
    function hookJun26Checkboxes(frame) { return setupHiddenVariantSim(frame); }

    // Calcula matrix3d que mapeia o retângulo (0,0)-(w,0)-(w,h)-(0,h)
    // aos 4 pontos dst[0..3]. Algoritmo Heckbert (projective mapping).
    function computeMatrix3d(w, h, dst) {
      function sysSolve(A, b) {
        // Gaussian elimination 8x8
        var n = 8;
        for (var i = 0; i < n; i++) {
          var maxRow = i;
          for (var k = i + 1; k < n; k++) if (Math.abs(A[k][i]) > Math.abs(A[maxRow][i])) maxRow = k;
          var tmp = A[i]; A[i] = A[maxRow]; A[maxRow] = tmp;
          var tb = b[i]; b[i] = b[maxRow]; b[maxRow] = tb;
          for (var k2 = i + 1; k2 < n; k2++) {
            var f = A[k2][i] / A[i][i];
            for (var j = i; j < n; j++) A[k2][j] -= f * A[i][j];
            b[k2] -= f * b[i];
          }
        }
        var x = new Array(n);
        for (var i2 = n - 1; i2 >= 0; i2--) {
          var s = b[i2];
          for (var j2 = i2 + 1; j2 < n; j2++) s -= A[i2][j2] * x[j2];
          x[i2] = s / A[i2][i2];
        }
        return x;
      }
      var srcs = [[0, 0], [w, 0], [w, h], [0, h]];
      var A = [], b = [];
      for (var i = 0; i < 4; i++) {
        var sx = srcs[i][0], sy = srcs[i][1], dx = dst[i][0], dy = dst[i][1];
        A.push([sx, sy, 1, 0, 0, 0, -sx * dx, -sy * dx]);
        b.push(dx);
        A.push([0, 0, 0, sx, sy, 1, -sx * dy, -sy * dy]);
        b.push(dy);
      }
      var p = sysSolve(A, b);
      // p = [a, b, c, d, e, f, g, h] da matriz 3x3 [[a,b,c],[d,e,f],[g,h,1]]
      // Converte pra matrix3d 4x4 (CSS column-major): rotação/translação 2D no plano XY, perspectiva via Z
      return [
        p[0], p[3], 0, p[6],
        p[1], p[4], 0, p[7],
        0,    0,    1, 0,
        p[2], p[5], 0, 1
      ];
    }

    function applyWarp(art, corners) {
      // corners: [TL, TR, BR, BL] cada um [x, y] em pixels relativos ao stage
      // object-fit fill: estica a imagem PRA preencher exatamente o box. Sem
      // isso, 'cover' corta partes pra manter aspect ratio.
      art.style.objectFit = 'fill';
      var w = art.offsetWidth || 100;
      var h = art.offsetHeight || 100;
      var m = computeMatrix3d(w, h, corners);
      art.style.transformOrigin = '0 0';
      art.style.transform = 'matrix3d(' + m.join(',') + ')';
      art.style.position = 'absolute';
      art.style.left = '0';
      art.style.top = '0';
    }

    function injectArtWarpHandles(stage, art) {
      // Detecta orient via <pp26-gallery data-orientation> (fonte oficial).
      // Antes lia stage.style.aspectRatio === '1.4 / 1' mas o pp26-gallery seta
      // aspect como '1600 / 1260' (números reais), então sempre caía em 'vertical'.
      var orient = (function () {
        var gal = document.querySelector('pp26-gallery');
        return (gal && gal.dataset.orientation) || 'vertical';
      })();
      var frameEl = stage.querySelector('.pp26__frame');
      function currentType() { return (frameEl && frameEl.dataset.frameType) || 'canvas'; }
      function warpKey(type) { return orient + '|' + (type || currentType()); }
      function loadWarp() {
        var st = getState();
        var byType = st.warpByOrientType || {};
        // Tenta warp específico do type, depois canvas (warp "base"), depois localStorage legacy
        var w = byType[warpKey()];
        if (w && w.length === 4) return w;
        w = byType[orient + '|canvas'];
        if (w && w.length === 4) return w;
        // Migração do localStorage antigo (warpByOrient)
        if (st.warpByOrient && st.warpByOrient[orient] && st.warpByOrient[orient].length === 4) {
          return st.warpByOrient[orient];
        }
        // Default
        return [
          [stage.offsetWidth * 0.05, stage.offsetHeight * 0.05],
          [stage.offsetWidth * 0.95, stage.offsetHeight * 0.05],
          [stage.offsetWidth * 0.95, stage.offsetHeight * 0.95],
          [stage.offsetWidth * 0.05, stage.offsetHeight * 0.95]
        ];
      }
      var corners = loadWarp();
      function saveWarp() {
        // Guard: não salva se corners estão zerados (boot inicial com stage ainda
        // sem dimensão). Antes, o salvamento sem guard gravava [[0,0],[0,0],[0,0],[0,0]]
        // em warpByOrientType, sobrescrevendo warp real ao trocar de produto.
        var allZero = corners.every(function (c) { return (c[0]||0) === 0 && (c[1]||0) === 0; });
        if (allZero) return;
        var st = getState();
        st.warpByOrientType = st.warpByOrientType || {};
        st.warpByOrientType[warpKey()] = corners;
        localStorage.setItem(STORAGE, JSON.stringify(st));
      }
      // Reload corners quando trocar de acabamento
      window.__rl_warp_reloadForType = function () {
        corners = loadWarp();
        applyWarp(art, corners);
        if (typeof positionAllHandles === 'function') positionAllHandles();
        if (window.__rl_updatePanel) window.__rl_updatePanel();
      };
      // 4 handles draggable — cria PRIMEIRO antes do refresh
      var labels = ['TL', 'TR', 'BR', 'BL'];
      var handles = [];
      function refresh() {
        applyWarp(art, corners);
        if (handles.length === 4) positionAllHandles();
        if (window.__rl_updatePanel) window.__rl_updatePanel();
      }
      // Expõe globalmente pra reaplicar quando variant muda
      window.__rl_reapplyArtWarp = function () { applyWarp(art, corners); };
      for (var i = 0; i < 4; i++) {
        (function (idx) {
          var h = document.createElement('div');
          h.className = 'jun26-warp-handle';
          h.textContent = labels[idx];
          h.dataset.idx = idx;
          h.style.cssText = 'position:absolute;width:12px;height:12px;background:#7c3aed;cursor:move;z-index:80;border:1.5px solid #fff;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.4);user-select:none';
          h.title = labels[idx];
          h.textContent = '';
          stage.appendChild(h);
          var dragging = false, sx, sy, scx, scy;
          h.addEventListener('mousedown', function (e) {
            dragging = true; sx = e.clientX; sy = e.clientY;
            scx = corners[idx][0]; scy = corners[idx][1];
            e.preventDefault(); e.stopPropagation();
          });
          document.addEventListener('mousemove', function (e) {
            if (!dragging) return;
            corners[idx] = [scx + (e.clientX - sx), scy + (e.clientY - sy)];
            refresh();
          });
          document.addEventListener('mouseup', function () { if (dragging) { dragging = false; saveWarp(); } });
          handles.push(h);
        })(i);
      }
      function positionAllHandles() {
        for (var i = 0; i < 4; i++) {
          if (!handles[i]) continue;
          handles[i].style.left = (corners[i][0] - 6) + 'px';
          handles[i].style.top = (corners[i][1] - 6) + 'px';
        }
      }
      // Refresh inicial — espera arte ter dimensão antes de aplicar warp.
      function safeRefresh(tries) {
        tries = tries || 0;
        if ((art.offsetWidth > 0 && art.offsetHeight > 0) || tries > 30) {
          refresh();
          // Reaplica mais vezes nos primeiros segundos pra ganhar de pp26-gallery
          // que sobrescreve transform com seu próprio matrix3d na carga inicial.
          setTimeout(refresh, 200);
          setTimeout(refresh, 600);
          setTimeout(refresh, 1200);
        } else {
          setTimeout(function () { safeRefresh(tries + 1); }, 50);
        }
      }
      safeRefresh();
      art.addEventListener('load', function () { setTimeout(refresh, 30); });

      // MutationObserver no art: se pp26-gallery mudar transform/objectFit,
      // reaplica nosso warp. Debounce 50ms pra não loop.
      var artReapplyTimer = null;
      var lastAppliedTransform = '';
      new MutationObserver(function () {
        var cur = art.style.transform || '';
        if (cur === lastAppliedTransform) return; // foi nosso próprio update
        if (artReapplyTimer) clearTimeout(artReapplyTimer);
        artReapplyTimer = setTimeout(function () {
          applyWarp(art, corners);
          lastAppliedTransform = art.style.transform;
        }, 50);
      }).observe(art, { attributes: true, attributeFilter: ['style'] });
      // Mostra/esconde handles via funções globais (chamadas pelo painel)
      window.__rl_warp_setMode = function (mode) {
        handles.forEach(function (h) { h.style.display = mode === 'warp' ? '' : 'none'; });
      };
      window.__rl_warp_reset = function () {
        corners = [
          [stage.offsetWidth * 0.10, stage.offsetHeight * 0.10],
          [stage.offsetWidth * 0.90, stage.offsetHeight * 0.10],
          [stage.offsetWidth * 0.90, stage.offsetHeight * 0.90],
          [stage.offsetWidth * 0.10, stage.offsetHeight * 0.90]
        ];
        saveWarp(); refresh();
      };
      window.__rl_warp_getCorners = function () {
        return {
          orient: orient,
          type: currentType(),
          cornersPx: corners.map(function (c) { return [Math.round(c[0]), Math.round(c[1])]; }),
          cornersPct: corners.map(function (c) {
            return [+(c[0] / stage.offsetWidth * 100).toFixed(2), +(c[1] / stage.offsetHeight * 100).toFixed(2)];
          })
        };
      };
      // Força salvar (botão APROVAR chama isso pra garantir)
      window.__rl_warp_save = function () { saveWarp(); };
      // Modo inicial = warp
      window.__rl_warp_setMode('warp');
    }
    function injectGrid(stage) {
      if (document.getElementById('jun26-grid')) return;
      var grid = document.createElement('div');
      grid.id = 'jun26-grid';
      grid.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:50;' +
        'background-image:' +
          'linear-gradient(to right, rgba(255,0,0,.10) 1px, transparent 1px),' +
          'linear-gradient(to bottom, rgba(255,0,0,.10) 1px, transparent 1px);' +
        'background-size:5% 5%';
      stage.style.position = stage.style.position || 'relative';
      stage.appendChild(grid);
      // Eixos 25/50/75 mais grossos
      [25, 50, 75].forEach(function (p) {
        var v = document.createElement('div');
        v.style.cssText = 'position:absolute;top:0;bottom:0;left:' + p + '%;width:1px;background:rgba(255,0,0,.3);pointer-events:none;z-index:51';
        stage.appendChild(v);
        var h = document.createElement('div');
        h.style.cssText = 'position:absolute;left:0;right:0;top:' + p + '%;height:1px;background:rgba(255,0,0,.3);pointer-events:none;z-index:51';
        stage.appendChild(h);
      });
    }
    // Ordem das combinações pra navegação guiada — nomes longos batem com
    // os webp subidos no Files (jun26-{ori}-padrao-com-paspatur-{cor}.webp)
    var TYPES_ORDER = ['canvas', 'padrao', 'padrao-com-paspatur', 'caixa', 'caixa-com-paspatur', 'slim', 'slim-com-paspatur', 'sem-moldura'];
    var CORES_ORDER = ['mel', 'preta', 'pinus', 'branca'];
    // Map cor interna → Option Value Shopify
    var COR_VALUE = { mel: 'madeira escura', preta: 'preta', pinus: 'madeira clara', branca: 'branca' };
    var TYPE_VALUE = {
      'canvas': 'canvas',
      'padrao': 'padrão',
      'paspatur': 'padrão com paspatur',
      'caixa': 'caixa',
      'caixa-paspatur': 'caixa com paspatur',
      'slim': 'slim',
      'slim-paspatur': 'slim com paspatur',
      'sem-moldura': 'sem moldura'
    };
    function comboIndex(type, cor) {
      var ti = TYPES_ORDER.indexOf(type);
      var ci = CORES_ORDER.indexOf(cor);
      if (ti < 0 || ci < 0) return -1;
      return ti * CORES_ORDER.length + ci;
    }
    function goToCombo(idx) {
      idx = ((idx % (TYPES_ORDER.length * CORES_ORDER.length)) +
             (TYPES_ORDER.length * CORES_ORDER.length)) %
            (TYPES_ORDER.length * CORES_ORDER.length);
      var ti = Math.floor(idx / CORES_ORDER.length);
      var ci = idx % CORES_ORDER.length;
      var type = TYPES_ORDER[ti];
      var cor = CORES_ORDER[ci];
      // sem-moldura: 1 webp único (cor virtual = 'default'). Aplica direto pelo
      // gallery sem mexer em radios (evita conflito com variant change real).
      if (type === 'sem-moldura') {
        var gal = document.querySelector('pp26-gallery');
        if (gal && typeof gal.updateFrame === 'function') {
          gal.updateFrame('sem-moldura', 'default');
        }
        return;
      }
      var typeValue = TYPE_VALUE[type];
      var corValue = COR_VALUE[cor];
      var molFs = document.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
      var corFs = document.querySelector('[data-handle="escolha-a-cor-da-moldura"]');
      var molInput = molFs && molFs.querySelector('input[value="' + typeValue + '"]');
      var corInput = corFs && corFs.querySelector('input[value="' + corValue + '"]');
      if (molInput && corInput) {
        molInput.checked = true; molInput.dispatchEvent(new Event('change', { bubbles: true }));
        var applyCor = function () {
          if (!corInput.checked) {
            corInput.checked = true;
            corInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        setTimeout(applyCor, 250);
        setTimeout(applyCor, 500);
        setTimeout(applyCor, 800);
        return;
      }
      // Variant não tem radio renderizado (Shopify oculta quando todas dela
      // estão deny+qty=0). Simula trocando frame.src direto + data attrs.
      var frame = document.querySelector('.pp26__frame');
      if (!frame) {
        console.warn('[jun26 ruler] Frame não encontrado pra simular', type, cor);
        return;
      }
      var baseMatch = frame.src.match(/(.+\/)jun26-[^/]+\.webp/);
      if (!baseMatch) {
        console.warn('[jun26 ruler] Não foi possível extrair base path pra simular');
        return;
      }
      var basePath = baseMatch[1];
      // Orientação real do produto: lê do <pp26-gallery data-orientation>.
      // Antes estava hardcoded como 'vertical', fazendo slim/slim-com-paspatur/
      // caixa-com-paspatur carregarem moldura vertical em produtos horizontais/quadrados.
      var gal = document.querySelector('pp26-gallery');
      var orient = (gal && gal.dataset.orientation) || 'vertical';
      var simSrc = basePath + 'jun26-' + orient + '-' + type + '-' + cor + '.webp';
      frame.src = simSrc;
      frame.dataset.frameType = type;
      frame.dataset.frameColor = cor;
      frame.removeAttribute('hidden');
      console.log('[jun26 ruler] Simulando variant oculta:', type, '/', cor, '→', simSrc);
    }

    function injectFrameInteractions(stage, frame) {
      frame.style.cursor = 'move';
      frame.style.zIndex = '60';
      frame.style.userSelect = 'none';
      frame.style.pointerEvents = 'auto';

      // Marcadores azuis dos cantos do warp aprovado (referência visual no modo POSIÇÃO)
      var warpRefs = [];
      for (var wi = 0; wi < 4; wi++) {
        var r = document.createElement('div');
        r.style.cssText = 'position:absolute;width:16px;height:16px;border:3px solid #3b82f6;border-radius:50%;pointer-events:none;z-index:85;display:none;background:rgba(255,255,255,.9);box-shadow:0 2px 6px rgba(0,0,0,.4)';
        stage.appendChild(r);
        warpRefs.push(r);
      }
      window.__rl_showWarpRefs = function (show) {
        var st = getState();
        var orient = (function () {
          var gal = document.querySelector('pp26-gallery');
          return (gal && gal.dataset.orientation) || 'vertical';
        })();
        var w = st.warpByOrient && st.warpByOrient[orient];
        if (show && w && w.length === 4) {
          for (var i = 0; i < 4; i++) {
            warpRefs[i].style.display = '';
            warpRefs[i].style.left = (w[i][0] - 8) + 'px';
            warpRefs[i].style.top = (w[i][1] - 8) + 'px';
          }
        } else {
          warpRefs.forEach(function (r) { r.style.display = 'none'; });
        }
      };

      // Restaura último ajuste pra essa combinação
      function key() { return (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?'); }
      function restoreIfApproved() {
        var st = getState();
        var ap = st.approved && st.approved[key()];
        if (ap) {
          // ap.translate vem em % (salvo viewport-agnostic) — converte pra px
          frame.style.translate = pctToPx(ap.translate || '0% 0%');
          frame.style.width = ap.width || '';
          frame.style.height = ap.height || '';
        }
      }
      restoreIfApproved();

      // Drag (mover) — só no modo POSIÇÃO. No WARP a moldura fica travada.
      var dragging = false, sx, sy, stx, sty;
      frame.addEventListener('mousedown', function (e) {
        if (window.__rl_currentMode !== 'pos') return;
        if (e.target.classList && e.target.classList.contains('jun26-resize-handle')) return;
        dragging = true;
        sx = e.clientX; sy = e.clientY;
        var t = (frame.style.translate || '0px 0px').split(' ');
        stx = parseFloat(t[0]) || 0;
        sty = parseFloat(t[1]) || 0;
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) {
          frame.style.translate = (stx + (e.clientX - sx)) + 'px ' + (sty + (e.clientY - sy)) + 'px';
          updatePanel();
        }
      });
      document.addEventListener('mouseup', function () {
        if (dragging) { dragging = false; }
      });

      // Handle de resize (canto BR) — posiciona via wrapper absoluto
      var handle = document.createElement('div');
      handle.className = 'jun26-resize-handle';
      handle.style.cssText = 'position:absolute;width:14px;height:14px;background:#7c3aed;border:2px solid #fff;cursor:nwse-resize;z-index:70;pointer-events:auto;box-shadow:0 1px 4px rgba(0,0,0,.3)';
      stage.appendChild(handle);
      function positionHandle() {
        var fr = frame.getBoundingClientRect();
        var sr = stage.getBoundingClientRect();
        handle.style.left = (fr.right - sr.left - 7) + 'px';
        handle.style.top = (fr.bottom - sr.top - 7) + 'px';
      }
      positionHandle();
      window.addEventListener('resize', positionHandle);
      new MutationObserver(positionHandle).observe(frame, { attributes: true, attributeFilter: ['style', 'src'] });
      var resizing = false, rsx, rsy, rsw, rsh;
      handle.addEventListener('mousedown', function (e) {
        if (window.__rl_currentMode !== 'pos') return;
        resizing = true;
        rsx = e.clientX; rsy = e.clientY;
        rsw = frame.offsetWidth; rsh = frame.offsetHeight;
        e.stopPropagation(); e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (resizing) {
          frame.style.width = Math.max(50, rsw + (e.clientX - rsx)) + 'px';
          frame.style.height = Math.max(50, rsh + (e.clientY - rsy)) + 'px';
          positionHandle();
          updatePanel();
        }
      });
      document.addEventListener('mouseup', function () { if (resizing) resizing = false; });

      // Re-aplica restore quando frame.src trocar (variant mudou)
      new MutationObserver(function () {
        // limpa antes
        frame.style.translate = '';
        frame.style.width = '';
        frame.style.height = '';
        setTimeout(function () {
          restoreIfApproved();
          // Warp por acabamento: recarrega corners do novo type
          if (window.__rl_warp_reloadForType) window.__rl_warp_reloadForType();
          else if (window.__rl_reapplyArtWarp) window.__rl_reapplyArtWarp();
          // Reaplica os marcadores azuis do warp só se está no modo pos
          if (window.__rl_currentMode === 'pos' && window.__rl_showWarpRefs) {
            window.__rl_showWarpRefs(true);
          }
          // Ressincroniza sliders/inputs com o estado da nova cor.
          // Sem isso, sliders mostram valores da cor anterior e qualquer ajuste
          // do usuário aplica esses valores na cor errada.
          if (window.__rl_syncSliders) window.__rl_syncSliders();
        }, 80);
        setTimeout(updatePanel, 150);
      }).observe(frame, { attributes: true, attributeFilter: ['src', 'data-frame-type', 'data-frame-color'] });
    }
    function injectPanel(stage, art) {
      var frame = stage.querySelector('.pp26__frame');
      var panel = document.createElement('div');
      panel.id = 'jun26-ruler-panel';
      panel.style.cssText = 'position:fixed;top:80px;right:20px;background:#fff;border:1px solid #111;padding:16px;z-index:9999;font:12px Archivo,system-ui,sans-serif;width:320px;box-shadow:0 8px 24px rgba(0,0,0,.15)';
      panel.innerHTML = ''
        + '<div id="rl-header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;font-weight:600;letter-spacing:.05em;text-transform:uppercase">'
        + '<span>Régua</span>'
        + '<span style="display:flex;gap:2px">'
        + '<button id="rl-min" style="width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:16px Archivo;color:#999;padding:0;line-height:1" title="minimizar">−</button>'
        + '<button id="rl-close" style="width:24px;height:24px;background:transparent;border:none;cursor:pointer;font:14px Archivo;color:#999;padding:0;line-height:1" title="fechar">×</button>'
        + '</span>'
        + '</div>'
        + '<div style="display:flex;gap:0;margin-bottom:12px;border:1px solid #d4d4d8">'
        + '<button id="rl-mode-warp" style="flex:1;padding:8px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600">WARP DA ARTE</button>'
        + '<button id="rl-mode-pos" style="flex:1;padding:8px;background:#fff;color:#111;border:none;cursor:pointer;font:11px Archivo">POSIÇÃO MOLDURA</button>'
        + '</div>'
        + '<div id="rl-status" style="font-size:11px;color:#666;margin-bottom:8px"></div>'
        + '<div id="rl-pos-sliders" style="display:none;margin-bottom:10px;padding:8px;background:#faf5ff;border:1px solid #e9d5ff;font-size:11px">'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="negativo = esquerda, positivo = direita">←→</label><input id="rl-sl-x" type="range" min="-200" max="200" value="0" style="flex:1"><input id="rl-sl-x-v" type="number" value="0" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">px</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="negativo = cima, positivo = baixo">↑↓</label><input id="rl-sl-y" type="range" min="-200" max="200" value="0" style="flex:1"><input id="rl-sl-y-v" type="number" value="0" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">px</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><label style="width:50px" title="largura">W</label><input id="rl-sl-w" type="range" min="50" max="200" value="100" style="flex:1"><input id="rl-sl-w-v" type="number" value="100" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">%</span></div>'
        + '  <div style="display:flex;align-items:center;gap:6px"><label style="width:50px" title="altura">H</label><input id="rl-sl-h" type="range" min="50" max="200" value="100" style="flex:1"><input id="rl-sl-h-v" type="number" value="100" style="width:54px;text-align:right;font-family:monospace;border:1px solid #d4d4d8;padding:2px 4px;font-size:11px"><span style="width:14px;color:#888;font-size:10px">%</span></div>'
        + '</div>'
        + '<div id="rl-values" style="font-family:monospace;font-size:10px;background:#f4f4f5;padding:6px;margin-bottom:10px;word-break:break-all;max-height:80px;overflow:auto"></div>'
        + '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">'
        + '<button id="rl-save" style="padding:8px 14px;background:#22c55e;color:#fff;border:none;cursor:pointer;font:12px Archivo;font-weight:600;pointer-events:auto;display:none">SALVAR</button>'
        + '<button id="rl-replicate" style="padding:8px 12px;background:#0ea5e9;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto;display:none" title="copia translate + width + height da última cor salva deste mesmo tipo (ex: padrao/mel → padrao/preta)">📋 REPLICAR</button>'
        + '<button id="rl-prev" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto;display:none">←</button>'
        + '<button id="rl-next" style="padding:6px 10px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto;display:none">→</button>'
        + '<button id="rl-reset" style="padding:6px 10px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto">RESET</button>'
        + '<button id="rl-hide-art" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="esconde a arte pra ver só a moldura">OCULTAR ARTE</button>'
        + '<button id="rl-add-vline" style="padding:6px 8px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="adiciona régua vertical">| RÉGUA V</button>'
        + '<button id="rl-add-hline" style="padding:6px 8px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="adiciona régua horizontal">— RÉGUA H</button>'
        + '<button id="rl-layers" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="mostra todas as molduras salvas sobrepostas pra comparar">CAMADAS</button>'
        + '<button id="rl-checkcolors" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;pointer-events:auto" title="amostra a cor média de cada moldura e compara com a esperada">VERIFICAR CORES</button>'
        + '<button id="rl-export" style="padding:6px 10px;background:#7c3aed;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="gera JSON pra commitar no tema (cliente final vê)">⬇ EXPORTAR PRO TEMA</button>'
        + '<button id="rl-save-orient" style="padding:6px 10px;background:#0ea5e9;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="baixa um .json com só esta orientação (vertical/horizontal/quadrado)">💾 SALVAR ORIENT</button>'
        + '<button id="rl-load-orient" style="padding:6px 10px;background:#fff;color:#111;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto" title="importa um .json salvo — NÃO sobrescreve as outras orientações nem o panelPos">📂 IMPORTAR</button>'
        + '<button id="rl-simulate" style="padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo;pointer-events:auto">SIMULAR</button>'
        + '<button id="rl-copy" style="padding:4px 8px;background:transparent;color:#999;border:1px solid #e4e4e7;cursor:pointer;font:10px Archivo;pointer-events:auto">copy</button>'
        + '<button id="rl-approve" style="padding:6px 10px;background:#22c55e;color:#fff;border:none;cursor:pointer;font:11px Archivo;font-weight:600;pointer-events:auto">SALVAR</button>'
        + '</div>';
      document.body.appendChild(panel);
      // Wrappa todo o corpo (do index 1 em diante; index 0 é #rl-header)
      // num único container pra o minimize ser robusto.
      var bodyWrap = document.createElement('div');
      bodyWrap.id = 'rl-body-wrap';
      var children = Array.from(panel.children);
      children.slice(1).forEach(function (c) { bodyWrap.appendChild(c); });
      panel.appendChild(bodyWrap);

      // Drag pelo header
      makeDraggable(panel, panel.querySelector('#rl-header'), 'ruler');

      var minimized = false;
      panel.querySelector('#rl-min').onclick = function () {
        minimized = !minimized;
        bodyWrap.style.display = minimized ? 'none' : '';
        panel.style.width = minimized ? 'auto' : '320px';
        panel.style.padding = minimized ? '10px 16px' : '16px';
        panel.querySelector('#rl-min').textContent = minimized ? '+' : '−';
        panel.querySelector('#rl-min').title = minimized ? 'expandir' : 'minimizar';
      };
      panel.querySelector('#rl-close').onclick = function () {
        panel.style.display = 'none';
        var open = document.createElement('button');
        open.textContent = 'RÉGUA';
        open.style.cssText = 'position:fixed;top:80px;right:20px;padding:6px 10px;background:#111;color:#fff;border:none;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:9999';
        document.body.appendChild(open);
        open.onclick = function () { panel.style.display = ''; open.remove(); };
      };
      var mode = 'warp';
      function setMode(m) {
        mode = m;
        window.__rl_currentMode = m;
        if (window.__rl_warp_setMode) window.__rl_warp_setMode(m);
        if (window.__rl_showWarpRefs) window.__rl_showWarpRefs(m === 'pos');
        panel.querySelector('#rl-mode-warp').style.background = m === 'warp' ? '#7c3aed' : '#fff';
        panel.querySelector('#rl-mode-warp').style.color = m === 'warp' ? '#fff' : '#111';
        panel.querySelector('#rl-mode-pos').style.background = m === 'pos' ? '#7c3aed' : '#fff';
        panel.querySelector('#rl-mode-pos').style.color = m === 'pos' ? '#fff' : '#111';
        var nextBtn = panel.querySelector('#rl-next');
        var prevBtn = panel.querySelector('#rl-prev');
        var saveBtn = panel.querySelector('#rl-save');
        var replicateBtn = panel.querySelector('#rl-replicate');
        var approveBtn = panel.querySelector('#rl-approve');
        if (nextBtn) nextBtn.style.display = m === 'pos' ? '' : 'none';
        if (prevBtn) prevBtn.style.display = m === 'pos' ? '' : 'none';
        if (saveBtn) saveBtn.style.display = m === 'pos' ? '' : 'none';
        if (replicateBtn) replicateBtn.style.display = m === 'pos' ? '' : 'none';
        if (approveBtn) approveBtn.style.display = m === 'warp' ? '' : 'none';
        var sliders = panel.querySelector('#rl-pos-sliders');
        if (sliders) sliders.style.display = m === 'pos' ? '' : 'none';
        // Trava/destrava cursor + resize handle da moldura
        frame.style.cursor = m === 'pos' ? 'move' : 'default';
        document.querySelectorAll('.jun26-resize-handle').forEach(function (h) {
          h.style.display = m === 'pos' ? '' : 'none';
        });
        // Inicializa sliders com valores atuais
        if (m === 'pos') syncSlidersFromFrame();
        updatePanel();
      }

      function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
      function applyFromValues(x, y, w, h) {
        x = clamp(Math.round(x), -200, 200);
        y = clamp(Math.round(y), -200, 200);
        w = clamp(Math.round(w), 50, 200);
        h = clamp(Math.round(h), 50, 200);
        panel.querySelector('#rl-sl-x').value = x;
        panel.querySelector('#rl-sl-y').value = y;
        panel.querySelector('#rl-sl-w').value = w;
        panel.querySelector('#rl-sl-h').value = h;
        panel.querySelector('#rl-sl-x-v').value = x;
        panel.querySelector('#rl-sl-y-v').value = y;
        panel.querySelector('#rl-sl-w-v').value = w;
        panel.querySelector('#rl-sl-h-v').value = h;
        frame.style.translate = x + 'px ' + y + 'px';
        frame.style.width = (w === 100 ? '' : w + '%');
        frame.style.height = (h === 100 ? '' : h + '%');
        updatePanel();
      }
      function applySliders() {
        applyFromValues(
          panel.querySelector('#rl-sl-x').value,
          panel.querySelector('#rl-sl-y').value,
          panel.querySelector('#rl-sl-w').value,
          panel.querySelector('#rl-sl-h').value
        );
      }
      function applyInputs() {
        applyFromValues(
          panel.querySelector('#rl-sl-x-v').value,
          panel.querySelector('#rl-sl-y-v').value,
          panel.querySelector('#rl-sl-w-v').value,
          panel.querySelector('#rl-sl-h-v').value
        );
      }
      function syncSlidersFromFrame() {
        var t = (frame.style.translate || '0px 0px').split(' ');
        var x = Math.round(parseFloat(t[0]) || 0);
        var y = Math.round(parseFloat(t[1]) || 0);
        var w = Math.round(parseFloat(frame.style.width) || 100);
        var h = Math.round(parseFloat(frame.style.height) || 100);
        panel.querySelector('#rl-sl-x').value = x;
        panel.querySelector('#rl-sl-y').value = y;
        panel.querySelector('#rl-sl-w').value = w;
        panel.querySelector('#rl-sl-h').value = h;
        panel.querySelector('#rl-sl-x-v').value = x;
        panel.querySelector('#rl-sl-y-v').value = y;
        panel.querySelector('#rl-sl-w-v').value = w;
        panel.querySelector('#rl-sl-h-v').value = h;
      }
      // Expõe pra que o MutationObserver (em injectFrameInteractions, outro escopo)
      // possa ressincronizar sliders quando o usuário troca de cor/tipo. Sem isso,
      // os sliders ficam mostrando valores da cor anterior e qualquer ajuste do
      // usuário aplica esses valores em cima da cor nova.
      window.__rl_syncSliders = syncSlidersFromFrame;
      ['rl-sl-x', 'rl-sl-y', 'rl-sl-w', 'rl-sl-h'].forEach(function (id) {
        panel.querySelector('#' + id).addEventListener('input', applySliders);
      });
      ['rl-sl-x-v', 'rl-sl-y-v', 'rl-sl-w-v', 'rl-sl-h-v'].forEach(function (id) {
        panel.querySelector('#' + id).addEventListener('input', applyInputs);
        panel.querySelector('#' + id).addEventListener('change', applyInputs);
      });

      // Atalhos de teclado: setas movem 1px, Shift+seta move 10px
      document.addEventListener('keydown', function (e) {
        if (mode !== 'pos') return;
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
        var step = e.shiftKey ? 10 : 1;
        var dx = 0, dy = 0;
        if (e.key === 'ArrowLeft') dx = -step;
        else if (e.key === 'ArrowRight') dx = step;
        else if (e.key === 'ArrowUp') dy = -step;
        else if (e.key === 'ArrowDown') dy = step;
        else return;
        e.preventDefault();
        var sx = panel.querySelector('#rl-sl-x');
        var sy = panel.querySelector('#rl-sl-y');
        sx.value = parseInt(sx.value, 10) + dx;
        sy.value = parseInt(sy.value, 10) + dy;
        applySliders();
      });
      panel.querySelector('#rl-mode-warp').onclick = function () { setMode('warp'); };
      panel.querySelector('#rl-mode-pos').onclick = function () { setMode('pos'); };

      panel.querySelector('#rl-reset').onclick = function () {
        if (mode === 'warp') {
          if (window.__rl_warp_reset) window.__rl_warp_reset();
        } else {
          frame.style.translate = ''; frame.style.width = ''; frame.style.height = '';
        }
        updatePanel();
      };
      panel.querySelector('#rl-copy').onclick = function () {
        var data;
        if (mode === 'warp') {
          data = window.__rl_warp_getCorners ? window.__rl_warp_getCorners() : {};
        } else {
          data = {
            type: frame.dataset.frameType,
            cor: frame.dataset.frameColor,
            translate: pxToPct(frame.style.translate),
            width: frame.style.width || 'auto',
            height: frame.style.height || 'auto'
          };
        }
        var txt = JSON.stringify(data, null, 2);
        if (navigator.clipboard) navigator.clipboard.writeText(txt);
        panel.querySelector('#rl-values').textContent = txt + '\n\n(copiado)';
      };
      panel.querySelector('#rl-approve').onclick = function () {
        var st = getState();
        if (mode === 'warp') {
          // Força salvar (mesmo já estando salvo via drag) + muda pra POSIÇÃO
          if (window.__rl_warp_save) window.__rl_warp_save();
          panel.querySelector('#rl-status').innerHTML = '<b style="color:#22c55e">✓ warp salvo · indo pra POSIÇÃO MOLDURA…</b>';
          setTimeout(function () { setMode('pos'); }, 300);
        } else {
          st.approved = st.approved || {};
          var k = (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?');
          st.approved[k] = {
            translate: pxToPct(frame.style.translate),
            width: frame.style.width || 'auto',
            height: frame.style.height || 'auto'
          };
          localStorage.setItem(STORAGE, JSON.stringify(st));
        }
        updatePanel();
      };
      panel.querySelector('#rl-save').onclick = function () {
        // Sempre salva, mesmo se o estado bater com o já salvo (útil pra
        // confirmar a cor atual após REPLICAR sem mexer em nada).
        var st = getState(); st.approved = st.approved || {};
        var k = (frame.dataset.frameType || '?') + '|' + (frame.dataset.frameColor || '?');
        st.approved[k] = {
          translate: pxToPct(frame.style.translate),
          width: frame.style.width || 'auto',
          height: frame.style.height || 'auto'
        };
        localStorage.setItem(STORAGE, JSON.stringify(st));
        // Feedback visual no botão (pulse + texto temporário)
        var btn = panel.querySelector('#rl-save');
        var originalText = btn.textContent;
        var originalBg = btn.style.background;
        btn.textContent = '✓ SALVO ' + k.split('|').pop().toUpperCase();
        btn.style.background = '#15803d';
        btn.style.transform = 'scale(1.05)';
        btn.style.transition = 'transform 200ms ease-out';
        setTimeout(function () {
          btn.style.transform = '';
          updatePanel(); // restaura texto/cor conforme estado real
        }, 800);
      };
      // REPLICAR: pega translate+W+H de qualquer outra cor JÁ SALVA do mesmo tipo
      // e aplica na cor atual. Útil pra acelerar calibração quando as 4 cores de
      // um tipo (canvas, padrao, caixa, etc) compartilham o mesmo offset.
      panel.querySelector('#rl-replicate').onclick = function () {
        var st = getState();
        var approved = st.approved || {};
        var curType = frame.dataset.frameType || '?';
        var curCor = frame.dataset.frameColor || '?';
        // Procura primeira cor do mesmo tipo já salva (priorizando a "irmã" mais comum)
        var prefer = ['mel', 'preta', 'pinus', 'branca'];
        var source = null, sourceCor = null;
        for (var i = 0; i < prefer.length; i++) {
          var cor = prefer[i];
          if (cor === curCor) continue;
          if (approved[curType + '|' + cor]) {
            source = approved[curType + '|' + cor];
            sourceCor = cor;
            break;
          }
        }
        if (!source) {
          alert('Nenhuma outra cor do tipo "' + curType + '" foi salva ainda. Calibre pelo menos uma cor primeiro.');
          return;
        }
        // Aplica no frame (em px do stage atual)
        frame.style.translate = pctToPx(source.translate || '0% 0%');
        frame.style.width = source.width === 'auto' ? '' : source.width;
        frame.style.height = source.height === 'auto' ? '' : source.height;
        // Atualiza sliders + caption
        if (window.__rl_syncSliders) window.__rl_syncSliders();
        updatePanel();
        // Feedback visual no botão
        var btn = panel.querySelector('#rl-replicate');
        var txt = btn.textContent;
        btn.textContent = '✓ COPIADO DE ' + sourceCor.toUpperCase();
        setTimeout(function () { btn.textContent = txt; }, 1500);
      };
      panel.querySelector('#rl-next').onclick = function () {
        // Avança SEM salvar (salvamento é manual via botão SALVAR)
        var curIdx = comboIndex(frame.dataset.frameType, frame.dataset.frameColor);
        goToCombo(curIdx + 1);
      };
      panel.querySelector('#rl-prev').onclick = function () {
        var curIdx = comboIndex(frame.dataset.frameType, frame.dataset.frameColor);
        goToCombo(curIdx - 1);
      };
      // Cores esperadas (RGB médio aproximado por cor de moldura)
      var EXPECTED_COLORS = {
        mel:    { r: 110, g: 75, b: 45 },     // tabaco escuro
        preta:  { r: 30,  g: 30, b: 30 },     // preto profundo
        pinus:  { r: 195, g: 165, b: 105 },   // amarelo dourado pastel (após modulate)
        branca: { r: 220, g: 215, b: 205 }    // off-white quente
      };
      function colorDist(a, b) {
        var dr = a.r - b.r, dg = a.g - b.g, db = a.b - b.b;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }
      function sampleMoldura(url) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = 100; canvas.height = 100;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, 100, 100);
            try {
              var data = ctx.getImageData(0, 0, 100, 100).data;
              var r = 0, g = 0, b = 0, n = 0;
              for (var i = 0; i < data.length; i += 4) {
                var a = data[i + 3];
                if (a < 200) continue; // só pixels opacos (a moldura, não o buraco)
                r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
              }
              if (!n) return resolve(null);
              resolve({ r: Math.round(r / n), g: Math.round(g / n), b: Math.round(b / n) });
            } catch (e) { resolve(null); }
          };
          img.onerror = function () { resolve(null); };
          img.src = url;
        });
      }
      panel.querySelector('#rl-checkcolors').onclick = function () {
        var st = getState();
        var approved = (st.approved || {});
        var keys = Object.keys(approved);
        if (!keys.length) { alert('Nenhuma moldura salva ainda.'); return; }
        var baseMatch = frame.src.match(/(.+\/)jun26-[^/]+\.webp/);
        if (!baseMatch) { alert('Não consegui detectar prefixo.'); return; }
        var basePath = baseMatch[1];
        var galC = document.querySelector('pp26-gallery');
        var orient = (galC && galC.dataset.orientation) || 'vertical';
        var btn = this;
        btn.textContent = 'AMOSTRANDO...';
        btn.disabled = true;
        Promise.all(keys.map(function (key) {
          var parts = key.split('|');
          var type = parts[0], cor = parts[1];
          var url = basePath + 'jun26-' + orient + '-' + type + '-' + cor + '.webp';
          return sampleMoldura(url).then(function (avg) {
            var expected = EXPECTED_COLORS[cor];
            var dist = avg && expected ? colorDist(avg, expected) : null;
            return { type: type, cor: cor, avg: avg, expected: expected, dist: dist };
          });
        })).then(function (results) {
          btn.textContent = 'VERIFICAR CORES';
          btn.disabled = false;
          var THRESHOLD = 80;
          var html = '<div style="font-weight:600;margin-bottom:6px">Verificação de cores</div>';
          html += '<div style="font-size:10px;color:#666;margin-bottom:8px">Desvios > ' + THRESHOLD + ' (distância RGB) marcados como suspeitos.</div>';
          var suspects = [];
          results.forEach(function (r) {
            var ok = r.dist != null && r.dist < THRESHOLD;
            if (!ok) suspects.push(r);
            var av = r.avg ? 'rgb(' + r.avg.r + ',' + r.avg.g + ',' + r.avg.b + ')' : 'falhou';
            var ex = r.expected ? 'rgb(' + r.expected.r + ',' + r.expected.g + ',' + r.expected.b + ')' : '—';
            html += '<div style="display:flex;align-items:center;gap:6px;font-size:10px;margin-bottom:3px">'
              + (ok ? '<span style="color:#22c55e">✓</span>' : '<span style="color:#ef4444">⚠</span>')
              + '<span style="width:60px;font-family:monospace">' + r.type + '</span>'
              + '<span style="width:50px;font-family:monospace">' + r.cor + '</span>'
              + '<span style="display:inline-block;width:14px;height:14px;border:1px solid #ccc;background:' + av + '"></span>'
              + '<span style="display:inline-block;width:14px;height:14px;border:1px solid #ccc;background:' + ex + '"></span>'
              + '<span style="font-family:monospace;color:' + (ok ? '#666' : '#ef4444') + '">Δ ' + (r.dist != null ? Math.round(r.dist) : '?') + '</span>'
              + '</div>';
          });
          if (suspects.length) {
            html = '<div style="background:#fef2f2;border:1px solid #fecaca;padding:6px;margin-bottom:8px;font-size:10px;color:#b91c1c"><b>' + suspects.length + ' suspeita(s)</b> — verifica se subiu o webp certo.</div>' + html;
          } else {
            html = '<div style="background:#f0fdf4;border:1px solid #bbf7d0;padding:6px;margin-bottom:8px;font-size:10px;color:#15803d"><b>Tudo dentro do esperado.</b></div>' + html;
          }
          // Mostra resultado num modal simples
          var modal = document.createElement('div');
          modal.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border:1px solid #111;padding:16px;z-index:99999;width:400px;max-height:70vh;overflow:auto;box-shadow:0 8px 24px rgba(0,0,0,.2);font:11px Archivo';
          modal.innerHTML = html + '<button style="margin-top:10px;padding:6px 12px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo">FECHAR</button>';
          modal.querySelector('button').onclick = function () { modal.remove(); };
          document.body.appendChild(modal);
        });
      };

      // EXPORTAR PRO TEMA: gera JSON com warp + position calibrados em %
      panel.querySelector('#rl-export').onclick = function () {
        var st = getState();
        var galEx = document.querySelector('pp26-gallery');
        var orientEx = (galEx && galEx.dataset.orientation) || 'vertical';
        var data = {
          generatedAt: new Date().toISOString(),
          orient: orientEx,
          warpByOrient: st.warpByOrient || {},
          warpByOrientType: st.warpByOrientType || {},
          approved: st.approved || {} // posição moldura por type|cor (em %)
        };
        var json = JSON.stringify(data, null, 2);
        // Copia pro clipboard
        if (navigator.clipboard) navigator.clipboard.writeText(json);
        // Baixa arquivo
        var blob = new Blob([json], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'jun26-calibracao-' + Date.now() + '.json';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
        // Mostra modal com instruções + JSON
        var modal = document.createElement('div');
        modal.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border:1px solid #111;padding:20px;z-index:99999;width:480px;max-height:80vh;overflow:auto;box-shadow:0 8px 24px rgba(0,0,0,.3);font:12px Archivo';
        modal.innerHTML = ''
          + '<div style="font-weight:600;font-size:14px;margin-bottom:10px">⬇ Exportado pro tema</div>'
          + '<div style="background:#fef3c7;border:1px solid #fde68a;padding:8px;font-size:11px;color:#92400e;margin-bottom:10px">'
          + '<b>Próximos passos:</b><br>'
          + '1. JSON copiado pro clipboard + baixado em ~/Downloads/<br>'
          + '2. Manda pra Claude (eu) commitar no template `product.pdp-jun26.json` (setting `pp26_builder_json`)<br>'
          + '3. Após push, todos os clientes em qualquer device veem as calibrações.'
          + '</div>'
          + '<textarea readonly style="width:100%;height:200px;font-family:monospace;font-size:10px;border:1px solid #d4d4d8;padding:8px">' + json.replace(/</g, '&lt;') + '</textarea>'
          + '<div style="display:flex;gap:6px;margin-top:10px">'
          + '<button style="padding:8px 12px;background:#111;color:#fff;border:none;cursor:pointer;font:11px Archivo" onclick="this.previousElementSibling.previousElementSibling.select(); document.execCommand(\'copy\'); this.textContent=\'✓ COPIADO\'">COPIAR DE NOVO</button>'
          + '<button id="rl-export-close" style="padding:8px 12px;background:#f4f4f5;border:1px solid #d4d4d8;cursor:pointer;font:11px Archivo">FECHAR</button>'
          + '</div>';
        modal.querySelector('#rl-export-close').onclick = function () { modal.remove(); };
        document.body.appendChild(modal);
      };

      // ──────────────────────────────────────────────────────────────────
      // SALVAR ORIENT: baixa um .json com APENAS a orientação atual.
      // Útil pra preservar trabalho antes de testar outro produto/orient.
      // O arquivo carrega só as chaves de uma orient (não polui o resto).
      // ──────────────────────────────────────────────────────────────────
      panel.querySelector('#rl-save-orient').onclick = function () {
        var st = getState();
        var orient = 'vertical'; // produto atual (jun26 é sempre 1 só)
        var galleryEl = document.querySelector('pp26-gallery');
        if (galleryEl && galleryEl.dataset.orientation) orient = galleryEl.dataset.orientation;
        // Filtra warpByOrientType e warpByOrient pra essa orient
        var snap = {
          orient: orient,
          generatedAt: new Date().toISOString(),
          warpByOrient: {},
          warpByOrientType: {},
          approved: st.approved || {},
          guides: {}
        };
        if (st.warpByOrient && st.warpByOrient[orient]) snap.warpByOrient[orient] = st.warpByOrient[orient];
        Object.keys(st.warpByOrientType || {}).forEach(function (k) {
          if (k.indexOf(orient + '|') === 0) snap.warpByOrientType[k] = st.warpByOrientType[k];
        });
        // Guides (réguas extras) também por orientação
        if (st.guides && st.guides[orient]) snap.guides[orient] = st.guides[orient];
        // Approved é compartilhado entre orientações (chave é type|cor sem orient).
        // Mantém TUDO no arquivo — quem importar pra outro produto/orient ignora
        // se não quiser, ou substitui se quiser. Backup mais completo.
        var blob = new Blob([JSON.stringify(snap, null, 2)], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'jun26-ruler-' + orient + '-' + Date.now() + '.json';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        var btn = panel.querySelector('#rl-save-orient');
        var txt = btn.textContent;
        btn.textContent = '✓ BAIXADO';
        setTimeout(function () { btn.textContent = txt; }, 1500);
      };

      // ──────────────────────────────────────────────────────────────────
      // IMPORTAR: lê .json salvo via "SALVAR ORIENT" e MERGE no localStorage.
      // NÃO sobrescreve outras orientações nem panelPos — só adiciona/atualiza
      // as chaves que estão no arquivo importado.
      // ──────────────────────────────────────────────────────────────────
      panel.querySelector('#rl-load-orient').onclick = function () {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/json,.json';
        input.style.display = 'none';
        input.onchange = function (e) {
          var file = e.target.files && e.target.files[0];
          if (!file) return;
          var reader = new FileReader();
          reader.onload = function (ev) {
            try {
              var data = JSON.parse(ev.target.result);
              var current = getState();
              // Merge warpByOrient (uma chave por orient)
              if (data.warpByOrient) {
                current.warpByOrient = current.warpByOrient || {};
                Object.assign(current.warpByOrient, data.warpByOrient);
              }
              // Merge warpByOrientType (chave: orient|tipo)
              if (data.warpByOrientType) {
                current.warpByOrientType = current.warpByOrientType || {};
                Object.assign(current.warpByOrientType, data.warpByOrientType);
              }
              // Merge approved (chave: tipo|cor) — sobrescreve as iguais
              if (data.approved) {
                current.approved = current.approved || {};
                Object.assign(current.approved, data.approved);
              }
              // Merge guides (réguas extras, por orient)
              if (data.guides) {
                current.guides = current.guides || {};
                Object.assign(current.guides, data.guides);
              }
              localStorage.setItem(STORAGE, JSON.stringify(current));
              alert('Importado: ' + (data.orient || '?') +
                '\nWarp custom: ' + Object.keys(data.warpByOrientType || {}).length +
                '\nAprovados: ' + Object.keys(data.approved || {}).length +
                '\nGuides: ' + Object.keys(data.guides || {}).map(function (k) { return k + ':' + (data.guides[k] || []).length; }).join(', ') +
                '\n\nRecarregando a régua…');
              location.reload();
            } catch (err) {
              alert('Erro ao importar: ' + err.message);
            }
          };
          reader.readAsText(file);
        };
        document.body.appendChild(input);
        input.click();
        setTimeout(function () { input.remove(); }, 1000);
      };

      // Réguas extras (vertical/horizontal) deletáveis. Linha azul ciano,
      // arrastável, mostra posição em % do stage. Click direito ou × deleta.
      // Réguas extras agora PERSISTEM em localStorage (sob guides[orient]).
      // Cada uma carrega id único pra poder atualizar/deletar no array.
      function getCurrentOrient() {
        var gal = document.querySelector('pp26-gallery');
        return (gal && gal.dataset.orientation) || 'vertical';
      }
      function saveGuides(arr) {
        var st = getState();
        st.guides = st.guides || {};
        st.guides[getCurrentOrient()] = arr;
        localStorage.setItem(STORAGE, JSON.stringify(st));
      }
      function getGuides() {
        var st = getState();
        return (st.guides && st.guides[getCurrentOrient()]) || [];
      }
      function addGuide(orient, presetPct, presetId) {
        var stage = document.querySelector('.pp26__perspective-stage');
        if (!stage) return;
        var line = document.createElement('div');
        line.className = 'jun26-guide jun26-guide-' + orient;
        var startPct = (typeof presetPct === 'number') ? presetPct : 50;
        var guideId = presetId || ('g' + Date.now() + Math.random().toString(36).slice(2, 6));
        line.dataset.guideId = guideId;
        if (orient === 'v') {
          line.style.cssText = 'position:absolute;top:0;bottom:0;width:1px;background:#06b6d4;left:' + startPct + '%;cursor:ew-resize;z-index:75;box-shadow:0 0 0 1px rgba(6,182,212,.3)';
        } else {
          line.style.cssText = 'position:absolute;left:0;right:0;height:1px;background:#06b6d4;top:' + startPct + '%;cursor:ns-resize;z-index:75;box-shadow:0 0 0 1px rgba(6,182,212,.3)';
        }
        var label = document.createElement('div');
        label.style.cssText = 'position:absolute;background:#06b6d4;color:#fff;font:10px Archivo;padding:2px 6px;white-space:nowrap;cursor:pointer;user-select:none;border-radius:2px';
        if (orient === 'v') { label.style.top = '8px'; label.style.left = '6px'; }
        else { label.style.left = '8px'; label.style.top = '-22px'; }
        label.innerHTML = '<span style="margin-right:6px">' + startPct.toFixed(1) + '%</span><span style="background:#dc2626;padding:0 4px;border-radius:2px;font-weight:700">×</span>';
        label.title = 'click no × pra deletar';
        line.appendChild(label);
        // Delete: remove do DOM + do array em localStorage
        label.onclick = function (e) {
          e.stopPropagation();
          line.remove();
          var arr = getGuides().filter(function (g) { return g.id !== guideId; });
          saveGuides(arr);
        };
        var dragging = false;
        line.addEventListener('mousedown', function (e) {
          if (e.target === label) return;
          dragging = true; e.preventDefault();
        });
        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var stageRect = stage.getBoundingClientRect();
          var pct;
          if (orient === 'v') {
            pct = ((e.clientX - stageRect.left) / stageRect.width) * 100;
            pct = Math.max(0, Math.min(100, pct));
            line.style.left = pct + '%';
          } else {
            pct = ((e.clientY - stageRect.top) / stageRect.height) * 100;
            pct = Math.max(0, Math.min(100, pct));
            line.style.top = pct + '%';
          }
          label.innerHTML = '<span style="margin-right:6px">' + pct.toFixed(1) + '%</span><span style="background:#dc2626;padding:0 4px;border-radius:2px;font-weight:700">×</span>';
          // Atualiza posição no localStorage
          var arr = getGuides().map(function (g) {
            return g.id === guideId ? { id: guideId, orient: orient, pct: pct } : g;
          });
          saveGuides(arr);
        });
        document.addEventListener('mouseup', function () { dragging = false; });
        stage.appendChild(line);
        // Salva nova guide (se não veio de preset)
        if (!presetId) {
          var arr = getGuides();
          arr.push({ id: guideId, orient: orient, pct: startPct });
          saveGuides(arr);
        }
      }
      panel.querySelector('#rl-add-vline').onclick = function () { addGuide('v'); };
      panel.querySelector('#rl-add-hline').onclick = function () { addGuide('h'); };
      // Restaura guides salvas pra orientação atual (no boot do ruler)
      setTimeout(function () {
        getGuides().forEach(function (g) { addGuide(g.orient, g.pct, g.id); });
      }, 100);

      var artHidden = false;
      panel.querySelector('#rl-hide-art').onclick = function () {
        artHidden = !artHidden;
        art.style.visibility = artHidden ? 'hidden' : '';
        this.textContent = artHidden ? 'MOSTRAR ARTE' : 'OCULTAR ARTE';
        this.style.background = artHidden ? '#fbbf24' : '#fff';
        this.style.color = artHidden ? '#111' : '#111';
      };

      // Painel de camadas em ÁRVORE (estilo Rafael's mockup)
      // Vertical > Warp geral > [Type warp custom?] > Cores
      var layerPanel = null;
      panel.querySelector('#rl-layers').onclick = function () {
        if (layerPanel) {
          layerPanel.remove(); layerPanel = null;
          this.textContent = 'CAMADAS';
          this.style.background = '#fff';
          return;
        }
        this.textContent = 'FECHAR ÁRVORE';
        this.style.background = '#fbbf24';
        layerPanel = renderLayerTree();
      };
      function renderLayerTree() {
        var st = getState();
        var approved = st.approved || {};
        var warpByOT = st.warpByOrientType || {};
        var warpByO = st.warpByOrient || {};
        var galLT = document.querySelector('pp26-gallery');
        var orient = (galLT && galLT.dataset.orientation) || 'vertical';
        var hasGeral = !!warpByO[orient];
        var pnl = document.createElement('div');
        pnl.id = 'jun26-layers-panel';
        pnl.style.cssText = 'position:fixed;top:80px;right:340px;background:#fff;border:1px solid #111;color:#111;padding:0;z-index:9998;font:12px Archivo,system-ui,sans-serif;width:280px;box-shadow:0 8px 24px rgba(0,0,0,.15);max-height:75vh;overflow:auto';
        var html = '<div style="padding:10px 12px;background:#111;color:#fff;font-weight:600;letter-spacing:.05em;text-transform:uppercase;font-size:10px;display:flex;justify-content:space-between;align-items:center"><span>Calibração</span><button id="rl-l-close" style="background:transparent;border:none;color:#fff;cursor:pointer;font-size:16px;line-height:1;padding:0">×</button></div>';
        html += '<div style="padding:10px 12px"><div style="font-weight:600;font-size:11px;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px;color:#444">📐 Vertical</div>';
        // Warp geral
        html += '<div class="rl-l-node" data-act="goWarp" style="padding:6px 10px 6px 24px;cursor:pointer;display:flex;align-items:center;gap:6px;border-radius:3px" title="Define warp geral da orientação (fallback pros acabamentos sem customização)">' +
          '<span style="width:14px">└</span>' +
          '<span style="flex:1;font-size:11px"><b>Warp da arte geral</b></span>' +
          '<span style="font-size:10px;color:' + (hasGeral ? '#15803d' : '#999') + '">' + (hasGeral ? '✓' : '◯') + '</span>' +
          '</div>';
        // Por type
        TYPES_ORDER.forEach(function (type) {
          var hasCustom = !!warpByOT[orient + '|' + type];
          var collapsedState = (st.treeCollapsed || {})[type];
          var collapsed = !!collapsedState;
          html += '<div class="rl-l-type-group" data-type="' + type + '" style="padding:8px 10px 4px 24px;margin-top:4px;border-top:1px solid #f0f0f0">' +
            '<div class="rl-l-type-header" style="display:flex;align-items:center;gap:6px;font-weight:600;font-size:11px;padding:2px 4px;border-radius:3px">' +
            '<button class="rl-l-toggle" data-type="' + type + '" style="width:14px;background:transparent;border:none;cursor:pointer;font-size:10px;color:#999;padding:0" title="recolher/expandir">' + (collapsed ? '▸' : '▾') + '</button>' +
            '<span class="rl-l-type-name" data-type="' + type + '" style="flex:1;cursor:pointer" title="WARP deste acabamento">' + type + '</span>' +
            '<button class="rl-l-warp-toggle" data-type="' + type + '" style="font-size:10px;background:' + (hasCustom ? '#7c3aed' : '#f4f4f5') + ';color:' + (hasCustom ? '#fff' : '#666') + ';border:none;padding:2px 6px;cursor:pointer;border-radius:2px" title="' + (hasCustom ? 'warp customizado' : 'usa warp geral') + '">' + (hasCustom ? '🎨' : '↑') + '</button>' +
            '</div>';
          // Cores (colapsável)
          html += '<div class="rl-l-cores-wrap" data-type="' + type + '" style="display:' + (collapsed ? 'none' : 'block') + '">';
          CORES_ORDER.forEach(function (cor) {
            var key = type + '|' + cor;
            var ap = approved[key];
            html += '<div class="rl-l-node rl-l-cor" data-type="' + type + '" data-cor="' + cor + '" style="padding:4px 10px 4px 44px;cursor:pointer;display:flex;align-items:center;gap:6px;border-radius:3px" title="Calibrar posição moldura">' +
              '<span style="width:14px;color:#888">└</span>' +
              '<span style="flex:1;font-size:11px;color:#555">' + cor + '</span>' +
              '<span style="font-size:10px;color:' + (ap ? '#15803d' : '#bbb') + '">' + (ap ? '✓' : '◯') + '</span>' +
              '</div>';
          });
          html += '</div></div>';
        });
        html += '</div>';
        pnl.innerHTML = html;
        document.body.appendChild(pnl);
        // Drag pelo header do painel árvore
        makeDraggable(pnl, pnl.firstElementChild, 'tree');
        pnl.querySelector('#rl-l-close').onclick = function () {
          pnl.remove(); layerPanel = null;
          var btn = panel.querySelector('#rl-layers');
          btn.textContent = 'CAMADAS'; btn.style.background = '#fff';
        };
        // Hover individual: só na linha de cor ou no header do type (não no grupo)
        pnl.querySelectorAll('.rl-l-cor, .rl-l-type-header, [data-act="goWarp"]').forEach(function (n) {
          n.onmouseover = function () { n.style.background = '#f4f4f5'; };
          n.onmouseout = function () { n.style.background = ''; };
        });
        // Click no warp geral: vai pro modo WARP + canvas mel (referência da orientação)
        pnl.querySelector('[data-act="goWarp"]').onclick = function () {
          setMode('warp');
          var ti = TYPES_ORDER.indexOf('canvas'), ci = CORES_ORDER.indexOf('mel');
          goToCombo(ti * CORES_ORDER.length + ci);
        };
        // Click na cor: vai pra essa combinação no modo POSIÇÃO
        pnl.querySelectorAll('.rl-l-cor').forEach(function (node) {
          node.onclick = function () {
            var t = node.dataset.type, c = node.dataset.cor;
            var ti = TYPES_ORDER.indexOf(t), ci = CORES_ORDER.indexOf(c);
            if (ti < 0 || ci < 0) return;
            setMode('pos');
            goToCombo(ti * CORES_ORDER.length + ci);
            setTimeout(function () {
              if (layerPanel) { layerPanel.remove(); layerPanel = renderLayerTree(); }
            }, 800);
          };
        });
        // Click no NOME do type: vai pra esse type no modo WARP (edita warp dele)
        pnl.querySelectorAll('.rl-l-type-name').forEach(function (node) {
          node.onclick = function (e) {
            e.stopPropagation();
            var t = node.dataset.type;
            var ti = TYPES_ORDER.indexOf(t);
            if (ti < 0) return;
            setMode('warp');
            goToCombo(ti * CORES_ORDER.length); // primeira cor (mel)
            setTimeout(function () {
              if (layerPanel) { layerPanel.remove(); layerPanel = renderLayerTree(); }
            }, 800);
          };
        });
        // Click no botão recolher/expandir grupo
        pnl.querySelectorAll('.rl-l-toggle').forEach(function (btn) {
          btn.onclick = function (e) {
            e.stopPropagation();
            var t = btn.dataset.type;
            var st2 = getState();
            st2.treeCollapsed = st2.treeCollapsed || {};
            st2.treeCollapsed[t] = !st2.treeCollapsed[t];
            localStorage.setItem(STORAGE, JSON.stringify(st2));
            var wrap = pnl.querySelector('.rl-l-cores-wrap[data-type="' + t + '"]');
            if (wrap) {
              var hidden = wrap.style.display === 'none';
              wrap.style.display = hidden ? 'block' : 'none';
              btn.textContent = hidden ? '▾' : '▸';
            }
          };
        });
        // Click no botão de toggle warp custom/geral
        pnl.querySelectorAll('.rl-l-warp-toggle').forEach(function (btn) {
          btn.onclick = function (e) {
            e.stopPropagation();
            var t = btn.dataset.type;
            var st = getState();
            st.warpByOrientType = st.warpByOrientType || {};
            var k = orient + '|' + t;
            if (st.warpByOrientType[k]) {
              // tem custom → volta pro geral (deleta)
              delete st.warpByOrientType[k];
            } else {
              // não tem custom → copia o geral (ou canvas) pra esse type
              var base = (st.warpByOrient && st.warpByOrient[orient]) ||
                st.warpByOrientType[orient + '|canvas'] ||
                [[5, 5], [95, 5], [95, 95], [5, 95]];
              st.warpByOrientType[k] = base.map(function (c) { return [c[0], c[1]]; });
            }
            localStorage.setItem(STORAGE, JSON.stringify(st));
            // Se está editando este type agora, recarrega warp
            var curFrame = document.querySelector('.pp26__frame');
            if (curFrame && curFrame.dataset.frameType === t && window.__rl_warp_reloadForType) {
              window.__rl_warp_reloadForType();
            }
            // Re-renderiza árvore
            layerPanel.remove();
            layerPanel = renderLayerTree();
          };
        });
        return pnl;
      }
      var simulating = false;
      panel.querySelector('#rl-simulate').onclick = function () {
        simulating = !simulating;
        // Esconde/mostra grid, eixos, handles, marcadores azuis
        var grid = document.getElementById('jun26-grid');
        if (grid) grid.style.display = simulating ? 'none' : '';
        stage.querySelectorAll('div[style*="rgba(255,0,0,.3)"]').forEach(function (el) {
          el.style.display = simulating ? 'none' : '';
        });
        document.querySelectorAll('.jun26-warp-handle, .jun26-resize-handle').forEach(function (el) {
          el.style.display = simulating ? 'none' : '';
        });
        if (window.__rl_showWarpRefs) window.__rl_showWarpRefs(!simulating && mode === 'pos');
        // Painel fica mais discreto
        panel.style.opacity = simulating ? '0.3' : '';
        panel.style.pointerEvents = simulating ? 'auto' : '';
        this.textContent = simulating ? 'EDITAR' : 'SIMULAR';
        this.style.background = simulating ? '#7c3aed' : '#111';
      };

      window.__rl_updatePanel = updatePanel;
      updatePanel();
      function updatePanel() {
        var type = frame.dataset.frameType || '?';
        var cor = frame.dataset.frameColor || '?';
        var st = getState();
        if (mode === 'warp') {
          var w = (window.__rl_warp_getCorners && window.__rl_warp_getCorners()) || {};
          // Verifica salvo no warp POR MOLDURA (warpByOrientType[orient|tipo]) — que é o que
          // o usuário está editando. Antes checava warpByOrient[orient] (warp geral, legado),
          // por isso "não salvo" amarelo sempre aparecia.
          var warpKeyCur = (w.orient || '?') + '|' + (w.type || '?');
          var warpSaved = st.warpByOrientType && st.warpByOrientType[warpKeyCur];
          var savedTag = warpSaved
            ? '<span style="color:#15803d;background:#f0fdf4;padding:2px 6px;font-size:10px;font-weight:600;border:1px solid #bbf7d0">✓ SALVO</span>'
            : '<span style="color:#92400e;background:#fef3c7;padding:2px 6px;font-size:10px;font-weight:600;border:1px solid #fde68a">não salvo</span>';
          panel.querySelector('#rl-status').innerHTML =
            'Modo <b>WARP</b> · <b>' + (w.type || '?') + '</b> · orientação <b>' + (w.orient || '?') + '</b> ' + savedTag + '<br>' +
            '<span style="font-size:10px;color:#666">Define os 4 cantos arrastando os handles roxos. Salva sozinho. Clique SALVAR pra confirmar e ir pra posição da moldura.</span>';
          panel.querySelector('#rl-values').textContent =
            'orient: ' + (w.orient || '?') + '\n' +
            'corners (%):\n' + (w.cornersPct ? JSON.stringify(w.cornersPct, null, 2) : '?');
          var approveBtn = panel.querySelector('#rl-approve');
          if (approveBtn) {
            if (warpSaved) {
              approveBtn.textContent = '✓ SALVO';
              approveBtn.style.background = '#15803d';
            } else {
              approveBtn.textContent = 'SALVAR';
              approveBtn.style.background = '#22c55e';
            }
          }
        } else {
          var approved = (st.approved && Object.keys(st.approved).length) || 0;
          var ap = st.approved && st.approved[type + '|' + cor];
          var curIdx = comboIndex(type, cor);
          var posLabel = curIdx >= 0 ? (curIdx + 1) + ' / 28' : '?';
          panel.querySelector('#rl-status').innerHTML =
            'Modo <b>POSIÇÃO</b> — <b>' + posLabel + '</b> · <b>' + type + '</b> / <b>' + cor + '</b><br>' +
            'Salvas: <b>' + approved + '</b> / 28' +
            '<div style="font-size:10px;color:#666;margin-top:4px">Pontos azuis = warp aprovado. Encaixe as quinas internas neles.</div>';
          panel.querySelector('#rl-values').textContent =
            'translate: ' + (frame.style.translate || '0px 0px') + '\n' +
            'width: ' + (frame.style.width || 'auto') + '\n' +
            'height: ' + (frame.style.height || 'auto');
          // Botão SALVAR: 3 estados
          //   - "SALVAR" verde: não há ajuste salvo
          //   - "✓ SALVO" verde escuro: ajustes atuais = ajustes salvos
          //   - "SALVAR MUDANÇAS" amarelo: editou após salvar
          var saveBtn = panel.querySelector('#rl-save');
          if (saveBtn) {
            // Normaliza valores pra comparação robusta (evita falso positivo
            // por diferença de formatação: "5px 3px" vs "5px  3px" vs "5.0px 3.0px")
            function normalizeT(v) {
              var parts = (v || '0px 0px').trim().split(/\s+/);
              var x = Math.round(parseFloat(parts[0]) || 0);
              var y = Math.round(parseFloat(parts[1]) || 0);
              return x + 'px ' + y + 'px';
            }
            function normalizeDim(v) {
              if (!v || v === 'auto' || v === '') return 'auto';
              var n = parseFloat(v);
              return isNaN(n) ? 'auto' : Math.round(n) + (v.indexOf('%') > -1 ? '%' : 'px');
            }
            // Normaliza ambos em px (ap pode estar em %)
            var curT = normalizeT(frame.style.translate);
            var curW = normalizeDim(frame.style.width);
            var curH = normalizeDim(frame.style.height);
            var apT = ap ? normalizeT(pctToPx(ap.translate)) : null;
            var apW = ap ? normalizeDim(ap.width) : null;
            var apH = ap ? normalizeDim(ap.height) : null;
            var modified = ap && (curT !== apT || curW !== apW || curH !== apH);
            if (modified) {
              saveBtn.textContent = '⚠ SALVAR MUDANÇAS';
              saveBtn.style.background = '#f59e0b';
            } else if (ap) {
              saveBtn.textContent = '✓ SALVO';
              saveBtn.style.background = '#15803d';
            } else {
              saveBtn.textContent = 'SALVAR';
              saveBtn.style.background = '#22c55e';
            }
          }
        }
      }
    }
    var updatePanel = function () { if (window.__rl_updatePanel) window.__rl_updatePanel(); };
    attempt();
  }

  // Simula variants ocultas (slim/caixa-com-paspatur/slim-com-paspatur)
  // mudando frame.src direto. Roda sempre (não só no ruler).
  function setupHiddenVariantSim(frameArg) {
    function getFrame() { return frameArg || document.querySelector('.pp26__frame'); }
    function recalcAndSimulate() {
      setTimeout(function () {
        var frame = getFrame();
        if (!frame) return;
        var activePill = document.querySelector('.jun26-pill--active');
        var primario = activePill && activePill.dataset.primario;
        if (!primario) return;
        if (primario === 'sem moldura' || primario === 'canvas') return;
        var mods = document.querySelectorAll('.jun26-mod input[type="checkbox"]');
        var prof = false, fino = false, pasp = false;
        mods.forEach(function (cb) {
          var label = cb.closest('label');
          var txt = label ? label.textContent.toLowerCase() : '';
          if (txt.indexOf('profundidade') !== -1) prof = cb.checked;
          else if (txt.indexOf('fino') !== -1) fino = cb.checked;
          else if (txt.indexOf('paspatur') !== -1) pasp = cb.checked;
        });
        var type = 'padrao';
        if (fino && pasp) type = 'slim-com-paspatur';
        else if (fino) type = 'slim';
        else if (prof && pasp) type = 'caixa-com-paspatur';
        else if (prof) type = 'caixa';
        else if (pasp) type = 'padrao-com-paspatur';
        // Tipos sempre tratados como "hidden" (sem variant pra todos os tamanhos):
        // slim, slim-com-paspatur, caixa-com-paspatur. Pra esses, delega pro
        // pp26-gallery.updateFrame() público — assim os corners do stage também
        // são atualizados (essencial pro warp ficar centralizado), não só o src.
        // padrao-com-paspatur e caixa: deixa pp26-gallery cuidar via variant change.
        var HIDDEN_TYPES = ['slim', 'slim-com-paspatur', 'caixa-com-paspatur'];
        if (HIDDEN_TYPES.indexOf(type) === -1) return;
        // Verifica se existe Option Value pra esse tipo nesse produto/tamanho.
        // Se NÃO existe (Matrixify removeu pra esse tamanho), NÃO simula visualmente —
        // o cliente nem deveria estar nesse estado (render() escondeu o checkbox).
        // Sem esse guard, o frame muda mas o preço fica da variant anterior.
        var molFs2 = document.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
        var typeValueMap2 = {
          'slim': 'slim', 'slim-com-paspatur': 'slim com paspatur',
          'caixa-com-paspatur': 'caixa com paspatur'
        };
        var molRadio = molFs2 && molFs2.querySelector('input[value="' + typeValueMap2[type] + '"]');
        if (!molRadio) return; // option value não existe — não simula
        var corFs = document.querySelector('[data-handle="escolha-a-cor-da-moldura"]');
        var corInput = corFs && corFs.querySelector('input:checked');
        var corValueMap = {
          'madeira escura': 'mel', 'preta': 'preta',
          'madeira clara': 'pinus', 'branca': 'branca'
        };
        var corShort = corInput ? (corValueMap[corInput.value] || corInput.value) : 'mel';
        if (corShort === 'sem moldura') corShort = 'mel';
        // Se o frame já está no tipo+cor esperado, no-op
        if (frame.dataset.frameType === type && frame.dataset.frameColor === corShort) return;
        var gallery = frame.closest('pp26-gallery');
        if (gallery && typeof gallery.updateFrame === 'function') {
          gallery.updateFrame(type, corShort);
        }
      }, 300);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.jun26-pill') || e.target.closest('.jun26-mod') || e.target.closest('.jun26-swatch')) {
        recalcAndSimulate();
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.closest('.jun26-mod')) recalcAndSimulate();
    }, true);
  }

  // === Work head (topo do buy box): chip QUADRO + rating, título sem "Quadro",
  // crédito do artista. Ordem de galeria. ===
  // Localização dos artistas (de pdp-artistas-localizacao.md, 12/jun):
  // alta confiança = cidade, país; média = só país; baixa = fora do mapa.
  var ARTIST_LOCATIONS = {
    'Agata Krolak': 'Gdańsk, Polônia',
    'Agus Buerba': 'Buenos Aires, Argentina',
    'Agus Minuto': 'Buenos Aires, Argentina',
    'Andrea Reichhart': 'St. Wendel, Alemanha',
    'Andreas Magnusson': 'Vendelsö (Estocolmo), Suécia',
    'Angela Seear': 'Vancouver, Canadá',
    'Anna Mielniczuk': 'Chicago, Estados Unidos',
    'Artur Chen': 'Taiwan',
    'Athene Fritsch': 'Panamá',
    'Avanesova Elena': 'Maiorca, Espanha',
    'Bellassai Art': 'Itália',
    'Bethany Young': 'Estados Unidos',
    'Breanna Megan Studio': 'Turlock (CA), Estados Unidos',
    'Camilla Aasen Jordanger': 'Sande (Vestfold), Noruega',
    'Cartissi': 'Cornualha, Reino Unido',
    'Catalina Somolinos': 'Frankfurt, Alemanha',
    'Charlotte Curd': 'Sydney, Austrália',
    'Christina Misuro': 'Polônia',
    'Dan Hobday': 'Devon, Reino Unido',
    'Danushka Abeygoda': 'Perth, Austrália',
    'David Diehl': 'Zurique, Suíça',
    'David Vineis': 'Paris, França',
    'Deb Chaney': 'Vancouver, Canadá',
    'Dianne Nicole Fernando': 'Manila, Filipinas',
    'Dorothy Fagan': 'Estados Unidos',
    'Eden Kalif': 'Tel Aviv, Israel',
    'Elena Shraibman': 'Israel',
    'Ellen Greup': 'Países Baixos',
    'Emma Bell': 'Atlanta (GA), Estados Unidos',
    'Enrique Larios': 'Cidade do México, México',
    'Esperanza Manzanera': 'Granada, Espanha',
    'Gemma Bardot': 'Portland (OR), Estados Unidos',
    'Hans-Wolfgang Hawerkamp': 'Düsseldorf, Alemanha',
    'Heike Wolters Wrase': 'Braunschweig, Alemanha',
    'Ibrahim Nabeel': 'Amã, Jordânia',
    'Isadora Sá': 'Brasil',
    'Jackie Stofsick': 'Itália',
    'Jazzberry Blue': 'Toronto, Canadá',
    'Joackim Schou Dahle': 'Noruega',
    'Jonas Weikel': 'Karlskrona, Suécia',
    'Julia Contacessi': 'Norwalk (CT), Estados Unidos',
    'Julia Purinton': 'Washington, DC, Estados Unidos',
    'Julita Elbe': 'Münster, Alemanha',
    'Kanat Ibragimov': 'São Francisco (CA), Estados Unidos',
    'Karin Kilb': 'Alemanha',
    'Karin Lauria': 'Estados Unidos',
    'Katy Tanis': 'Estados Unidos',
    'Leigh Viner': 'Denver, Estados Unidos',
    'Linda Wride': 'Oxford, Reino Unido',
    'Little Dean': 'Malásia',
    'Livia Frigo': 'São Paulo, Brasil',
    'Lucy Muss': 'Londres, Reino Unido',
    'Magdalena Krzak': 'Chicago, Estados Unidos',
    'Marina Nelson': 'Calgary, Canadá',
    'Marisol Evora': 'Espanha',
    'Marius Surleac': 'Bucareste, Romênia',
    'Mark Russell Jones': 'Los Angeles, Estados Unidos',
    'Mette Rix': 'Aarhus, Dinamarca',
    'Mowzu': 'Ballito, África do Sul',
    'Nikita Jariwala': 'Suíça',
    'Orly Ammon': 'Redruth (Cornualha), Reino Unido',
    'Paulo Abrantes': 'Coimbra, Portugal',
    'Pictufy Studio': 'Estocolmo, Suécia',
    'Rafael Campezato': 'Igrejinha (RS), Brasil',
    'Rafael Farias': 'Brasil',
    'Richard Gombar': 'Estados Unidos',
    'Rikard Martin': 'Suécia',
    'Rob Li': 'Filadélfia, Estados Unidos',
    'Rushati Chowdhury': 'Índia',
    'Shatha Al Dafai': 'Mascate, Omã',
    'Shot by Clint': 'África do Sul',
    'Streiff Marcel': 'Zurique, Suíça',
    'Tamara Jare': 'Liubliana, Eslovênia',
    'Tamas Dragon': 'Budapeste, Hungria',
    'Tetsuji Fujino': 'Fukuoka, Japão',
    'The Miuus Studio': 'Varsóvia, Polônia',
    'Tim Mossholder': 'Santa Maria (CA), Estados Unidos',
    'Tove Hoglund': 'Skurup, Suécia',
    'Uplusmestudio': 'Flensburg, Alemanha',
    'Vered Gersztenkorn': 'Israel',
    'Vitor Costa': 'Portugal'
  };

  function buildWorkHead(root) {
    var inner = root.querySelector('.product-information--inner') || root;
    var titleEl = inner.querySelector('h1.product-title');
    if (!titleEl || inner.querySelector('.jun26-workhead')) return;
    var titleContainer = titleEl.closest('.product-title-container') || titleEl.parentElement;

    // v2 "etiqueta de galeria": artista em small-caps no topo → título →
    // estrelas+nota abaixo; coração à direita. Sem chips (QUADRO saiu — vira
    // estado do stage no toggle, pendente).
    var wh = document.createElement('div');
    wh.className = 'jun26-workhead';

    var artistMenu = inner.querySelector('.artist-menu.desktop') || inner.querySelector('.artist-menu');
    var artistName = (artistMenu && artistMenu.textContent.trim()) || '';
    var artistLink = artistMenu && artistMenu.querySelector('a');
    var artistHref = (artistLink && artistLink.getAttribute('href')) || '';
    // Linha do eyebrow: artista à esquerda, rating à direita (decisão 12/jun).
    var eyebrowRow = document.createElement('div');
    eyebrowRow.className = 'jun26-wh-eyebrow';
    if (artistName) {
      var credit = artistHref ? document.createElement('a') : document.createElement('span');
      credit.className = 'jun26-wh-artist';
      if (artistHref) credit.href = artistHref;
      credit.textContent = artistName;
      eyebrowRow.appendChild(credit);
    }
    wh.appendChild(eyebrowRow);
    inner.querySelectorAll('.artist-menu').forEach(function (a) { a.style.display = 'none'; });

    // --- Linha: [título + rating] à esquerda / coração à direita ---
    var row = document.createElement('div');
    row.className = 'jun26-wh-row';

    var titleGroup = document.createElement('div');
    titleGroup.className = 'jun26-wh-titlegroup';

    var t = (titleEl.textContent || '').trim();
    t = t.replace(/^\s*quadro\s+/i, '').replace(/\s+by\s+.+$/i, '').trim();
    titleEl.textContent = t;
    titleEl.classList.add('jun26-wh-title');
    titleGroup.appendChild(titleEl);

    var rating = document.createElement('div');
    rating.className = 'jun26-wh-rating';
    rating.setAttribute('aria-label', '4,9 de 5');
    var stars = document.createElement('span');
    stars.className = 'jun26-wh-stars';
    stars.textContent = '★★★★★';
    var count = document.createElement('span');
    count.className = 'jun26-wh-count';
    count.textContent = '4,9';
    rating.append(stars, count);
    eyebrowRow.appendChild(rating);
    row.appendChild(titleGroup);


    // Card de título antigo da galeria (artista+título "Quadro …") — redundante
    // com o work head. Esconde via JS (inline !important vence o pp26).
    var titleCard = root.querySelector('.pp26-gallery__title-card');
    if (titleCard) titleCard.style.setProperty('display', 'none', 'important');

    wh.appendChild(row);

    if (titleContainer && titleContainer.parentElement) {
      titleContainer.parentElement.insertBefore(wh, titleContainer);
    } else {
      inner.insertBefore(wh, inner.firstChild);
    }

    // Mobile: work head ACIMA da imagem (galeria). Desktop: no topo do info.
    var media = root.querySelector('.pp26-product-grid__media');
    if (media && media.parentElement) {
      var mq = window.matchMedia('(max-width: 959px)');
      var placeWorkHead = function () {
        if (mq.matches) {
          if (wh.nextElementSibling !== media || wh.parentElement !== media.parentElement) {
            media.parentElement.insertBefore(wh, media);
          }
        } else if (titleContainer && titleContainer.parentElement) {
          if (wh.nextElementSibling !== titleContainer || wh.parentElement !== titleContainer.parentElement) {
            titleContainer.parentElement.insertBefore(wh, titleContainer);
          }
        }
      };
      placeWorkHead();
      if (mq.addEventListener) mq.addEventListener('change', placeWorkHead);
      else if (mq.addListener) mq.addListener(placeWorkHead);
    }

  }

  // ============================================================
  // Proteção anti-cópia da PDP (best-effort): bloqueia menu de
  // contexto (salvar imagem), arrastar imagens, seleção/cópia de
  // texto e atalhos de salvar/ver-fonte/imprimir. Screenshot e
  // devtools NÃO são bloqueáveis — isto é dissuasão, não cofre.
  // Editores internos (?ruler/?colortool etc.) desativam tudo.
  // ============================================================
  function setupCopyProtection() {
    var params = new URLSearchParams(location.search);
    var EDIT_FLAGS = ['ruler', 'colortool', 'fxedit', 'posedit', 'calibrate', 'localframes'];
    for (var i = 0; i < EDIT_FLAGS.length; i++) {
      if (params.has(EDIT_FLAGS[i])) return;
    }
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    document.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    ['copy', 'cut'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        // permite copiar de campos de formulário (cupom, etc.)
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return;
        e.preventDefault();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (!(e.ctrlKey || e.metaKey)) return;
      var k = (e.key || '').toLowerCase();
      // salvar página, ver fonte, imprimir
      if (k === 's' || k === 'u' || k === 'p') e.preventDefault();
    });
    // draggable=false em todas as imagens (atuais e futuras — variant troca img)
    function lockImgs() {
      document.querySelectorAll('img:not([draggable="false"])').forEach(function (im) {
        im.setAttribute('draggable', 'false');
      });
    }
    lockImgs();
    new MutationObserver(lockImgs).observe(document.body, { childList: true, subtree: true });
  }

  // Clona o botão do app Swym (coração) pra dentro dos slots ao lado dos
  // CTAs (barra mobile + cartão desktop). O app injeta o original dentro do
  // h1 (escondido via CSS); clonamos pra cada slot quando ele carrega.
  // Coração ao lado dos CTAs: botão PROXY que repassa o clique pro botão
  // real do app Swym (clones não herdam handlers — por isso "não funcionava").
  // O estado favoritado vem da classe wk-selected do botão original.
  function setupWishlistHearts() {
    function origButton() {
      return document.querySelector(
        '.thb-product-detail--jun26 wishlist-button-product button, ' +
        '.thb-product-detail--jun26 wk-button button, ' +
        '.thb-product-detail--jun26 button.wk-button'
      );
    }
    function syncState() {
      var o = origButton();
      var on = !!(o && o.classList.contains('wk-selected'));
      document.querySelectorAll('.jun26-heart-slot').forEach(function (slot) {
        slot.classList.toggle('jun26-heart-on', on);
      });
    }
    function fillAll() {
      var slots = Array.prototype.slice.call(document.querySelectorAll('.jun26-heart-slot:not(.is-loaded)'));
      if (!slots.length) return false;
      if (!origButton()) return false;
      slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jun26-heart-btn';
        btn.setAttribute('aria-label', 'Adicionar aos favoritos');
        btn.addEventListener('click', function () {
          var o = origButton();
          if (o) o.click();
        });
        slot.innerHTML = '';
        slot.appendChild(btn);
        slot.classList.add('is-loaded');
      });
      syncState();
      var wbp = document.querySelector('.thb-product-detail--jun26 wishlist-button-product');
      if (wbp) {
        new MutationObserver(syncState).observe(wbp, { attributes: true, subtree: true, childList: true });
      }
      return true;
    }
    if (fillAll()) return;
    var mo = new MutationObserver(function () { if (fillAll()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); fillAll(); }, 30000);
  }

  // Selo do artista no stage (desktop): pill glass com foto P&B redonda,
  // nome em caps e "Artista · Cidade, País" (só país sem cidade; nada sem
  // país). Foto: assets/artista-<slug-da-collection>.jpg, fallback inicial.
  function buildArtistBadge(root) {
    var credit = root.querySelector('.jun26-wh-artist');
    var media = root.querySelector('.pp26-product-grid__media');
    if (!credit || !media || root.querySelector('.jun26-artist-badge')) return;
    var name = (credit.textContent || '').trim();
    if (!name) return;
    var loc = ARTIST_LOCATIONS[name];
    var sub = name === '1x.com' ? 'via 1x.com' : (loc ? 'Artista · ' + loc : 'Artista');
    var href = credit.getAttribute('href') || '';
    var m = href.match(/\/collections\/([^\/?#]+)/);
    var slug = m ? m[1] : name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    var cssLink = document.querySelector('link[href*="jun26"]');
    var base = cssLink ? cssLink.href.replace(/jun26[^\/]*\.css.*$/, '') : '';

    var badge = document.createElement(href ? 'a' : 'div');
    badge.className = 'jun26-artist-badge';
    if (href) badge.href = href;
    badge.innerHTML = ''
      + '<span class="jun26-artist-badge-avatar"><span class="jun26-artist-badge-initial"></span></span>'
      + '<span class="jun26-artist-badge-col">'
      + '<span class="jun26-artist-badge-name"></span>'
      + '<span class="jun26-artist-badge-sub"></span>'
      + '</span>';
    badge.querySelector('.jun26-artist-badge-name').textContent = name;
    badge.querySelector('.jun26-artist-badge-sub').textContent = sub;
    badge.querySelector('.jun26-artist-badge-initial').textContent = (name.charAt(0) || '').toUpperCase();
    if (base) {
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.addEventListener('error', function () { img.remove(); });
      img.src = base + 'artista-' + slug + '.jpg';
      badge.querySelector('.jun26-artist-badge-avatar').appendChild(img);
    }
    media.appendChild(badge);
  }

  // Evita a "caixa vazia" no load: a arte/moldura só aparecem quando a imagem
  // carrega (fade-in). Se a img já estiver carregada (cache), não mexe. Falha-
  // segura: se o JS não rodar, as imgs continuam visíveis (não esconde via CSS).
  function fadeGalleryImgs(root) {
    var imgs = root.querySelectorAll('.pp26__art, .pp26__frame');
    [].forEach.call(imgs, function (img) {
      if (img.complete && img.naturalWidth) return; // já carregada
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.25s ease';
      var show = function () { img.style.opacity = ''; };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    });
  }

  // === Editor de tipografia/estilo (?typeedit) =======================
  // Painel flutuante que edita fonte, peso, kerning, caixa (uppercase),
  // cor, fundo, border-radius, borda e padding de QUALQUER alvo nomeado
  // da PDP — ao vivo. Persiste em localStorage e exporta CSS pronto pra
  // colar no jun26.css. Tem conta-gotas ("PEGAR ESTILO") pra copiar a
  // fonte/estilo de outro elemento da página pro alvo atual.
  function setupTypeEdit() {
    var params = new URLSearchParams(location.search);
    if (!params.has('typeedit')) return;
    var SCOPE = '.thb-product-detail--jun26 ';
    var STORE = 'jun26_typeedit';

    var TEXT = ['family', 'size', 'weight', 'ls', 'lh', 'transform', 'style', 'color'];
    var BOX = ['bg', 'radius', 'bw', 'bcolor', 'padding'];
    var ALL = TEXT.concat(BOX);

    // sel é SEM o scope (prefixado na hora de aplicar/exportar). pseudo opcional.
    var TARGETS = [
      { k: 'secLabel', g: 'Configurador', label: 'Rótulo seção (MOLDURA/COR)', sel: '.jun26-acabamento-header', controls: TEXT },
      { k: 'secValue', g: 'Configurador', label: 'Valor seção (CANVAS…)', sel: '.jun26-label-value', controls: TEXT },
      { k: 'micro', g: 'Configurador', label: 'Descrição (microcopy)', sel: '.jun26-acabamento-micro', controls: TEXT },
      { k: 'tamLabel', g: 'Configurador', label: 'Rótulo "Tamanho"', sel: '.jun26-tamanho-header-new', pseudo: '::before', controls: TEXT },
      { k: 'tamValue', g: 'Configurador', label: 'Valor tamanho (30×42)', sel: '.jun26-tamanho-header-new', pseudo: '::after', controls: TEXT },
      { k: 'pillTxt', g: 'Pills moldura', label: 'Texto do pill', sel: '.jun26-pill-name', controls: TEXT },
      { k: 'pillBox', g: 'Pills moldura', label: 'Caixa do pill', sel: '.jun26-pill', controls: BOX },
      { k: 'pillBoxOn', g: 'Pills moldura', label: 'Caixa do pill ATIVO', sel: '.jun26-pill--active', controls: BOX },
      { k: 'badgeHot', g: 'Pills moldura', label: 'Badge "MAIS PEDIDO"', sel: '.jun26-pill-badge', controls: TEXT },
      { k: 'badgeNeu', g: 'Pills moldura', label: 'Badge "COM VIDRO"', sel: '.jun26-pill-badge--neutro', controls: TEXT },
      { k: 'chipTxt', g: 'Chips tamanho', label: 'Texto do chip', sel: '[data-handle="escolha-o-tamanho-(cm)"] label.jun26-size-chip', pseudo: '::before', controls: TEXT },
      { k: 'chipBox', g: 'Chips tamanho', label: 'Caixa do chip', sel: '[data-handle="escolha-o-tamanho-(cm)"] label.jun26-size-chip', controls: BOX },
      { k: 'chipTxtOn', g: 'Chips tamanho', label: 'Texto do chip ATIVO', sel: '[data-handle="escolha-o-tamanho-(cm)"] input[type="radio"]:checked + label.jun26-size-chip', pseudo: '::before', controls: TEXT },
      { k: 'chipBoxOn', g: 'Chips tamanho', label: 'Caixa do chip ATIVO', sel: '[data-handle="escolha-o-tamanho-(cm)"] input[type="radio"]:checked + label.jun26-size-chip', controls: BOX },
      { k: 'tgTxt', g: 'Toggle ambiente', label: 'QUADRO/AMBIENTE', sel: '.jun26-stage-toggle button', controls: ALL },
      { k: 'tgOn', g: 'Toggle ambiente', label: 'QUADRO/AMBIENTE ativo', sel: '.jun26-stage-toggle button.is-on', controls: ALL },
      { k: 'envTxt', g: 'Toggle ambiente', label: 'HALL/SALA/QUARTO…', sel: '.jun26-stage-envs button', controls: ALL },
      { k: 'envOn', g: 'Toggle ambiente', label: 'HALL/SALA… ativo', sel: '.jun26-stage-envs button.is-on', controls: ALL }
    ];
    var TMAP = {};
    TARGETS.forEach(function (t) { TMAP[t.k] = t; });

    // Alvos ad-hoc criados via "SELECIONAR" (seletor gerado do elemento clicado).
    var root0 = document.querySelector('.thb-product-detail--jun26');
    var CUSTOM = {};
    function getT(k) { return TMAP[k] || CUSTOM[k]; }
    function pre(t) { return t.noscope ? '' : SCOPE; }

    var PROP = {
      family: 'font-family', size: 'font-size', weight: 'font-weight',
      ls: 'letter-spacing', lh: 'line-height', transform: 'text-transform',
      style: 'font-style', color: 'color', bg: 'background',
      radius: 'border-radius', bw: 'border-width', bcolor: 'border-color',
      padding: 'padding'
    };
    var CTRL = {
      family: { kind: 'text', label: 'Fonte', list: true },
      size: { kind: 'num', label: 'Tamanho (px)', step: 0.5, min: 6, max: 56 },
      weight: { kind: 'select', label: 'Peso', opts: ['300', '400', '500', '600', '700', '800'] },
      ls: { kind: 'range', label: 'Kerning (em)', min: -0.05, max: 0.4, step: 0.005 },
      lh: { kind: 'text', label: 'Line-height' },
      transform: { kind: 'select', label: 'Caixa', opts: ['none', 'uppercase', 'lowercase', 'capitalize'] },
      style: { kind: 'select', label: 'Estilo', opts: ['normal', 'italic'] },
      color: { kind: 'color', label: 'Cor do texto' },
      bg: { kind: 'color', label: 'Fundo', allowNone: true },
      radius: { kind: 'num', label: 'Border-radius (px)', step: 1, min: 0, max: 999 },
      bw: { kind: 'num', label: 'Espessura borda (px)', step: 0.5, min: 0, max: 8 },
      bcolor: { kind: 'color', label: 'Cor da borda' },
      padding: { kind: 'text', label: 'Padding (ex. 9px 14px)' }
    };
    var FONTS = [
      '"Archivo", system-ui, sans-serif',
      '"Archivo Narrow", "Archivo", system-ui, sans-serif',
      'Georgia, "Times New Roman", serif',
      '"Courier New", monospace'
    ];

    function cssVal(ck, v) {
      if (v === '' || v == null) return null;
      v = String(v).trim();
      if (v === '') return null;
      if (ck === 'size' || ck === 'radius' || ck === 'bw') return /[a-z%]/i.test(v) ? v : v + 'px';
      if (ck === 'ls') return /[a-z%]/i.test(v) ? v : v + 'em';
      return v;
    }

    var state = (function () { try { return JSON.parse(localStorage.getItem(STORE) || '{}'); } catch (e) { return {}; } })();
    // restaura alvos custom persistidos
    Object.keys(state._custom || {}).forEach(function (k) { CUSTOM[k] = state._custom[k]; });
    function save() { localStorage.setItem(STORE, JSON.stringify(state)); }
    var curKey = (state._cur && getT(state._cur)) ? state._cur : TARGETS[0].k;

    var styleEl = document.getElementById('jun26-typeedit-style');
    if (!styleEl) { styleEl = document.createElement('style'); styleEl.id = 'jun26-typeedit-style'; document.head.appendChild(styleEl); }
    function rebuild() {
      var css = '';
      Object.keys(state).forEach(function (k) {
        var t = getT(k); if (!t) return;
        var o = state[k]; var decls = [];
        Object.keys(o).forEach(function (ck) {
          var cv = cssVal(ck, o[ck]); if (cv == null) return;
          decls.push(PROP[ck] + ':' + cv + ' !important');
        });
        if (decls.length) css += pre(t) + t.sel + (t.pseudo || '') + '{' + decls.join(';') + '}\n';
      });
      styleEl.textContent = css;
    }
    rebuild();

    function compVal(t, ck) {
      var p = pre(t);
      var el = document.querySelector(p + t.sel.replace(/:checked/g, '').replace(/\s*\+\s*/g, ' '));
      if (!el) el = document.querySelector(p + t.sel.split(' ').pop());
      if (!el) return '';
      var cs = getComputedStyle(el, t.pseudo || undefined);
      var fs = parseFloat(cs.fontSize) || 16;
      switch (ck) {
        case 'family': return cs.fontFamily;
        case 'size': return Math.round(fs * 10) / 10;
        case 'weight': return String(parseInt(cs.fontWeight, 10) || 400);
        case 'ls': var l = cs.letterSpacing === 'normal' ? 0 : parseFloat(cs.letterSpacing) || 0; return Math.round((l / fs) * 1000) / 1000;
        case 'lh': return cs.lineHeight;
        case 'transform': return cs.textTransform;
        case 'style': return cs.fontStyle;
        case 'color': return cs.color;
        case 'bg': return '';
        case 'radius': return Math.round(parseFloat(cs.borderTopLeftRadius) || 0);
        case 'bw': return Math.round((parseFloat(cs.borderTopWidth) || 0) * 10) / 10;
        case 'bcolor': return cs.borderTopColor;
        case 'padding': return cs.padding;
      }
      return '';
    }
    function dispVal(t, ck) {
      if (state[t.k] && state[t.k][ck] != null) return state[t.k][ck];
      return compVal(t, ck);
    }
    function rgbToHex(c) {
      var m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(c || '');
      if (!m) return /^#/.test(c) ? c : '#000000';
      return '#' + [m[1], m[2], m[3]].map(function (n) { return ('0' + (+n).toString(16)).slice(-2); }).join('');
    }
    function esc(s) { return String(s).replace(/"/g, '&quot;'); }

    function renderControls() {
      var t = getT(curKey);
      var html = '';
      t.controls.forEach(function (ck) {
        var c = CTRL[ck]; var v = dispVal(t, ck);
        html += '<div style="margin-bottom:9px">';
        html += '<label style="display:block;font-size:9px;letter-spacing:.04em;color:#888;margin-bottom:3px;text-transform:uppercase">' + c.label + '</label>';
        if (c.kind === 'num') {
          html += '<input type="number" data-ck="' + ck + '" value="' + esc(v) + '" step="' + c.step + '" min="' + c.min + '" max="' + c.max + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
        } else if (c.kind === 'range') {
          html += '<div style="display:flex;align-items:center;gap:8px">'
            + '<input type="range" data-ck="' + ck + '" value="' + esc(v) + '" min="' + c.min + '" max="' + c.max + '" step="' + c.step + '" style="flex:1">'
            + '<input type="text" class="te-ro" data-ro="' + ck + '" value="' + (+v).toFixed(3) + '" title="digite/copie o valor em em" style="width:60px;padding:5px 6px;border:1px solid #ddd;border-radius:3px;font:11px monospace;text-align:right">'
            + '<span style="font:10px monospace;color:#999">em</span>'
            + '</div>';
        } else if (c.kind === 'select') {
          html += '<select data-ck="' + ck + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
          c.opts.forEach(function (o) { html += '<option value="' + o + '"' + (String(v) === o ? ' selected' : '') + '>' + o + '</option>'; });
          html += '</select>';
        } else if (c.kind === 'color') {
          html += '<div style="display:flex;gap:6px;align-items:center">';
          html += '<input type="color" data-ckc="' + ck + '" value="' + rgbToHex(v) + '" style="width:34px;height:30px;padding:0;border:1px solid #ddd;border-radius:3px;cursor:pointer">';
          html += '<input type="text" data-ck="' + ck + '" value="' + esc(v) + '"' + (c.allowNone ? ' placeholder="none / #hex / rgb()"' : '') + ' style="flex:1;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:11px monospace">';
          html += '</div>';
        } else {
          html += '<input type="text" data-ck="' + ck + '"' + (c.list ? ' list="jun26-te-fonts"' : '') + ' value="' + esc(v) + '" style="width:100%;padding:5px 7px;border:1px solid #ddd;border-radius:3px;font:12px Archivo">';
        }
        html += '</div>';
      });
      var body = panel.querySelector('#te-controls');
      body.innerHTML = html;
      body.querySelectorAll('[data-ck]').forEach(function (inp) {
        var ev = (inp.tagName === 'SELECT' || inp.type === 'range') ? 'input' : 'input';
        inp.addEventListener(ev, onEdit);
        if (inp.tagName !== 'SELECT') inp.addEventListener('change', onEdit);
      });
      body.querySelectorAll('[data-ckc]').forEach(function (pick) {
        pick.addEventListener('input', function () {
          var ck = pick.getAttribute('data-ckc');
          var txt = body.querySelector('input[data-ck="' + ck + '"]');
          if (txt) { txt.value = pick.value; onEditVal(ck, pick.value); }
        });
      });
      // campo de texto do kerning (range): digita/cola o valor, sincroniza o slider
      body.querySelectorAll('[data-ro]').forEach(function (ro) {
        ro.addEventListener('input', function () {
          var ck = ro.getAttribute('data-ro');
          var rng = body.querySelector('input[type="range"][data-ck="' + ck + '"]');
          if (rng && ro.value !== '' && !isNaN(+ro.value)) rng.value = ro.value;
          onEditVal(ck, ro.value);
        });
      });
    }
    function onEditVal(ck, v) {
      var o = state[curKey] = state[curKey] || {};
      if (v === '' || v == null) delete o[ck]; else o[ck] = v;
      if (Object.keys(o).length === 0) delete state[curKey];
      save(); rebuild();
    }
    function onEdit(e) {
      var ck = e.target.getAttribute('data-ck');
      onEditVal(ck, e.target.value);
      if (e.target.type === 'range') {
        var ro = e.target.parentNode.querySelector('.te-ro');
        if (ro) ro.value = (+e.target.value).toFixed(3);
      }
    }

    function grabFrom(el) {
      var cs = getComputedStyle(el);
      var t = getT(curKey);
      var fs = parseFloat(cs.fontSize) || 16;
      var src = {
        family: cs.fontFamily,
        size: Math.round(fs * 10) / 10,
        weight: String(parseInt(cs.fontWeight, 10) || 400),
        ls: Math.round(((cs.letterSpacing === 'normal' ? 0 : parseFloat(cs.letterSpacing) || 0) / fs) * 1000) / 1000,
        lh: cs.lineHeight,
        transform: cs.textTransform,
        style: cs.fontStyle,
        color: cs.color
      };
      var o = state[curKey] = state[curKey] || {};
      Object.keys(src).forEach(function (ck) { if (t.controls.indexOf(ck) >= 0) o[ck] = src[ck]; });
      save(); rebuild(); renderControls();
    }
    function startPick() {
      panel.style.opacity = '0.2'; panel.style.pointerEvents = 'none';
      var hi = document.createElement('div');
      hi.style.cssText = 'position:fixed;pointer-events:none;z-index:99998;border:2px solid #7c3aed;background:rgba(124,58,237,.12);transition:all 40ms';
      document.body.appendChild(hi);
      var tip = document.createElement('div');
      tip.textContent = 'Clique no elemento pra copiar a fonte · ESC cancela';
      tip.style.cssText = 'position:fixed;top:12px;left:50%;transform:translateX(-50%);background:#7c3aed;color:#fff;font:11px Archivo;padding:6px 12px;border-radius:999px;z-index:99999;pointer-events:none';
      document.body.appendChild(tip);
      var last = null;
      function mm(e) { var el = document.elementFromPoint(e.clientX, e.clientY); if (!el || el === hi || el === tip) return; last = el; var r = el.getBoundingClientRect(); hi.style.left = r.left + 'px'; hi.style.top = r.top + 'px'; hi.style.width = r.width + 'px'; hi.style.height = r.height + 'px'; }
      function clk(e) { e.preventDefault(); e.stopPropagation(); var el = last || document.elementFromPoint(e.clientX, e.clientY); cleanup(); if (el) grabFrom(el); }
      function key(e) { if (e.key === 'Escape') cleanup(); }
      function cleanup() { panel.style.opacity = ''; panel.style.pointerEvents = ''; hi.remove(); tip.remove(); document.removeEventListener('mousemove', mm, true); document.removeEventListener('click', clk, true); document.removeEventListener('keydown', key, true); }
      document.addEventListener('mousemove', mm, true);
      document.addEventListener('click', clk, true);
      document.addEventListener('keydown', key, true);
    }

    // Gera um seletor a partir do elemento clicado (id ou tag.classes, sem
    // classes de estado voláteis). noscope=true se o elemento estiver fora do
    // container da PDP (aplica/exporta sem o prefixo .thb-product-detail--jun26).
    function selFor(el) {
      var inside = !!(root0 && root0.contains(el));
      if (el.id) return { sel: '#' + el.id, noscope: !inside };
      var cls = (el.getAttribute('class') || '').trim().split(/\s+/).filter(Boolean)
        .filter(function (c) { return !/^(is-on|active|selected|jun26-ready|jun26-amb-on|jun26-amb-active|swiper-|slick-|pp26-gallery--ready)/.test(c); });
      return { sel: el.tagName.toLowerCase() + (cls.length ? '.' + cls.join('.') : ''), noscope: !inside };
    }
    function makeCustom(el) {
      var info = selFor(el);
      var existing = TARGETS.filter(function (t) { return t.sel === info.sel && !t.pseudo; })[0];
      if (existing) { curKey = existing.k; }
      else {
        var dup = Object.keys(CUSTOM).filter(function (k) { return CUSTOM[k].sel === info.sel && !!CUSTOM[k].noscope === info.noscope; })[0];
        if (dup) { curKey = dup; }
        else {
          var key = 'custom_' + (Object.keys(CUSTOM).length + 1);
          var label = (info.noscope ? '⌖ ' : '') + (info.sel.length > 30 ? info.sel.slice(0, 29) + '…' : info.sel);
          CUSTOM[key] = { k: key, sel: info.sel, noscope: info.noscope, label: label, controls: ALL };
          state._custom = state._custom || {};
          state._custom[key] = CUSTOM[key];
          curKey = key;
        }
      }
      state._cur = curKey; save();
      refreshDropdown(); renderControls();
    }
    function startPickEdit() {
      panel.style.opacity = '0.2'; panel.style.pointerEvents = 'none';
      var hi = document.createElement('div');
      hi.style.cssText = 'position:fixed;pointer-events:none;z-index:99998;border:2px solid #0ea5a3;background:rgba(14,165,163,.14);transition:all 40ms';
      document.body.appendChild(hi);
      var tip = document.createElement('div');
      tip.textContent = 'Clique no elemento pra EDITAR · ESC cancela';
      tip.style.cssText = 'position:fixed;top:12px;left:50%;transform:translateX(-50%);background:#0ea5a3;color:#fff;font:11px Archivo;padding:6px 12px;border-radius:999px;z-index:99999;pointer-events:none';
      document.body.appendChild(tip);
      var last = null;
      function mm(e) { var el = document.elementFromPoint(e.clientX, e.clientY); if (!el || el === hi || el === tip) return; last = el; var r = el.getBoundingClientRect(); hi.style.left = r.left + 'px'; hi.style.top = r.top + 'px'; hi.style.width = r.width + 'px'; hi.style.height = r.height + 'px'; }
      function clk(e) { e.preventDefault(); e.stopPropagation(); var el = last || document.elementFromPoint(e.clientX, e.clientY); cleanup(); if (el) makeCustom(el); }
      function key(e) { if (e.key === 'Escape') cleanup(); }
      function cleanup() { panel.style.opacity = ''; panel.style.pointerEvents = ''; hi.remove(); tip.remove(); document.removeEventListener('mousemove', mm, true); document.removeEventListener('click', clk, true); document.removeEventListener('keydown', key, true); }
      document.addEventListener('mousemove', mm, true);
      document.addEventListener('click', clk, true);
      document.addEventListener('keydown', key, true);
    }

    function exportCSS() {
      var css = '/* ===== typeedit — colar no assets/jun26.css ===== */\n';
      Object.keys(state).forEach(function (k) {
        var t = getT(k); if (!t) return; var o = state[k]; var decls = [];
        Object.keys(o).forEach(function (ck) { var cv = cssVal(ck, o[ck]); if (cv == null) return; decls.push('  ' + PROP[ck] + ': ' + cv + ' !important;'); });
        if (decls.length) css += pre(t) + t.sel + (t.pseudo || '') + ' {\n' + decls.join('\n') + '\n}\n';
      });
      return css;
    }

    var panel = document.createElement('div');
    panel.id = 'jun26-typeedit';
    panel.style.cssText = 'position:fixed;top:70px;right:18px;background:#fff;border:1px solid #111;border-radius:6px;z-index:99990;font:12px Archivo,system-ui,sans-serif;width:300px;box-shadow:0 10px 30px rgba(0,0,0,.18);display:flex;flex-direction:column;max-height:88vh';
    var groups = [];
    TARGETS.forEach(function (t) { if (groups.indexOf(t.g) < 0) groups.push(t.g); });
    function buildOpts() {
      var html = groups.map(function (g) {
        return '<optgroup label="' + g + '">' + TARGETS.filter(function (t) { return t.g === g; }).map(function (t) {
          return '<option value="' + t.k + '"' + (t.k === curKey ? ' selected' : '') + '>' + t.label + '</option>';
        }).join('') + '</optgroup>';
      }).join('');
      var ck = Object.keys(CUSTOM);
      if (ck.length) {
        html += '<optgroup label="✏️ Selecionados">' + ck.map(function (k) {
          return '<option value="' + k + '"' + (k === curKey ? ' selected' : '') + '>' + esc(CUSTOM[k].label) + '</option>';
        }).join('') + '</optgroup>';
      }
      return html;
    }
    function refreshDropdown() {
      var sel = panel.querySelector('#te-target');
      if (sel) { sel.innerHTML = buildOpts(); sel.value = curKey; }
    }
    var optsHtml = buildOpts();
    panel.innerHTML = ''
      + '<div id="te-head" style="display:flex;align-items:center;justify-content:space-between;padding:11px 12px;border-bottom:1px solid #eee;cursor:move">'
      + '<b style="font-size:11px;letter-spacing:.1em;text-transform:uppercase">Editor de estilo</b>'
      + '<button id="te-x" style="width:22px;height:22px;border:none;background:transparent;cursor:pointer;font-size:16px;color:#999;line-height:1">×</button>'
      + '</div>'
      + '<div style="padding:11px 12px 0">'
      + '<button id="te-select" style="width:100%;padding:8px;margin-bottom:7px;background:#0ea5a3;color:#fff;border:none;border-radius:4px;cursor:pointer;font:11px Archivo;letter-spacing:.04em">✏️ SELECIONAR ELEMENTO</button>'
      + '<select id="te-target" style="width:100%;padding:6px 7px;border:1px solid #ccc;border-radius:4px;font:12px Archivo;margin-bottom:9px">' + optsHtml + '</select>'
      + '<div style="display:flex;gap:5px;margin-bottom:10px">'
      + '<button id="te-pick" style="flex:1;padding:6px 4px;background:#7c3aed;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.04em">🎯 PEGAR ESTILO</button>'
      + '<button id="te-refresh" title="Re-ler valores atuais" style="padding:6px 9px;background:#f4f4f5;border:1px solid #ddd;border-radius:4px;cursor:pointer;font:11px Archivo">↻</button>'
      + '<button id="te-reset" title="Resetar este alvo" style="padding:6px 9px;background:#f4f4f5;border:1px solid #ddd;border-radius:4px;cursor:pointer;font:10px Archivo">RESET</button>'
      + '</div>'
      + '</div>'
      + '<div id="te-controls" style="padding:0 12px;overflow:auto;flex:1"></div>'
      + '<div style="padding:10px 12px;border-top:1px solid #eee">'
      + '<div style="display:flex;gap:5px">'
      + '<button id="te-export" style="flex:1;padding:7px;background:#111;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.05em">EXPORTAR CSS</button>'
      + '<button id="te-resetall" style="padding:7px 9px;background:#fff;border:1px solid #d33;color:#d33;border-radius:4px;cursor:pointer;font:10px Archivo">LIMPAR TUDO</button>'
      + '</div>'
      + '<textarea id="te-out" readonly style="display:none;width:100%;height:120px;margin-top:8px;font:10px monospace;border:1px solid #ddd;border-radius:4px;padding:6px;resize:vertical;box-sizing:border-box"></textarea>'
      + '</div>'
      + '<datalist id="jun26-te-fonts">' + FONTS.map(function (f) { return '<option value="' + esc(f) + '">'; }).join('') + '</datalist>';
    document.body.appendChild(panel);

    panel.querySelector('#te-target').addEventListener('change', function () { curKey = this.value; state._cur = curKey; save(); renderControls(); });
    panel.querySelector('#te-select').addEventListener('click', startPickEdit);
    panel.querySelector('#te-pick').addEventListener('click', startPick);
    panel.querySelector('#te-refresh').addEventListener('click', renderControls);
    panel.querySelector('#te-reset').addEventListener('click', function () { delete state[curKey]; save(); rebuild(); renderControls(); });
    panel.querySelector('#te-resetall').addEventListener('click', function () {
      if (!confirm('Limpar TODOS os overrides do typeedit?')) return;
      Object.keys(state).forEach(function (k) { if (k !== '_cur') delete state[k]; });
      CUSTOM = {};
      curKey = (getT(state._cur)) ? state._cur : TARGETS[0].k;
      state._cur = curKey;
      save(); rebuild(); refreshDropdown(); renderControls();
    });
    panel.querySelector('#te-export').addEventListener('click', function () {
      var out = panel.querySelector('#te-out'); out.value = exportCSS(); out.style.display = 'block'; out.select();
      if (navigator.clipboard) navigator.clipboard.writeText(out.value);
      this.textContent = 'COPIADO ✓'; var b = this; setTimeout(function () { b.textContent = 'EXPORTAR CSS'; }, 1400);
    });
    panel.querySelector('#te-x').addEventListener('click', function () {
      panel.style.display = 'none';
      var op = document.createElement('button');
      op.textContent = 'ESTILO'; op.style.cssText = 'position:fixed;top:70px;right:18px;padding:7px 11px;background:#111;color:#fff;border:none;border-radius:4px;cursor:pointer;font:10px Archivo;letter-spacing:.08em;z-index:99990';
      op.onclick = function () { panel.style.display = ''; op.remove(); };
      document.body.appendChild(op);
    });

    // arrastar pelo header
    (function () {
      var head = panel.querySelector('#te-head'), drag = false, sx, sy, sl, st2;
      head.addEventListener('mousedown', function (e) {
        if (e.target.tagName === 'BUTTON') return;
        drag = true; sx = e.clientX; sy = e.clientY;
        var r = panel.getBoundingClientRect(); sl = r.left; st2 = r.top;
        panel.style.right = 'auto'; e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!drag) return;
        panel.style.left = Math.max(0, Math.min(window.innerWidth - 120, sl + e.clientX - sx)) + 'px';
        panel.style.top = Math.max(0, Math.min(window.innerHeight - 40, st2 + e.clientY - sy)) + 'px';
      });
      document.addEventListener('mouseup', function () { drag = false; });
    })();

    renderControls();
    // O configurador (pills/chips) e os toggles de ambiente são injetados
    // DEPOIS deste setup (via setTimeout no init). Re-lê os valores computados
    // algumas vezes pra preencher os campos quando os alvos aparecerem.
    // Seguro: dispVal prioriza override do usuário, então edições persistem.
    [200, 500, 1000, 2000].forEach(function (ms) { setTimeout(renderControls, ms); });
  }

  // Tap-to-zoom (MOBILE): tocar no palco amplia EXATAMENTE a vista atual —
  // QUADRO → quadro com moldura; AMBIENTE → cômodo com a arte. Faz isso clonando
  // o nó visível e escalando com transform:scale (o clone recebe os estilos
  // COMPUTADOS inline, então independe de CSS scope). No ambiente, mostra as
  // pills HALL/SALA/QUARTO/JANTAR pra trocar de cômodo sem fechar. Desktop não
  // é afetado (gated por matchMedia). Toggle/pills do palco são ignorados no tap.
  function setupArtZoom(root) {
    var mqMobile = window.matchMedia('(max-width: 959px)');
    var media = function () { return root.querySelector('.pp26-product-grid__media'); };
    function isAmb() { var m = media(); return !!(m && m.classList.contains('jun26-amb-on')); }
    function srcNode() {
      return isAmb() ? root.querySelector('.jun26-amb') : root.querySelector('.pp26__perspective-stage');
    }
    function artSrc() {
      var a = root.querySelector('.pp26__art');
      var s = a && a.getAttribute('src');
      if (!s) return null;
      if (/[?&]width=/.test(s)) return s.replace(/([?&]width=)\d+/, function (m, p1) { return p1 + '1600'; });
      return s + (s.indexOf('?') < 0 ? '?' : '&') + 'width=1600';
    }
    function isSemMoldura() {
      var a = root.querySelector('.jun26-pill--active .jun26-pill-name');
      return !!(a && /sem\s*moldura/i.test(a.textContent));
    }
    // copia estilos computados (props visuais) do src pro clone, em toda a árvore
    var COPY = ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'box-sizing',
      'transform', 'transform-origin', 'perspective', 'perspective-origin', 'transform-style',
      'clip-path', '-webkit-clip-path',
      'background-color', 'background-image', 'background-size', 'background-position', 'background-repeat', 'background-blend-mode',
      'box-shadow', 'opacity', 'mix-blend-mode', 'filter', '-webkit-filter',
      'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
      'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style',
      'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
      'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius',
      'object-fit', 'object-position', 'overflow', 'z-index', 'display'];
    function copyComputed(src, clone) {
      var a = [src].concat([].slice.call(src.querySelectorAll('*')));
      var b = [clone].concat([].slice.call(clone.querySelectorAll('*')));
      for (var i = 0; i < a.length && i < b.length; i++) {
        var cs = getComputedStyle(a[i]);
        for (var j = 0; j < COPY.length; j++) {
          var v = cs.getPropertyValue(COPY[j]);
          if (v) b[i].style.setProperty(COPY[j], v);
        }
      }
    }
    function buildAmbClone() {
      var src = srcNode();
      if (!src) return null;
      // IMPORTANTE: usar o tamanho de LAYOUT (offsetWidth/Height), NÃO o
      // getBoundingClientRect — o palco QUADRO tem scale(0.95) embutido, então o
      // rect vem já escalado (327.75 em vez de 345). O warp matrix3d da arte foi
      // calculado pra caixa de layout (345); dimensionar o clone pelo rect
      // escalado desregistrava a arte da moldura. offset* ignora o transform.
      var ow = src.offsetWidth, oh = src.offsetHeight;
      if (!ow || !oh) return null;
      var clone = src.cloneNode(true);
      copyComputed(src, clone);
      // tex/vao não clonam bem (deslocam p/ -255% e geram o artefato de "linha")
      ['.jun26-amb-tex', '.jun26-amb-vao'].forEach(function (s) { var e = clone.querySelector(s); if (e) e.remove(); });
      // raiz: vira bloco relativo no tamanho de LAYOUT, sem o transform original
      clone.style.setProperty('position', 'relative');
      ['top', 'left', 'right', 'bottom'].forEach(function (p) { clone.style.setProperty(p, 'auto'); });
      clone.style.setProperty('margin', '0');
      clone.style.setProperty('display', 'block');
      clone.style.setProperty('width', ow + 'px');
      clone.style.setProperty('height', oh + 'px');
      clone.style.setProperty('visibility', 'visible');
      clone.style.setProperty('transform-origin', 'center center');
      // sem borda/cantos arredondados no zoom (full-bleed, sem moldura de card)
      clone.style.setProperty('border', '0', 'important');
      clone.style.setProperty('border-radius', '0', 'important');
      clone.style.setProperty('box-shadow', 'none', 'important');
      clone.style.setProperty('background', '#F1EFEA', 'important'); // mesmo cinza do stage
      clone.style.setProperty('touch-action', 'none'); // garante pan com o dedo
      clone._w = ow; clone._h = oh;
      return clone;
    }
    function open() {
      if (!mqMobile.matches) return; // este lightbox é SÓ mobile (desktop terá outro zoom)
      if (document.querySelector('.jun26-artzoom')) return;
      var amb = isAmb();
      var ov = document.createElement('div');
      ov.className = 'jun26-artzoom';
      ov.innerHTML = '<button class="jun26-artzoom__close" type="button" aria-label="Fechar">'
        + '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 5 L19 19 M19 5 L5 19"/></svg>'
        + '</button>'
        + '<div class="jun26-artzoom__stage"></div>'
        + (amb ? '<div class="jun26-artzoom__envs"></div>' : '');
      document.body.appendChild(ov);
      document.documentElement.style.overflow = 'hidden';

      // Controlador de gestos (Pointer Events): 1 dedo = pan · 2 dedos =
      // pinch-zoom (ponto sob o midpoint fixo) · duplo-toque = alterna fit/zoom.
      // Transições smooth: anima no double-tap/snap/início, mas durante o
      // pan/pinch a transição é desligada (manipulação direta, 1:1, sem lag).
      function attachGesture(st, el, cw, ch, qcx, qcy, qw, qh, baseFactor, initMul, tx0, ty0) {
        var vw = window.innerWidth, vh = window.innerHeight;
        var SMOOTH = 'transform .34s cubic-bezier(.22,1,.36,1)';
        var minS = baseFactor, maxS = baseFactor * 4;
        var scale = Math.min(maxS, baseFactor * initMul);
        var tx = 0, ty = 0;
        function center() { tx = -(qcx - cw / 2) * scale; ty = -(qcy - ch / 2) * scale; }
        // Clamp pelo CONTEÚDO inteiro (não só pela região do quadro) — assim no
        // QUADRO dá pra arrastar além da moldura e ver um pedaço do stage/parede.
        function clampT() {
          var moX = Math.max(0, cw * scale / 2 - vw / 2), moY = Math.max(0, ch * scale / 2 - vh / 2);
          tx = Math.max(-moX, Math.min(moX, tx));
          ty = Math.max(-moY, Math.min(moY, ty));
        }
        function apply() { el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
        el.style.transition = 'none';
        // tx0/ty0 = posição inicial explícita (ancorar o quadro no relX do stage).
        if (typeof tx0 === 'number') { tx = tx0; ty = (typeof ty0 === 'number' ? ty0 : 0); clampT(); }
        else { center(); }
        apply();
        requestAnimationFrame(function () { el.style.transition = SMOOTH; });
        st.style.cursor = 'grab';
        var pts = {}, pinch = null, lastTap = 0;
        function pcount() { var n = 0, k; for (k in pts) n++; return n; }
        st.onpointerdown = function (e) {
          pts[e.pointerId] = { x: e.clientX, y: e.clientY };
          try { st.setPointerCapture(e.pointerId); } catch (x) { }
          var ids = []; for (var k in pts) ids.push(k);
          if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]]; pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y) }; }
          el.style.transition = 'none'; // pan/pinch = direto, sem lag
          st.style.cursor = 'grabbing';
        };
        st.onpointermove = function (e) {
          if (!pts[e.pointerId]) return;
          var ids = []; for (var k in pts) ids.push(k);
          if (ids.length === 1) {
            var p = pts[e.pointerId];
            tx += e.clientX - p.x; ty += e.clientY - p.y;
            p.x = e.clientX; p.y = e.clientY;
            clampT(); apply();
          } else if (ids.length >= 2) {
            pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY;
            var a = pts[ids[0]], b = pts[ids[1]];
            var dist = Math.hypot(a.x - b.x, a.y - b.y);
            var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
            if (!pinch) { pinch = { dist: dist }; return; }
            var ns = Math.max(minS, Math.min(maxS, scale * dist / pinch.dist));
            var clmx = cw / 2 + (mx - vw / 2 - tx) / scale, clmy = ch / 2 + (my - vh / 2 - ty) / scale;
            scale = ns;
            tx = mx - vw / 2 - (clmx - cw / 2) * scale;
            ty = my - vh / 2 - (clmy - ch / 2) * scale;
            pinch.dist = dist; clampT(); apply();
          }
        };
        st.onpointerup = function (e) {
          delete pts[e.pointerId];
          if (pcount() < 2) pinch = null;
          if (pcount() === 0) {
            st.style.cursor = 'grab';
            el.style.transition = SMOOTH; // snap/double-tap animam
            var now = e.timeStamp || 0;
            if (now - lastTap < 300) { // duplo-toque: alterna fit ↔ zoom
              scale = (Math.abs(scale - minS) < 0.01) ? Math.min(maxS, baseFactor * Math.max(1.5, initMul)) : minS;
              center(); clampT(); apply(); lastTap = 0;
            } else { clampT(); apply(); lastTap = now; }
          }
        };
      }

      // Monta uma CAMADA nova (absoluta, full-screen) com o conteúdo do modo
      // atual. crossfade=true sobrepõe à camada antiga e dissolve (sem flash do
      // fundo — UX 2026: mesmo efeito da View Transitions API, manual p/ suporte
      // universal). As camadas coexistem; a antiga é removida após o fade.
      function renderStage(crossfade) {
        var st = ov.querySelector('.jun26-artzoom__stage');
        var vw = window.innerWidth, vh = window.innerHeight;
        var isPoster = (!amb && isSemMoldura());
        var el, cw, ch;
        if (isPoster) {
          el = document.createElement('img');
          var s = artSrc(); if (s) el.src = s;
          var ra = root.querySelector('.pp26__art');
          cw = (ra && ra.naturalWidth) || 1000; ch = (ra && ra.naturalHeight) || 1400;
          el.style.cssText = 'display:block;width:' + cw + 'px;height:' + ch + 'px;max-width:none;max-height:none;touch-action:none;-webkit-user-drag:none;user-select:none';
        } else {
          el = buildAmbClone(); if (!el) return; cw = el._w; ch = el._h;
        }
        var layer = document.createElement('div');
        layer.className = 'jun26-artzoom__layer';
        layer.appendChild(el);
        var olds = [].slice.call(st.children);
        if (crossfade) { layer.style.opacity = '0'; st.appendChild(layer); }
        else { st.innerHTML = ''; st.appendChild(layer); }
        // parâmetros de enquadramento
        var qcx, qcy, qw, qh, baseFactor, initMul, tx0 = null;
        if (isPoster) {
          // cover: obra inteira preenchendo a tela
          qw = cw; qh = ch; qcx = cw / 2; qcy = ch / 2;
          baseFactor = Math.max(vw / cw, vh / ch); initMul = 1;
        } else if (amb) {
          // cover (cômodo inteiro) + ANCORA o quadro no mesmo X relativo do stage
          // (stage e viewport têm a MESMA largura, então o quadro cai no mesmo px).
          qw = cw; qh = ch; qcx = cw / 2; qcy = ch / 2;
          baseFactor = Math.max(vw / cw, vh / ch); initMul = 1;
          var qd = el.querySelector('.jun26-amb-quadro');
          if (qd) {
            var cr2 = el.getBoundingClientRect(), qr2 = qd.getBoundingClientRect();
            var qsx = (qr2.left - cr2.left) + qr2.width / 2;
            tx0 = qsx - vw / 2 - (qsx - cw / 2) * baseFactor;
          }
        } else {
          var qx = 0, qy = 0; qw = cw; qh = ch;
          var artEl = el.querySelector('.pp26__art');
          if (artEl) {
            var cr0 = el.getBoundingClientRect(), ar0 = artEl.getBoundingClientRect();
            var pad = 0.14, aw = ar0.width, ah = ar0.height;
            qx = (ar0.left - cr0.left) - aw * pad; qy = (ar0.top - cr0.top) - ah * pad;
            qw = aw * (1 + 2 * pad); qh = ah * (1 + 2 * pad);
          }
          qcx = qx + qw / 2; qcy = qy + qh / 2;
          baseFactor = Math.min((vw - 20) / qw, (vh - 80) / qh); initMul = 1.5; // abre 1.5x
        }
        attachGesture(st, el, cw, ch, qcx, qcy, qw, qh, baseFactor, initMul, tx0);
        if (crossfade) {
          requestAnimationFrame(function () { layer.style.opacity = '1'; olds.forEach(function (o) { o.style.opacity = '0'; }); });
          setTimeout(function () { olds.forEach(function (o) { if (o.parentNode) o.remove(); }); }, 380);
        }
      }
      function renderEnvs() {
        if (!amb) return;
        var box = ov.querySelector('.jun26-artzoom__envs');
        var realEnvs = root.querySelector('.jun26-stage-envs');
        if (!realEnvs) { box.style.display = 'none'; return; }
        var realBtns = [].slice.call(realEnvs.querySelectorAll('button'));
        var bar = document.createElement('div');
        bar.style.cssText = 'display:inline-flex;gap:2px;padding:4px;border-radius:999px;background:rgba(40,40,40,.55);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);box-shadow:0 6px 20px rgba(0,0,0,.35)';
        realBtns.forEach(function (rb) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = rb.textContent;
          var on = rb.classList.contains('is-on');
          b.style.cssText = 'font:600 11px Archivo,system-ui,sans-serif;letter-spacing:.08em;padding:8px 14px;border:0;border-radius:999px;cursor:pointer;white-space:nowrap;transition:background .2s,color .2s;' + (on ? 'background:#fff;color:#141414' : 'background:transparent;color:#fff');
          b.addEventListener('click', function () {
            // posição do quadro ANTES de trocar (pra detectar quando atualizou)
            function qkey() {
              var q = root.querySelector('.jun26-amb-quadro');
              if (!q) return '';
              var r = q.getBoundingClientRect();
              return Math.round(r.top) + ',' + Math.round(r.left) + ',' + Math.round(r.height);
            }
            var key0 = qkey();
            rb.click();                       // troca o ambiente de verdade
            renderEnvs();                     // atualiza o estado ativo das pills já
            // CLONA SÓ QUANDO o composite real ESTABILIZOU no novo ambiente. O
            // setMode roda um layout() INTERMEDIÁRIO (foto antiga) e o layout
            // FINAL só no 'load' da nova foto (--amb-aspect muda a altura). Então
            // espero a posição do quadro ficar IGUAL por 3 frames + foto pronta.
            var done = false, tries = 0, stable = 0, last = '';
            function finish() { if (done) return; done = true; renderStage(true); }
            function poll() {
              if (done) return;
              var photo = root.querySelector('.jun26-amb-photo');
              var ready = photo && photo.complete && photo.naturalWidth > 0;
              var k = qkey();
              if (k && k !== key0 && k === last) stable++; else stable = 0;
              last = k;
              if ((ready && stable >= 3) || tries > 90) finish();
              else { tries++; requestAnimationFrame(poll); }
            }
            requestAnimationFrame(poll);
          });
          bar.appendChild(b);
        });
        box.innerHTML = '';
        box.appendChild(bar);
      }
      renderStage();
      renderEnvs();
      void ov.offsetWidth;
      ov.classList.add('is-open');

      function close() {
        ov.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { ov.remove(); }, 220);
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      ov.addEventListener('click', function (e) {
        if (e.target === ov
          || (e.target.closest && e.target.closest('.jun26-artzoom__close'))
          || e.target.classList.contains('jun26-artzoom__stage')) close();
      });
      document.addEventListener('keydown', onKey);
    }
    function bind(el) {
      if (!el || el._artzoom) return;
      el._artzoom = true;
      // cursor zoom-in só no mobile (no desktop o zoom é outro; cursor enganoso)
      if (mqMobile.matches) el.style.cursor = 'zoom-in';
      el.addEventListener('click', function (e) {
        if (!mqMobile.matches) return;
        // tap em TODO o stage abre o zoom — exceto controles (toggle / pills /
        // botão expandir / grabber do sheet).
        if (e.target.closest('.jun26-stage-toggle, .jun26-stage-envs, .jun26-zoom-btn, .jun26-sheet-grip')) return;
        open();
      });
    }
    // Botão "expandir" no canto do palco (afordância de zoom). Glass escuro,
    // mesmo estilo das pills. Abre o mesmo lightbox do tap.
    function ensureZoomBtn() {
      var media = root.querySelector('.pp26-product-grid__media');
      if (!media) return;
      var b = media.querySelector('.jun26-zoom-btn');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'jun26-zoom-btn';
        b.setAttribute('aria-label', 'Ampliar');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>';
        b.addEventListener('click', function (e) { e.stopPropagation(); open(); });
        media.appendChild(b);
      }
      // mesma altura do toggle QUADRO/AMBIENTE (re-mede a cada retry)
      var tg = root.querySelector('.jun26-stage-toggle');
      if (tg) { var h = tg.offsetHeight; if (h) { b.style.width = h + 'px'; b.style.height = h + 'px'; } }
    }
    var tries = 0;
    (function retry() {
      // binda a COLUNA DE MÍDIA inteira (parede + quadro), não só o palco —
      // assim o tap pega o stage todo no QUADRO. Controles são ignorados no handler.
      bind(root.querySelector('.pp26-product-grid__media'));
      ensureZoomBtn();
      if (tries++ < 12) setTimeout(retry, 300);
    })();

    // Mobile: ao escolher um TAMANHO com a página rolada, sobe suave até o quadro
    // pra ver a obra no novo tamanho ("expandir a tela").
    // DELEGAÇÃO no document (não no fieldset): o tema RE-RENDERIZA o fieldset do
    // tamanho ao trocar variante, então um listener preso nele morria (funcionava
    // 1x e parava). No document, sobrevive a qualquer re-render.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || t.type !== 'radio') return;
      if (!t.closest('[data-handle="escolha-o-tamanho-(cm)"]')) return;
      var scope = t.closest('.thb-product-detail--jun26');
      if (!scope) return;
      var media = scope.querySelector('.pp26-product-grid__media');
      if (!media) return;
      // ATENÇÃO: a mídia é `position:sticky`, então `offsetTop`/rect dela são
      // INSTÁVEIS quando a página está rolada (reportam a posição "grudada"). Por
      // isso ancoro em elementos NÃO-sticky pra achar o topo natural do stage.
      var y;
      if (mqMobile.matches) {
        // MOBILE: título (work head) fica acima do stage → fundo dele = topo do
        // stage. Sobe só até o stage (título fora de vista).
        var wh = scope.querySelector('.jun26-workhead') || media.previousElementSibling;
        y = wh ? (wh.getBoundingClientRect().top + window.scrollY + wh.offsetHeight)
               : (media.getBoundingClientRect().top + window.scrollY);
      } else {
        // DESKTOP: stage é coluna sticky (top:N). Rola até o topo do grid menos
        // esse offset, pra a coluna do stage aparecer inteira sob o header.
        var grid = scope.querySelector('.pp26-product-grid') || media.parentElement;
        var stickyTop = parseInt(getComputedStyle(media).top, 10) || 0;
        y = grid.getBoundingClientRect().top + window.scrollY - stickyTop;
      }
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: 'smooth' });
    });
  }

  function init() {
    // GARANTIA anti-indexação: qualquer URL de EDIÇÃO (?ambedit/?calibrate/etc.)
    // recebe <meta robots noindex,nofollow> — o Google nunca indexa o editor.
    if (/[?&](ambedit|calibrate|posedit|fxedit|localframes|typeedit)/.test(location.search)) {
      var robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex,nofollow';
      document.head.appendChild(robots);
    }
    setupFrameFallback();
    setupColorTool();
    setupRuler();
    setupTypeEdit();
    setupHiddenVariantSim();
    var root = document.querySelector('.thb-product-detail--jun26');
    if (!root) return;

    fadeGalleryImgs(root);
    setupCopyProtection();

    // Esconde o botão flutuante de WhatsApp (support-widget) só nesta PDP.
    var sw = document.getElementById('support-widget');
    if (sw) sw.style.setProperty('display', 'none', 'important');

    buildWorkHead(root);
    // buildArtistBadge(root); // desligado por enquanto (a pedido) — reativar depois
    setupWishlistHearts();

    // Espera o pp26 UI antiga ser montada (custom-moldura.js roda no mesmo tick).
    // Como ambos sao `defer`, jun26.js carrega DEPOIS do custom-moldura.min.js
    // — mas o init pode rodar antes do setupPP26MolduraCorUI() ter inserido a row.
    // Resolve com pequeno delay + retry.
    var tries = 0;
    function attempt() {
      var molduraFs = root.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
      if (!molduraFs) {
        if (tries++ < 20) return setTimeout(attempt, 50);
        return;
      }
      cleanupPp26UI(root);
      setupJun26UI(root);
      setupAmbientado(root);
      setupArtZoom(root);
      root.classList.add('jun26-ready'); // revela o painel direito (FOUC guard)
    }
    attempt();
    // Failsafe: revela o painel mesmo se o build não completar (nunca fica oculto).
    setTimeout(function () { root.classList.add('jun26-ready'); }, 2500);
  }

  function cleanupPp26UI(root) {
    // Remove a row montada pelo pp26 (se ja foi montada)
    var oldRow = root.querySelector('.pp26-moldura-cor-row');
    if (oldRow) {
      // Move o fieldset moldura de volta pra fora antes de remover
      var molduraFs = oldRow.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
      var parent = oldRow.parentElement;
      if (molduraFs && parent) parent.insertBefore(molduraFs, oldRow);
      oldRow.remove();
    }
    var oldCheck = root.querySelector('.pp26-paspatur-check');
    if (oldCheck) oldCheck.remove();
    // Tamanho header criado pelo pp26 pode ficar (visual util)
    var corFs = root.querySelector('[data-handle="escolha-a-cor-da-moldura"]');
    if (corFs) corFs.classList.remove('pp26-cor-original-hidden');
  }

  // SVG path do sofá (obrah-sofa.svg) — viewBox 0 0 1200 1200
  // Novo sofá (2 poltronas + sofá central) — fornecido pelo Rafael em
  // ~/Downloads/sofa.svg. Extraído só os 2 paths visíveis (class="st1").
  var SOFA_PATH_LEFT = 'M258.46,1000.33v-97.36c0-39.55,36.45-71.74,81.25-71.74h264.49v-13.81h4.81s-269.31-.05-269.31-.05c-26.27,0-49.96,9.32-67.38,24.11,18.23-28.12,52.47-47.08,91.74-47.08h0s240.14,0,240.14,0v-13.9l-240.15.02c-17.3,0-33.63,3.2-48.54,8.99v-78.66c.01-39.55,36.47-71.74,81.27-71.74h207.43v-13.84l-207.62.02c-51.98,0-94.26,36.36-96.59,81.7-13.2-14.96-33.75-24.98-57.01-24.98h-85.61c-61.61,0-111.69,43.83-112.3,98.06v234.1h559.14v-13.86h-345.74ZM60.67,1000.33v-220.24c.31-27.31,25.59-49.52,56.7-49.52h68.67c31.24,0,56.7,22.48,56.7,50.06v219.7s-182.07,0-182.07,0ZM185.92,716.71h-68.49c-10.87,0-21.05,2.22-30.19,5.96,17.61-16.36,42.4-26.76,70.08-26.76h0s85.61,0,85.61,0c31.24,0,56.7,22.48,56.7,50.06v50.93c-17.12,9.43-31.42,22.59-41.3,38.14v-54.39c0-35.22-32.52-63.93-72.41-63.93Z';
  var SOFA_PATH_RIGHT = 'M1060.66,682.03h-85.61c-23.27,0-43.82,10.02-57.01,24.98-2.33-45.35-44.61-81.7-96.59-81.7l-207.62-.02h-4.81s-4.81,0-4.81,0h0v13.84h217.04c44.8,0,81.25,32.18,81.25,71.74v78.66c-14.9-5.79-31.23-8.99-48.53-8.99l-240.15-.02h-4.81s-4.81,0-4.81,0h0v13.9h249.76c39.28,0,73.51,18.96,91.74,47.08-17.43-14.79-41.11-24.11-67.38-24.11l-269.31.05h-4.81v13.81h274.1c44.8,0,81.25,32.18,81.25,71.74v97.36h-355.36v13.86h568.75v-234.1c-.61-54.23-50.69-98.06-112.3-98.06ZM959.7,835.03c-9.88-15.55-24.18-28.71-41.3-38.14v-50.93c0-27.58,25.47-50.06,56.7-50.06h85.61,0c27.68,0,52.47,10.41,70.08,26.77-9.14-3.74-19.33-5.96-30.19-5.96h-68.49c-39.89,0-72.41,28.71-72.41,63.93v54.39ZM1157.35,1000.33h-182.08v-219.7c0-27.58,25.47-50.06,56.71-50.06h68.67c31.12,0,56.4,22.21,56.7,49.52v220.24Z';

  // ============================================================
  // TAMANHO DO QUADRINHO NO PICKER — Rafael controla o menor (25x35),
  // os outros derivam proporcional. ViewBox é 1200x1200.
  //
  // QUADRO_REF_W = largura visual do 25×35 dentro do viewBox.
  // Pra deixar maior, sobe esse número. Pra menor, desce.
  //   68  ≈ atual (sofá-relativo: arte fica pequena no sofá)
  //   100 ≈ médio
  //   150 ≈ grande, arte ocupa parte do sofá
  // ============================================================
  var QUADRO_REF_W = 110;             // ← AJUSTE AQUI o tamanho do MENOR (25x35)
  var QUADRO_REF_TAMANHO = 25;        // tamanho real em cm do menor (referência)
  var BOX_X_CENTER = 600;             // centralizado no viewBox 1200
  var BOX_Y_BOTTOM = 580;             // base do quadro (logo acima do sofá menor)
  // Derivados: dimensões em px do viewBox por cm real
  var PX_PER_CM = QUADRO_REF_W / QUADRO_REF_TAMANHO;
  // Sofá: escala (0–1) e cor — mais claro e menor
  var SOFA_SCALE = 0.70;
  var SOFA_COLOR = '#c4c4c4';

  function parseTamanho(val) {
    var m = String(val).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
  }

  function svgIconForTamanho(val, orient) {
    var d = parseTamanho(val);
    if (!d) return '';
    // Produto horizontal: deita o quadrinho (label vem sempre WxH retrato).
    if (orient === 'horizontal' && d.h > d.w) {
      var t = d.w; d.w = d.h; d.h = t;
    }
    // Proporção 100% real cm → px do viewBox, derivada do REF
    var w = d.w * PX_PER_CM;
    var h = d.h * PX_PER_CM;
    var x = BOX_X_CENTER - w / 2;
    var y = BOX_Y_BOTTOM - h;
    // Wrappa o sofá em <g> com transform: scale a partir do bottom-center,
    // assim ele encolhe pro centro e mantém apoio "no chão" (y=1000 do viewBox).
    var sofaTransform = 'translate(' + BOX_X_CENTER + ' 1000) scale(' + SOFA_SCALE + ') translate(' + (-BOX_X_CENTER) + ' -1000)';
    return '<svg viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">' +
      '<rect x="' + x.toFixed(0) + '" y="' + y.toFixed(0) + '" width="' + w.toFixed(0) + '" height="' + h.toFixed(0) + '" fill="#151515" />' +
      '<g transform="' + sofaTransform + '">' +
        '<path d="' + SOFA_PATH_LEFT + '" fill="' + SOFA_COLOR + '" />' +
        '<path d="' + SOFA_PATH_RIGHT + '" fill="' + SOFA_COLOR + '" />' +
      '</g>' +
      '</svg>';
  }

  // Tamanhos que devem sumir do picker (Qty=0+deny em todos os produtos,
  // ou decisão de catálogo). Lista temporária até o Matrixify do Rafael
  // remover os Option Values de vez. Quando isso rolar, pode tirar daqui.
  var HIDDEN_TAMANHOS = ['20x20', '100x140'];
  function replaceTamanhoIcons(root) {
    var tamanhoFs = root.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
    if (!tamanhoFs) return;
    var galOrient = document.querySelector('pp26-gallery');
    var orient = (galOrient && galOrient.dataset.orientation) || 'vertical';
    // Esconde radios + labels dos tamanhos da blocklist.
    tamanhoFs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (HIDDEN_TAMANHOS.indexOf(input.value) !== -1) {
        input.style.display = 'none';
        var label = input.nextElementSibling;
        if (label) label.style.display = 'none';
        // Esconde a CÉLULA inteira (não só input+label) pra não sobrar coluna
        // vazia na barra segmentada.
        var cell = input.parentElement;
        if (cell) cell.style.display = 'none';
        // Se o radio escondido estava checked, marca o primeiro visível.
        if (input.checked) {
          var firstVisible = tamanhoFs.querySelector(
            'input[type="radio"]:not([style*="display: none"])'
          );
          if (firstVisible) {
            firstVisible.checked = true;
            firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
    // v2: chips de texto "25×35" (sofá/quadradinho saiu — a escala visual vai
    // virar o estado EM ESCALA do stage). O texto é renderizado via CSS
    // ::before/attr(data-size) — imune a scripts do tema que reescrevem labels.
    tamanhoFs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label) return;
      var img = label.querySelector('img');
      if (img) img.style.setProperty('display', 'none', 'important');
      label.classList.add('jun26-size-chip');
      label.setAttribute('data-size', String(input.value).replace(/\s*x\s*/i, '×'));
      // padding inline: um stylesheet cross-origin (app) rouba o padding com
      // !important; inline vence. O valor responsivo vem da CSS var.
      label.style.setProperty('padding', 'var(--jun26-chip-pad, 9px 14px)', 'important');
    });
  }

  function setupJun26UI(root) {
    var molduraFs = root.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
    var corFs = root.querySelector('[data-handle="escolha-a-cor-da-moldura"]');
    if (!molduraFs) return;

    replaceTamanhoIcons(root);

    // Grabber do sheet mobile (v2): pílula 36×4 no topo do card branco.
    var infoCol = root.querySelector('.pp26-product-grid__info');
    if (infoCol && !infoCol.querySelector('.jun26-sheet-grip')) {
      var grip = document.createElement('div');
      grip.className = 'jun26-sheet-grip';
      infoCol.insertBefore(grip, infoCol.firstChild);
    }

    // Header próprio do Tamanho ("TAMANHO · 30 × 30 cm") — esconde o pp26 via CSS
    // e reusa o mesmo estilo muted de Acabamento/Cor.
    var tamHeaderEl = null;
    // Apelidos de tamanho (decisão 12/jun): 30x42 entrou no Médio (por área,
    // fica entre 30x30 e 35x50).
    var SIZE_NAMES = {
      '20x20': 'Pequeno', '25x35': 'Pequeno',
      '30x30': 'Médio', '30x42': 'Médio', '35x50': 'Médio',
      '50x50': 'Grande', '50x70': 'Grande', '70x70': 'Grande',
      '70x100': 'Galeria',
      '100x100': 'Exposição', '100x140': 'Exposição'
    };
    function fmtSize(v) { return (v || '').replace(/x/i, ' × ') + ' cm'; }
    function updateTamanhoHeader() {
      if (!tamHeaderEl) return;
      var s = document.querySelector('[data-handle="escolha-o-tamanho-(cm)"] input[type="radio"]:checked');
      // O rótulo é renderizado via CSS ::before com attr(data-size). Um script do
      // tema reescreve o TEXTO de qualquer label dessa opção pra "Tamanho:"; como
      // pseudo-elemento + atributo não são texto do DOM, ficam imunes.
      var label = '';
      if (s) {
        var nm = SIZE_NAMES[s.value];
        label = (nm ? nm + ' · ' : '') + fmtSize(s.value);
      }
      tamHeaderEl.setAttribute('data-size', label);
    }
    (function buildTamanhoHeader() {
      var fs = root.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
      if (!fs) return;
      // Linha: "TAMANHO · 50 × 70 CM" à esquerda + "⤢ Compare as medidas" à
      // direita (v2). O link ainda não tem destino (estado EM ESCALA pendente).
      var tamRow = document.createElement('div');
      tamRow.className = 'jun26-tamanho-row';
      tamHeaderEl = document.createElement('div');
      tamHeaderEl.className = 'jun26-tamanho-header-new';
      tamRow.appendChild(tamHeaderEl);
      var cmp = document.createElement('button');
      cmp.type = 'button';
      cmp.className = 'jun26-compare-link';
      // GATE DE DEV: a régua "Comparar" ainda não tem destino. Só aparece no
      // theme dev local (localhost/127.0.0.1) — na loja real fica oculta até
      // o estado EM ESCALA existir. Remover o gate quando a régua entrar.
      if (!/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) {
        cmp.style.display = 'none';
      }
      cmp.innerHTML = ''
        + '<svg class="jun26-compare-sofa" aria-hidden="true" width="15" height="12" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">'
        + '<path d="M3 5V3.5A1.5 1.5 0 0 1 4.5 2h7A1.5 1.5 0 0 1 13 3.5V5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>'
        + '<path d="M2.5 10.5V8.8M13.5 10.5V8.8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>'
        + '<path d="M1.5 6.5A1.3 1.3 0 0 1 2.8 5.2c.72 0 1.3.58 1.3 1.3V7h7.8v-.5a1.3 1.3 0 0 1 1.3-1.3 1.3 1.3 0 0 1 1.3 1.3c0 .9-.55 1.6-1.3 1.85V9H2.8v-.65A1.95 1.95 0 0 1 1.5 6.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>'
        + '</svg>'
        + '<span class="jun26-compare-txt">Comparar<span class="jun26-compare-txt-extra"> com móvel</span></span>';
      tamRow.appendChild(cmp);
      if (fs.parentElement) fs.parentElement.insertBefore(tamRow, fs);
      else fs.insertBefore(tamRow, fs.firstChild);
      updateTamanhoHeader();
    })();

    var molduraInputs = {};
    molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      molduraInputs[i.value] = i;
    });

    molduraFs.classList.add('jun26-moldura-original-hidden');

    var container = document.createElement('div');
    container.className = 'jun26-acabamento-row';

    var header = document.createElement('div');
    header.className = 'jun26-acabamento-header';
    var headerPrefix = document.createElement('span');
    headerPrefix.className = 'jun26-label-prefix';
    headerPrefix.textContent = 'Moldura';
    var headerSep = document.createElement('span');
    headerSep.className = 'jun26-label-sep';
    headerSep.textContent = '·';
    var headerValue = document.createElement('span');
    headerValue.className = 'jun26-label-value';
    header.append(headerPrefix, headerSep, headerValue);
    container.appendChild(header);

    // v2: pills arredondadas soltas (sem box segmentado). Selo "MAIS PEDIDO"
    // vai INLINE no pill Canvas (pontinho verde + caps), nunca badge flutuante.
    var pillsRow = document.createElement('div');
    pillsRow.className = 'jun26-pills-row';
    container.appendChild(pillsRow);

    var pills = {};
    var PILL_NAMES = { 'canvas': 'Canvas', 'padrão': 'Padrão', 'sem moldura': 'Sem moldura' };
    var PRIMARIOS = ['canvas', 'padrão', 'sem moldura'];

    PRIMARIOS.forEach(function (primario) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jun26-pill';
      var nameEl = document.createElement('span');
      nameEl.className = 'jun26-pill-name';
      nameEl.textContent = PILL_NAMES[primario] || primario;
      btn.appendChild(nameEl);
      if (primario === 'canvas') {
        var dot = document.createElement('span');
        dot.className = 'jun26-pill-dot';
        var cap = document.createElement('span');
        cap.className = 'jun26-pill-badge';
        cap.textContent = 'Mais pedido';
        btn.append(dot, cap);
      }
      if (primario === 'padrão') {
        var dotV = document.createElement('span');
        dotV.className = 'jun26-pill-dot jun26-pill-dot--neutro';
        var capV = document.createElement('span');
        capV.className = 'jun26-pill-badge jun26-pill-badge--neutro';
        capV.textContent = 'Com vidro';
        btn.append(dotV, capV);
      }
      btn.dataset.primario = primario;
      btn.addEventListener('click', function () {
        state.primario = primario;
        state.profundidade = false;
        state.fino = false;
        state.paspatur = false;
        state._profForced = false;
        // Ao voltar pra canvas/padrão, restaura a última cor escolhida
        // (default madeira escura). Evita ficar com cor="sem moldura"
        // que vinha do acabamento sem moldura.
        if (primario !== 'sem moldura' && corFs) {
          var target = lastCor || 'madeira escura';
          var corInput = corFs.querySelector('input[type="radio"][value="' + target + '"]');
          if (corInput && !corInput.checked) {
            corInput.checked = true;
            corInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        resolveAndSync();
      });
      pillsRow.appendChild(btn);
      pills[primario] = btn;
    });

    // Microcopy do acabamento selecionado (v2) — explica o que vem.
    var MICROCOPY = {
      'canvas': 'Tela com moldura flutuante de madeira, pronta para pendurar.',
      'padrão': 'Moldura de madeira com vidro de proteção, pronta para pendurar.',
      'sem moldura': 'Impressão enrolada em tubo, pronta para ser emoldurada.'
    };
    var microEl = document.createElement('div');
    microEl.className = 'jun26-acabamento-micro';
    container.appendChild(microEl);

    var modsRow = document.createElement('div');
    modsRow.className = 'jun26-modificadores';

    function makeMod(key, label, hint) {
      var lbl = document.createElement('label');
      lbl.className = 'jun26-mod jun26-mod--' + key;
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      var col = document.createElement('span');
      col.className = 'jun26-mod-col';
      var txt = document.createElement('span');
      txt.className = 'jun26-mod-label';
      txt.textContent = label;
      var hintEl = document.createElement('span');
      hintEl.className = 'jun26-mod-hint';
      hintEl.textContent = hint;
      col.append(txt, hintEl);
      var priceEl = document.createElement('span');
      priceEl.className = 'jun26-mod-price';
      lbl.append(cb, col, priceEl);
      cb.addEventListener('change', function () {
        if (key === 'profundidade' && cb.checked) state.fino = false;
        if (key === 'fino' && cb.checked) state.profundidade = false;
        // Interação manual com +profundidade limpa o "forçado por tamanho".
        if (key === 'profundidade') state._profForced = false;
        state[key] = cb.checked;
        resolveAndSync();
      });
      modsRow.appendChild(lbl);
      return { label: lbl, checkbox: cb, price: priceEl };
    }

    // Ordem (decisão): Paspatur ANTES de Profundidade.
    var modPasp = makeMod('paspatur', '+ Paspatur', 'Acréscimo de 5 cm de margem branca por lado');
    var modProf = makeMod('profundidade', '+ Profundidade', 'Moldura caixa, mais encorpada');
    var modFino = makeMod('fino', '+ Fino', 'Moldura slim, mais discreta');
    // Selo que posiciona o paspatur como acabamento de galeria (bronze sutil)
    (function () {
      var b = document.createElement('span');
      b.className = 'jun26-mod-badge';
      b.textContent = 'Acabamento de galeria';
      modPasp.label.querySelector('.jun26-mod-label').appendChild(b);
    })();

    // v2: opcionais viram grupo próprio "OPCIONAIS", DEPOIS do tamanho (decisão
    // do Paper — usuário não quis no meio do configurador). Só aparece com
    // Padrão ativo (toggle no render()).
    var opGroup = document.createElement('div');
    opGroup.className = 'jun26-opcionais';
    var opHeader = document.createElement('div');
    opHeader.className = 'jun26-acabamento-header';
    var opPrefix = document.createElement('span');
    opPrefix.className = 'jun26-label-prefix';
    opPrefix.textContent = 'Opcionais';
    opHeader.appendChild(opPrefix);
    // Quando o tamanho só existe em caixa, o "+ Profundidade" travado some e
    // entra esta linha (copy escolhida 12/jun).
    var opInfo = document.createElement('div');
    opInfo.className = 'jun26-op-info';
    opInfo.innerHTML = ''
      + '<svg class="jun26-info-ico" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">'
      + '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>'
      + '</svg>'
      + '<span>Quadros neste tamanho já vêm com profundidade maior (moldura caixa).</span>';
    opInfo.style.display = 'none';
    opGroup.append(opHeader, opInfo, modsRow);
    var sizeFsForOp = root.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
    if (sizeFsForOp && sizeFsForOp.parentElement) {
      sizeFsForOp.parentElement.insertBefore(opGroup, sizeFsForOp.nextSibling);
    } else {
      container.appendChild(opGroup);
    }

    // === Bloco de cor próprio (não depende do pp26) ===
    var corBlock = null;
    var corValueEl = null;
    var corSwatches = [];
    if (corFs) {
      corBlock = document.createElement('div');
      corBlock.className = 'jun26-cor-block';

      var corHeader = document.createElement('div');
      corHeader.className = 'jun26-acabamento-header';
      var corPrefix = document.createElement('span');
      corPrefix.className = 'jun26-label-prefix';
      corPrefix.textContent = 'Cor';
      var corSep = document.createElement('span');
      corSep.className = 'jun26-label-sep';
      corSep.textContent = '·';
      corValueEl = document.createElement('span');
      corValueEl.className = 'jun26-label-value';
      corHeader.append(corPrefix, corSep, corValueEl);
      corBlock.appendChild(corHeader);

      var swatchesRow = document.createElement('div');
      swatchesRow.className = 'jun26-swatches-row';

      var corInputs = corFs.querySelectorAll('input[type="radio"]:not([value="sem moldura"])');
      corInputs.forEach(function (input) {
        var origLabel = input.nextElementSibling;
        if (!origLabel) return;
        var sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'jun26-swatch';
        sw.dataset.value = input.value;
        sw.style.setProperty('--option-color', origLabel.style.getPropertyValue('--option-color') || '#ccc');
        sw.style.setProperty('--option-color-image', origLabel.style.getPropertyValue('--option-color-image') || '');
        // Sem `title` (tooltip nativo do browser feio).
        // Em vez disso, data-tooltip + ::after estilizado.
        sw.setAttribute('data-tooltip', input.value);
        sw.setAttribute('aria-label', input.value);
        sw.addEventListener('click', function () {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          updateCorUI();
        });
        swatchesRow.appendChild(sw);
        corSwatches.push({ el: sw, input: input });
      });

      corBlock.appendChild(swatchesRow);
      container.appendChild(corBlock);
    }

    function titleCase(s) {
      return (s || '').replace(/\S+/g, function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      });
    }

    // Preço (centavos) de uma moldura no tamanho atual. >= R$ 9.999 = sentinela
    // de variante "não vendida" → trata como indisponível (null).
    function priceOfMold(moldura) {
      var sz = getCurrentSize();
      var per = PRICE_BY_SIZE && sz && PRICE_BY_SIZE[sz];
      var c = per && moldura ? per[moldura] : null;
      if (c == null || c >= 999900) return null;
      return c;
    }

    function fmtBRL(cents) {
      var r = cents / 100;
      var dec = r % 1 === 0 ? 0 : 2;
      return 'R$ ' + r.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: 2 });
    }

    // Custo marginal de LIGAR um modificador, a partir do estado atual (mantém
    // os outros mods). Estável independente do checkbox estar marcado ou não.
    function modAddCost(modKey) {
      var on = Object.assign({}, state), off = Object.assign({}, state);
      on[modKey] = true; off[modKey] = false;
      if (modKey === 'profundidade') on.fino = false;
      if (modKey === 'fino') on.profundidade = false;
      var kOn = on.primario + '|' + (on.profundidade ? 1 : 0) + '|' + (on.fino ? 1 : 0) + '|' + (on.paspatur ? 1 : 0);
      var kOff = off.primario + '|' + (off.profundidade ? 1 : 0) + '|' + (off.fino ? 1 : 0) + '|' + (off.paspatur ? 1 : 0);
      var pOn = priceOfMold(VARIANT_MAP[kOn]), pOff = priceOfMold(VARIANT_MAP[kOff]);
      if (pOn == null || pOff == null) return null;
      return pOn - pOff;
    }

    function updateCorUI() {
      if (!corFs) return;
      var checked = corFs.querySelector('input:checked');
      var val = checked ? checked.value : '';
      corSwatches.forEach(function (item) {
        item.el.classList.toggle('jun26-swatch--active', item.input.value === val);
      });
      if (corValueEl) corValueEl.textContent = titleCase(val);
    }

    molduraFs.parentElement.insertBefore(container, molduraFs);

    // === Cartão configurador (v2): agrupa acabamento/cor/tamanho/opcionais.
    // No desktop vira card branco com fios full-bleed entre grupos; no mobile
    // o wrapper é transparente (estilos só ≥960). A cor sai do container pra
    // ser grupo irmão (ganha o próprio fio).
    var cardConfig = document.createElement('div');
    cardConfig.className = 'jun26-card-config';
    container.parentElement.insertBefore(cardConfig, container);
    cardConfig.appendChild(container);
    if (corBlock) cardConfig.appendChild(corBlock);
    var tamGroup = document.createElement('div');
    tamGroup.className = 'jun26-tam-group';
    var tamRowEl = root.querySelector('.jun26-tamanho-row');
    var sizeFsEl = root.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
    // ⚠️ ORDEM DOS FIELDSETS: variant-selects (product.js#updateOptions) lê os
    // fieldsets NA ORDEM DO DOM e casa por índice com as option positions.
    // Como o fieldset de tamanho entra no cartão, os de moldura/cor (ocultos)
    // vêm JUNTO, antes dele — senão a ordem vira [tamanho, moldura, cor],
    // nenhuma variante casa e o botão trava em "Indisponível".
    tamGroup.appendChild(molduraFs);
    if (corFs) tamGroup.appendChild(corFs);
    if (tamRowEl) tamGroup.appendChild(tamRowEl);
    if (sizeFsEl) tamGroup.appendChild(sizeFsEl);
    cardConfig.appendChild(tamGroup);
    cardConfig.appendChild(opGroup);

    // === Extras do sheet (v2): fio → garantias → ficha técnica → curadoria ===
    // Vivem no FIM do info (preço/CTA mobile moram na barra fixa).
    var inner = root.querySelector('.product-information--inner') || root;
    var extras = document.createElement('div');
    extras.className = 'jun26-extras';
    extras.innerHTML = ''
      + '<div class="jun26-trust">'
      + '<span class="jun26-trust-item"><span class="jun26-lock" aria-hidden="true"><span class="jun26-lock-shackle"></span><span class="jun26-lock-body"></span></span>Compra 100% segura</span>'
      + '<span class="jun26-trust-item jun26-trust-devolucao">'
      + '<svg class="jun26-return-ico" aria-hidden="true" width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<path d="M4.5 1.5L2 4l2.5 2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>'
      + '<path d="M2 4h6.5a3.75 3.75 0 0 1 0 7.5H4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
      + '</svg>'
      + 'Devolução grátis</span>'
      + '<span class="jun26-trust-dot jun26-trust-dot-b">·</span>'
      + '<a class="jun26-trust-link" href="/pages/trocas-e-devolucoes">Ver política</a>'
      + '</div>'
      + '<div class="jun26-specs">'
      + '<div class="jun26-spec-row" data-spec="papel"><div class="jun26-spec-label">Papel</div><div class="jun26-spec-value">Canson® Satin 240g/m², impressão giclée</div></div>'
      + '<div class="jun26-spec-row" data-spec="moldura"><div class="jun26-spec-label">Moldura</div><div class="jun26-spec-value"></div></div>'
      + '<div class="jun26-spec-row" data-spec="envio"><div class="jun26-spec-label">Envio</div><div class="jun26-spec-value"></div></div>'
      + '<div class="jun26-spec-row"><div class="jun26-spec-label">Arte</div><div class="jun26-spec-value">Reprodução oficial autorizada · artista comissionado em cada venda</div></div>'
      + '</div>'
      + '<div class="jun26-curadoria">'
      + '<div class="jun26-curadoria-col">'
      + '<span class="jun26-curadoria-title">Dúvidas sobre o quadro?</span>'
      + '<span class="jun26-curadoria-sub">Fale com a curadoria no WhatsApp.</span>'
      + '<span class="jun26-curadoria-status"></span>'
      + '</div>'
      + '<a class="jun26-curadoria-btn" target="_blank" rel="noopener noreferrer">'
      + '<svg class="jun26-wa-ico" width="14" height="14" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/></svg>'
      + '<span class="jun26-curadoria-btn-txt"></span>'
      + '</a>'
      + '</div>';
    // Ficha técnica + card "Dúvidas": no DESKTOP vão FULL-WIDTH abaixo do grid
    // (o stage sticky é mais curto que o painel → sobrava um vazio bege à
    // esquerda ao rolar). No MOBILE seguem no fim do sheet (lá é coluna única,
    // sem vazio). placeExtras reposiciona ao cruzar o breakpoint.
    var gridEl = root.querySelector('.pp26-product-grid') ||
      (inner.closest && inner.closest('.pp26-product-grid'));
    // 1068px = breakpoint do grid 2-colunas do pp26 (pp26.css). Abaixo disso o
    // grid empilha (coluna única) e o extras volta pro fim do sheet.
    var mqDesk = window.matchMedia('(min-width: 1068px)');
    function placeExtras() {
      if (mqDesk.matches && gridEl && gridEl.parentElement) {
        if (gridEl.nextElementSibling !== extras) {
          gridEl.parentElement.insertBefore(extras, gridEl.nextSibling);
        }
        extras.classList.add('jun26-extras--below');
      } else {
        if (extras.parentElement !== inner) inner.appendChild(extras);
        extras.classList.remove('jun26-extras--below');
      }
    }
    placeExtras();
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', placeExtras);
    else if (mqDesk.addListener) mqDesk.addListener(placeExtras);
    var specMolduraRow = extras.querySelector('[data-spec="moldura"]');
    var specMolduraVal = specMolduraRow.querySelector('.jun26-spec-value');
    var specPapelRow = extras.querySelector('[data-spec="papel"]');
    var specPapelLabel = specPapelRow.querySelector('.jun26-spec-label');
    var specPapelVal = specPapelRow.querySelector('.jun26-spec-value');
    // Ficha por acabamento: canvas é TELA (canvas de algodão). Padrão/caixa/
    // paspatur e sem moldura usam o MESMO papel Canson Satin (confirmado pelo
    // usuário 13/jun que o emoldurado passou a ser Canson Satin de verdade).
    var SPEC_PAPEL = {
      'canvas': { label: 'Tela', value: 'Canvas 100% algodão · impressão UV em alta definição' },
      'padrão': { label: 'Papel', value: 'Canson® Satin 240g/m², impressão giclée' },
      'sem moldura': { label: 'Papel', value: 'Canson® Satin 240g/m², impressão giclée' }
    };
    var SPEC_MOLDURA = {
      'canvas': 'Flutuante, em madeira revestida · pendurador e kit de instalação inclusos',
      'padrão': 'Madeira revestida, com vidro de proteção · pendurador e kit de instalação inclusos',
      'sem moldura': null
    };
    var SPEC_ENVIO = {
      'canvas': 'Caixa reforçada · cantoneiras de proteção',
      'padrão': 'Caixa reforçada · cantoneiras de proteção',
      'sem moldura': 'Tubo postal rígido · arte cuidadosamente enrolada'
    };
    var specEnvioVal = extras.querySelector('[data-spec="envio"] .jun26-spec-value');
    // Link da curadoria = mesmo WhatsApp do widget flutuante (escondido na PDP).
    // Status inteligente: dentro do horário (seg–sex, 10h–18h de Brasília) =
    // "Online agora"; fora = convite a deixar mensagem (nunca "offline").
    var waBtn = document.querySelector('#support-widget a[data-sw-action="whatsapp"]');
    var curaBtn = extras.querySelector('.jun26-curadoria-btn');
    var curaStatus = extras.querySelector('.jun26-curadoria-status');
    var curaBtnTxt = extras.querySelector('.jun26-curadoria-btn-txt');
    function curadoriaOnline() {
      var now = new Date();
      var br = new Date(now.getTime() - 3 * 3600 * 1000); // Brasília = UTC-3
      var day = br.getUTCDay();
      var h = br.getUTCHours() + br.getUTCMinutes() / 60;
      return day >= 1 && day <= 5 && h >= 10 && h < 18;
    }
    var WA_FALLBACK = 'https://api.whatsapp.com/send/?phone=5511911292673&text=Ol%C3%A1%21+Gostaria+de+uma+Consultoria+de+Quadros.&type=phone_number&app_absent=0';
    curaBtn.href = (waBtn && waBtn.href) ? waBtn.href : WA_FALLBACK;
    var online = curadoriaOnline();
    // Offline: a linha de status SOME (pedido 13/jun — sem "Respondemos seg
    // a sex..."); só o botão muda pra "Deixar mensagem".
    curaStatus.textContent = online ? 'Online agora' : '';
    curaStatus.style.display = online ? '' : 'none';
    curaStatus.classList.toggle('jun26-curadoria-status--on', online);
    curaBtnTxt.textContent = online ? 'Enviar mensagem' : 'Deixar mensagem';

    // === Barra de compra fixa (mobile, v2): linha PIX + CTA com preço ===
    var pixPct = 10;
    var pixLbl = document.querySelector('.obrah-pix-discount-label');
    var pixM = pixLbl && pixLbl.textContent.match(/(\d+)\s*%/);
    if (pixM) pixPct = parseInt(pixM[1], 10);
    var buybar = document.createElement('div');
    buybar.className = 'jun26-buybar';
    // Layout V2 (Paper 57D-0): preço à esquerda, CTA à direita.
    buybar.innerHTML = ''
      + '<div class="jun26-buybar-row">'
      + '<div class="jun26-buybar-price">'
      + '<span class="jun26-buybar-amount-line"><span class="jun26-buybar-amount"></span><span class="jun26-buybar-installments">em até 12x</span></span>'
      + '<span class="jun26-buybar-pix"><span class="jun26-buybar-pix-val"></span><span class="jun26-buybar-badge">−' + pixPct + '%</span></span>'
      + '</div>'
      + '<button type="button" class="jun26-buybar-cta">Comprar</button>'
      + '<span class="jun26-heart-slot jun26-buybar-heart" aria-label="Adicionar aos favoritos"></span>'
      + '</div>';
    document.body.appendChild(buybar);
    var barPixLine = buybar.querySelector('.jun26-buybar-price');
    var barPriceLockW = 0; // largura travada do bloco de preço (só cresce)
    var barAmount = buybar.querySelector('.jun26-buybar-amount');
    var barPixVal = buybar.querySelector('.jun26-buybar-pix-val');
    var barCta = buybar.querySelector('.jun26-buybar-cta');
    barCta.addEventListener('click', function () {
      var real = root.querySelector('button[name="add"]');
      if (real && !real.disabled) real.click();
    });

    // === Cartão de compra (desktop v2): preço hero + PIX + CTA + garantia.
    // Escondido ≤959 (lá vale a barra fixa). Mesmos dados do buybar.
    var cardBuy = document.createElement('div');
    cardBuy.className = 'jun26-card-buy';
    cardBuy.innerHTML = ''
      + '<div class="jun26-buy-price"><span class="jun26-buy-amount"></span><span class="jun26-buy-installments">em até 12x</span></div>'
      + '<div class="jun26-buy-pix"><span class="jun26-buy-pix-val"></span><span class="jun26-buy-badge">−' + pixPct + '%</span></div>'
      + '<div class="jun26-buy-cta-row">'
      + '<button type="button" class="jun26-buy-cta">Adicionar ao carrinho</button>'
      + '<span class="jun26-heart-slot jun26-buy-heart" aria-label="Adicionar aos favoritos"></span>'
      + '</div>'
      + '<div class="jun26-buy-trust">'
      + '<span class="jun26-trust-item"><span class="jun26-lock" aria-hidden="true"><span class="jun26-lock-shackle"></span><span class="jun26-lock-body"></span></span>Compra 100% segura</span>'
      + '<span class="jun26-trust-item jun26-buy-devolucao-item">'
      + '<svg class="jun26-return-ico" aria-hidden="true" width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<path d="M4.5 1.5L2 4l2.5 2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>'
      + '<path d="M2 4h6.5a3.75 3.75 0 0 1 0 7.5H4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
      + '</svg>'
      + 'Devolução grátis</span>'
      + '<span class="jun26-trust-dot">·</span>'
      + '<a class="jun26-buy-trust-link" href="/pages/trocas-e-devolucoes">Ver política</a>'
      + '</div>';
    cardConfig.parentElement.insertBefore(cardBuy, cardConfig.nextSibling);
    var buyAmount = cardBuy.querySelector('.jun26-buy-amount');
    var buyPixLine = cardBuy.querySelector('.jun26-buy-pix');
    var buyPixVal = cardBuy.querySelector('.jun26-buy-pix-val');
    var buyCta = cardBuy.querySelector('.jun26-buy-cta');
    buyCta.addEventListener('click', function () {
      var real = root.querySelector('button[name="add"]');
      if (real && !real.disabled) real.click();
    });

    function fmtBRLcents(cents) {
      var r = cents / 100;
      var dec = Math.round(cents) % 100 === 0 ? 0 : 2;
      return 'R$ ' + r.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: 2 });
    }

    // Tamanhos SEM devolução grátis: não prometemos o que não oferecemos
    // (estorno custa mais conversão que a ausência da promessa). Nesses, o
    // mobile mostra só "Compra 100% segura · Conferir política" e o desktop
    // troca o link por "Política de troca".
    var NO_RETURN_SIZES = { '70x100': 1, '100x140': 1, '100x100': 1 };
    var trustDevolucaoEl = extras.querySelector('.jun26-trust-devolucao');
    var trustLinkEl = extras.querySelector('.jun26-trust-link');
    var buyDevolucaoEl = cardBuy.querySelector('.jun26-buy-devolucao-item');
    var buyTrustLinkEl = cardBuy.querySelector('.jun26-buy-trust-link');

    // "Ver política" abre DRAWER lateral (padrão do tema: .side-panel +
    // body.open-cc; side-panel-close/clique-fora fecham via app.js). O texto
    // é o da própria página /pages/trocas-e-devolucoes, buscado no 1º open.
    var policyDrawer = document.createElement('div');
    policyDrawer.id = 'Jun26-Policy-Drawer';
    policyDrawer.className = 'side-panel jun26-policy-drawer';
    policyDrawer.innerHTML = ''
      + '<div class="side-panel-inner">'
      + '<div class="side-panel-header"><div>'
      + '<h4 class="body-font">Trocas e devoluções</h4>'
      + '<side-panel-close class="side-panel-close">'
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
      + '</side-panel-close>'
      + '</div></div>'
      + '<div class="side-panel-content"><div class="jun26-policy-body rte"></div></div>'
      + '</div>';
    document.body.appendChild(policyDrawer);
    var policyLoaded = false;
    function loadPolicy() {
      if (policyLoaded) return;
      policyLoaded = true;
      fetch('/pages/trocas-e-devolucoes')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.rte') || doc.querySelector('.page-content') || doc.querySelector('main');
          var body = policyDrawer.querySelector('.jun26-policy-body');
          body.innerHTML = content
            ? content.innerHTML
            : '<p>Veja a política completa em <a href="/pages/trocas-e-devolucoes">trocas e devoluções</a>.</p>';
        })
        .catch(function () { policyLoaded = false; });
    }
    function openPolicyDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.add('open-cc');
      policyDrawer.classList.add('active');
      loadPolicy();
    }
    // Prefetch: o texto chega antes do clique (abria "vazio" por instantes)
    if ('requestIdleCallback' in window) requestIdleCallback(loadPolicy, { timeout: 4000 });
    else setTimeout(loadPolicy, 1500);
    if (trustLinkEl) trustLinkEl.addEventListener('click', openPolicyDrawer);
    if (buyTrustLinkEl) buyTrustLinkEl.addEventListener('click', openPolicyDrawer);

    function updateBuyBar() {
      var sz = getCurrentSize();
      var noReturn = !!(sz && NO_RETURN_SIZES[sz]);
      if (trustDevolucaoEl) trustDevolucaoEl.style.display = noReturn ? 'none' : '';
      if (trustLinkEl) {
        trustLinkEl.textContent = noReturn ? 'Política de trocas e devoluções' : 'Ver política';
      }
      if (buyDevolucaoEl) buyDevolucaoEl.style.display = noReturn ? 'none' : '';
      if (buyTrustLinkEl) {
        buyTrustLinkEl.textContent = noReturn ? 'Política de trocas e devoluções' : 'Ver política';
      }
      var p = priceOfMold(resolveVariant());
      var real = root.querySelector('button[name="add"]');
      var dis = !!(real && real.disabled);
      barCta.disabled = dis;
      buyCta.disabled = dis;
      if (p == null) {
        barPixLine.style.visibility = 'hidden';
        buyPixLine.style.visibility = 'hidden';
        barAmount.textContent = '';
        buyAmount.textContent = '';
        return;
      }
      barPixLine.style.visibility = '';
      buyPixLine.style.visibility = '';
      var pix = fmtBRLcents(Math.round(p * (100 - pixPct) / 100)) + ' no PIX';
      barAmount.textContent = fmtBRLcents(p);
      barPixVal.textContent = pix;
      buyPixVal.textContent = pix;
      buyAmount.textContent = fmtBRLcents(p);
      // Trava NÃO-ENCOLHÍVEL: o bloco de preço só cresce, nunca diminui — o CTA
      // "COMPRAR" fica fixo. (O probe inicial pode subestimar antes das fontes;
      // aqui a largura real medida ao vivo garante que nunca pule pra trás.)
      var live = Math.ceil(barPixLine.scrollWidth);
      if (live > barPriceLockW) {
        barPriceLockW = live;
        barPixLine.style.width = live + 'px';
        barPixLine.style.minWidth = live + 'px';
      }
    }

    // O botão real começa disabled e o tema o habilita DEPOIS (async). Sem
    // observer, nosso CTA congelava no estado do primeiro render (inativo
    // até a primeira interação). Espelha qualquer mudança do atributo.
    (function watchRealAddButton() {
      var realBtn = root.querySelector('button[name="add"]');
      if (!realBtn) return;
      new MutationObserver(function () { updateBuyBar(); })
        .observe(realBtn, { attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
    })();

    var state = inferStateFromSelection(molduraFs);
    var lastCor = null;
    if (corFs) {
      var checkedCor = corFs.querySelector('input:checked');
      if (checkedCor && checkedCor.value !== 'sem moldura') {
        lastCor = checkedCor.value;
      }
      corFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        i.addEventListener('change', function () {
          if (i.checked && i.value !== 'sem moldura') {
            lastCor = i.value;
          }
        });
      });
    }

    function resolveVariant() {
      var key = state.primario + '|' +
        (state.profundidade ? 1 : 0) + '|' +
        (state.fino ? 1 : 0) + '|' +
        (state.paspatur ? 1 : 0);
      return VARIANT_MAP[key] || null;
    }

    function syncToShopify() {
      var target = resolveVariant();
      if (!target) return;
      var input = molduraInputs[target];
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Lê quais Option Values existem no fieldset moldura ATUAL — algumas variants
    // foram removidas via Matrixify (slim, slim+pasp, caixa+pasp ocultos em tamanhos
    // onde não são vendidos). UI precisa esconder os checkboxes que levariam a
    // combinações inexistentes pra não enganar o cliente (preço da variant antiga).
    function getAvailableMoldVariants() {
      var set = {};
      molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        set[i.value] = true;
      });
      return set;
    }

    function getCurrentSize() {
      var s = document.querySelector('[data-handle="escolha-o-tamanho-(cm)"] input[type="radio"]:checked');
      return s ? s.value : null;
    }

    // Interseção das molduras do produto com as que EXISTEM no tamanho atual.
    // Sem dados ainda (MOLD_BY_SIZE null) ou tamanho sem mapa → não restringe.
    function getSizeMoldVariants(availAll) {
      if (!MOLD_BY_SIZE) return availAll;
      var sz = getCurrentSize();
      var per = sz && MOLD_BY_SIZE[sz];
      if (!per) return availAll;
      var out = {};
      Object.keys(availAll).forEach(function (k) { if (per[k]) out[k] = true; });
      return out;
    }

    // Pills disponíveis: canvas, padrão, sem moldura
    function isPrimarioAvailable(p, avail) {
      if (p === 'canvas') return !!avail['canvas'];
      if (p === 'sem moldura') return !!avail['sem moldura'];
      // padrão: qualquer variant padrão-derivada existe?
      return !!(avail['padrão'] || avail['padrão com paspatur'] ||
                avail['caixa'] || avail['caixa com paspatur'] ||
                avail['slim'] || avail['slim com paspatur']);
    }

    // Pra cada checkbox, retorna true se EXISTE alguma combinação válida
    // que use esse mod marcado (sozinho ou com paspatur).
    function isModAvailable(mod, avail) {
      if (mod === 'profundidade') return !!(avail['caixa'] || avail['caixa com paspatur']);
      if (mod === 'fino')         return !!(avail['slim'] || avail['slim com paspatur']);
      if (mod === 'paspatur')     return !!(avail['padrão com paspatur'] ||
                                            avail['caixa com paspatur'] ||
                                            avail['slim com paspatur']);
      return false;
    }

    function render() {
      // availAll = molduras que o PRODUTO tem (controla mostrar/esconder).
      // avail    = molduras que existem no TAMANHO atual (controla habilitar/
      //            desabilitar e resolver a variant). Assim opções inexistentes
      //            no tamanho ficam cinzas em vez de sumir.
      var availAll = getAvailableMoldVariants();
      var avail = getSizeMoldVariants(availAll);

      // Se o primário atual não existe nesse tamanho, cai pro 1º disponível.
      if (Object.keys(avail).length && !isPrimarioAvailable(state.primario, avail)) {
        var firstOk = Object.keys(pills).filter(function (k) {
          return isPrimarioAvailable(k, avail);
        })[0];
        if (firstOk) {
          state.primario = firstOk;
          state.profundidade = false; state.fino = false; state.paspatur = false;
        }
      }
      // Padrão sem variante RASA nesse tamanho, mas com CAIXA → força
      // +profundidade (caixa é a única opção da família padrão ali). O checkbox
      // fica travado marcado via wouldYieldValid (desmarcar levaria a variant
      // inexistente). _profForced marca que foi automático: ao voltar pra um
      // tamanho que tem padrão raso, desfaz sozinho (não prende o cliente na
      // caixa). Se o cliente marcar +profundidade na mão, a flag é limpa e a
      // escolha persiste.
      if (state.primario === 'padrão' && !avail['padrão'] &&
          (avail['caixa'] || avail['caixa com paspatur'])) {
        if (!state.profundidade) { state.profundidade = true; state.fino = false; }
        state._profForced = true;
      } else if (state._profForced && avail['padrão']) {
        state.profundidade = false;
        state._profForced = false;
      }

      // AUTO-CORREÇÃO: se o combo atual não tem variante NO TAMANHO (ex.: paspatur
      // ficou marcado de um tamanho onde existia e o cliente trocou pra 100×100,
      // caindo em "caixa com paspatur" que não existe ali), derruba modificadores
      // até achar um combo válido — o cliente nunca fica num "INDISPONÍVEL"
      // alcançado por cliques válidos.
      var comboKey = function (s) { return s.primario + '|' + (s.profundidade ? 1 : 0) + '|' + (s.fino ? 1 : 0) + '|' + (s.paspatur ? 1 : 0); };
      var comboValid = function (s) { var v = VARIANT_MAP[comboKey(s)]; return !!v && !!avail[v]; };
      if (Object.keys(avail).length && !comboValid(state)) {
        var tryDrop = ['paspatur', 'fino'];
        if (!state._profForced) tryDrop.push('profundidade');
        for (var di = 0; di < tryDrop.length && !comboValid(state); di++) {
          if (state[tryDrop[di]]) {
            var t = Object.assign({}, state); t[tryDrop[di]] = false;
            if (comboValid(t)) state[tryDrop[di]] = false;
          }
        }
      }

      // Pills: esconde os que não têm variant no produto; desabilita (cinza) os
      // que existem no produto mas não no tamanho atual.
      Object.keys(pills).forEach(function (k) {
        pills[k].style.display = isPrimarioAvailable(k, availAll) ? '' : 'none';
        var okSize = isPrimarioAvailable(k, avail);
        pills[k].disabled = !okSize;
        pills[k].classList.toggle('jun26-pill--disabled', !okSize);
        pills[k].classList.toggle('jun26-pill--active', state.primario === k);
      });
      var isPadrao = state.primario === 'padrão';
      modsRow.classList.toggle('jun26-modificadores--visible', isPadrao);
      // Grupo "OPCIONAIS" inteiro (header + linhas) só existe com Padrão ativo
      // e se o produto tiver pelo menos um opcional.
      var anyMod = isModAvailable('profundidade', availAll) ||
                   isModAvailable('fino', availAll) ||
                   isModAvailable('paspatur', availAll);
      opGroup.style.display = (isPadrao && anyMod) ? '' : 'none';
      // Modificadores: esconde se o PRODUTO não tem; mostra (porém desabilita
      // abaixo) se existe no produto mas não no tamanho atual.
      modProf.label.style.display = isModAvailable('profundidade', availAll) ? '' : 'none';
      modFino.label.style.display = isModAvailable('fino', availAll) ? '' : 'none';
      modPasp.label.style.display = isModAvailable('paspatur', availAll) ? '' : 'none';
      modProf.checkbox.checked = state.profundidade;
      modFino.checkbox.checked = state.fino;
      modPasp.checkbox.checked = state.paspatur;

      // Pré-emptive: pra cada mod, simula TOGGLE e checa se a variant resultante
      // existe nos radios disponíveis. Se não, desabilita o checkbox (cliente
      // não consegue chegar num estado que não pode comprar).
      function wouldYieldValid(modKey) {
        var s = Object.assign({}, state);
        s[modKey] = !s[modKey];
        // toggles mutuamente exclusivos: marcar prof zera fino e vice-versa
        if (modKey === 'profundidade' && s.profundidade) s.fino = false;
        if (modKey === 'fino' && s.fino) s.profundidade = false;
        var key = s.primario + '|' + (s.profundidade ? 1 : 0) + '|' + (s.fino ? 1 : 0) + '|' + (s.paspatur ? 1 : 0);
        var variant = VARIANT_MAP[key];
        return !!variant && !!avail[variant];
      }
      // Mutex prof↔fino (legado) + valid-target check
      modProf.checkbox.disabled = state.fino || !wouldYieldValid('profundidade');
      modFino.checkbox.disabled = state.profundidade || !wouldYieldValid('fino');
      modPasp.checkbox.disabled = !wouldYieldValid('paspatur');
      // +profundidade forçado (caixa obrigatória no tamanho) NÃO é "indisponível":
      // está ativo e travado → estado "incluído" (--locked), não cinza (--disabled).
      var profLocked = state._profForced && state.profundidade && modProf.checkbox.disabled;
      // Caixa obrigatória no tamanho: troca o checkbox travado pela linha
      // informativa (sem "INCLUÍDO" — usuário rejeitou o badge).
      opInfo.style.display = profLocked ? '' : 'none';
      if (profLocked) modProf.label.style.display = 'none';
      modProf.label.classList.toggle('jun26-mod--locked', profLocked);
      modProf.label.classList.toggle('jun26-mod--disabled', modProf.checkbox.disabled && !profLocked);
      modFino.label.classList.toggle('jun26-mod--disabled', modFino.checkbox.disabled);
      modPasp.label.classList.toggle('jun26-mod--disabled', modPasp.checkbox.disabled);
      // Indisponível NO TAMANHO = some (cinza sem preço só confunde; a linha
      // informativa já explica quando é o caso). Decisão 12/jun.
      if (modPasp.checkbox.disabled && !modPasp.checkbox.checked) modPasp.label.style.display = 'none';
      if (modFino.checkbox.disabled && !modFino.checkbox.checked) modFino.label.style.display = 'none';
      if (!profLocked && modProf.checkbox.disabled && !modProf.checkbox.checked) modProf.label.style.display = 'none';
      // Grupo só existe se sobrou algo visível (linhas ou a informativa);
      // o rótulo OPCIONAIS só faz sentido se houver OPÇÃO clicável.
      var anyActionable = modProf.label.style.display !== 'none' ||
        modFino.label.style.display !== 'none' ||
        modPasp.label.style.display !== 'none';
      var anyVisible = profLocked || anyActionable;
      opGroup.style.display = (isPadrao && anyVisible) ? '' : 'none';
      opHeader.style.display = anyActionable ? '' : 'none';
      // Container dos modificadores some quando está vazio (senão o gap do
      // grupo soma altura fantasma abaixo da linha informativa).
      modsRow.classList.toggle('jun26-modificadores--visible', isPadrao && anyActionable);

      if (corBlock) {
        corBlock.classList.toggle('jun26-cor-block--hidden', state.primario === 'sem moldura');
      }
      updateCorUI();

      // "+ R$ X" dinâmico por modificador (custo marginal real, varia por tamanho).
      [['profundidade', modProf], ['fino', modFino], ['paspatur', modPasp]].forEach(function (pair) {
        var d = modAddCost(pair[0]);
        pair[1].price.textContent = (d != null && d > 0) ? '+ ' + fmtBRL(d) : '';
      });

      // Hint do paspatur mostra o RESULTADO (5cm por lado = +10 por dimensão):
      // "o quadro vai a 40 × 40 cm" comunica melhor que a aritmética.
      var szPasp = parseTamanho(getCurrentSize() || '');
      if (szPasp) {
        modPasp.label.querySelector('.jun26-mod-hint').textContent =
          'Acréscimo de 5 cm de margem branca por lado · tamanho final do quadro é ' + (szPasp.w + 10) + ' × ' + (szPasp.h + 10) + ' cm';
      }

      // v2: o valor do header é o primário — mas profundidade/fino mudam a
      // moldura de fato, então o nome acompanha (PADRÃO → CAIXA/SLIM).
      var headerName = PILL_NAMES[state.primario] || titleCase(state.primario);
      if (state.primario === 'padrão' && state.profundidade) headerName = 'Caixa';
      if (state.primario === 'padrão' && state.fino) headerName = 'Slim';
      headerValue.textContent = headerName;

      // Microcopy + ficha "MOLDURA" acompanham o acabamento.
      microEl.textContent = MICROCOPY[state.primario] || '';
      var specTxt = SPEC_MOLDURA[state.primario];
      specMolduraRow.style.display = specTxt ? '' : 'none';
      if (specTxt) specMolduraVal.textContent = specTxt;
      var papelSpec = SPEC_PAPEL[state.primario];
      if (papelSpec) {
        specPapelLabel.textContent = papelSpec.label;
        specPapelVal.textContent = papelSpec.value;
      }
      // No Padrão a moldura é a protagonista — sobe pra 1ª linha da ficha.
      if (state.primario === 'padrão') {
        specPapelRow.parentElement.insertBefore(specMolduraRow, specPapelRow);
      } else {
        specMolduraRow.parentElement.insertBefore(specPapelRow, specMolduraRow);
      }
      if (specEnvioVal) specEnvioVal.textContent = SPEC_ENVIO[state.primario] || '';

      updateBuyBar();
    }

    function resolveAndSync() {
      render();
      syncToShopify();
    }

    // Sincroniza se o variant mudar por outro caminho (URL params, picker original)
    molduraFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (i.checked && i.value !== resolveVariant()) {
          state = inferStateFromVariant(i.value);
          render();
        }
      });
    });

    // Trocar de TAMANHO muda quais molduras existem — recalcula a UI (forçar
    // caixa, cinza no paspatur etc.) e re-sincroniza a variant Shopify.
    var sizeFs = document.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
    if (sizeFs) {
      sizeFs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        i.addEventListener('change', function () { updateTamanhoHeader(); resolveAndSync(); });
      });
    }

    // Estado inicial consistente: o tema às vezes nasce com radios órfãos de
    // sessão anterior (ex.: moldura=caixa + cor="sem moldura" → combo
    // inexistente) e o botão fica "Indisponível" até a primeira interação.
    // Se o botão real nasceu desabilitado, conserta a cor e redispara change
    // pro tema recalcular — o CTA tem que começar ativo.
    function normalizeInitialSelection() {
      var real = root.querySelector('button[name="add"]');
      if (!real || !real.disabled) return;
      if (corFs && state.primario !== 'sem moldura') {
        var c = corFs.querySelector('input:checked');
        if (!c || c.value === 'sem moldura') {
          var fallback = corFs.querySelector('input[type="radio"][value="' + (lastCor || 'madeira escura') + '"]') ||
                         corFs.querySelector('input[type="radio"]:not([value="sem moldura"])');
          if (fallback) { fallback.checked = true; c = fallback; }
        }
        if (c) c.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var m = molduraFs.querySelector('input:checked');
      if (m) m.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Trava a largura do bloco de preço da barra no MAIOR preço do produto —
    // o COMPRAR não muda de lugar ao trocar tamanho/acabamento.
    function lockBarPriceWidth() {
      if (!PRICE_BY_SIZE) return;
      var max = 0;
      Object.keys(PRICE_BY_SIZE).forEach(function (sz) {
        var per = PRICE_BY_SIZE[sz];
        Object.keys(per).forEach(function (m) {
          var c = per[m];
          if (c && c < 999900 && c > max) max = c;
        });
      });
      if (!max) return;
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;';
      probe.innerHTML = '<div class="jun26-buybar-price">'
        + '<span class="jun26-buybar-amount-line"><span class="jun26-buybar-amount">' + fmtBRLcents(max) + '</span><span class="jun26-buybar-installments">em até 12x</span></span>'
        + '<span class="jun26-buybar-pix"><span class="jun26-buybar-pix-val">' + fmtBRLcents(Math.round(max * (100 - pixPct) / 100)) + ' no PIX</span><span class="jun26-buybar-badge">−' + pixPct + '%</span></span>'
        + '</div>';
      buybar.appendChild(probe);
      var w = Math.ceil(probe.firstChild.getBoundingClientRect().width);
      probe.remove();
      // Largura TRAVADA (não só min): o bloco de preço nunca cresce nem
      // encolhe ao trocar tamanho → o CTA "COMPRAR" fica fixo no lugar.
      if (w && w > barPriceLockW) {
        barPriceLockW = w;
        barPixLine.style.width = w + 'px';
        barPixLine.style.minWidth = w + 'px';
      }
    }

    // Carrega disponibilidade por tamanho e re-renderiza quando chegar.
    loadMoldBySize(function () {
      resolveAndSync();
      lockBarPriceWidth();
      setTimeout(normalizeInitialSelection, 300);
      setTimeout(normalizeInitialSelection, 1200);
    });
    // Re-trava depois das fontes carregarem (medida inicial pode sair menor
    // se a fonte Archivo ainda não estava pronta → CTA "pulava" depois).
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { lockBarPriceWidth(); });
    }

    render();
  }

  // ============================================================
  // AMBIENTADO — foto real de ambiente com o quadro em escala.
  // Clicar num tamanho troca o stage pra esta vista (decisão 12/jun);
  // toggle QUADRO/AMBIENTADO em pill liquid-glass sobre o stage.
  //
  // Escala: AMB_CAL.pxPerCm = pixels DA IMAGEM ORIGINAL (1600×2400) por cm
  // na parede. Âncora = centro do quadro como fração da imagem (o quadro de
  // calibração do Paper estava centrado → 0.5/0.5). Calibrar via ?ambedit.
  //
  // MOLDURA = RENDERIZADA via CSS (não PNG) — escala perfeita, sem clipping de
  // sombra. Geometria em CM (perfil/vão/profundidade) × escala da foto; cores
  // amostradas das pranchas FRONTAL. Cantos internos arredondados + risquinho
  // de quina (miter via border de 4 cores) + sombra projetada da profundidade.
  // ============================================================
  // AMBIENTES: cada foto de cômodo é um pill próprio, com a sua calibração
  // (px/cm, âncora X/Y) e suas linhas de parede (teto/móveis p/ o clamp).
  // Ordem dos pills = ordem da lista. ?ambedit edita o ambiente ATIVO e salva
  // por-ambiente (localStorage jun26_amb_cal_<id>). Pra adicionar um cômodo:
  // gere o webp em assets/ e acrescente uma entrada aqui.
  var AMB_ENVS = [
    {
      id: 'hall', label: 'HALL', asset: 'jun26-amb-hall.webp',
      img: { w: 1600, h: 1993 },
      // escala ~pelo livro Casa Mexicana (24cm). anchorX 0.62 = parede livre (à
      // direita da monstera); pé 0.689 (calibração do usuário).
      cal: { pxPerCm: 9, anchorX: 0.62, anchorY: 0.689 },
      furnitureY: 0.63, ceilY: 0.03,
      // madeira mais escura + quente (pedido): menos brilho, mais calor/saturação.
      fx: { brilho: 88, contraste: 103, saturacao: 106, calor: 14 },
      // zonas no-touch (banco à direita + monstera à esquerda)
      noTouch: [{ x0: 0.24, y0: 0.609, x1: 1, y1: 0.756 }, { x0: 0, y0: 0.534, x1: 0.28, y1: 0.684 }]
    },
    {
      id: 'sala', label: 'SALA', asset: 'jun26-amb-sala-estar-2.webp',
      img: { w: 1600, h: 1993 },
      // calibração do usuário (?ambedit) — foto nova (sofá bouclé), zoom recortado
      cal: { pxPerCm: 6.355, anchorX: 0.494, anchorY: 0.493 },
      furnitureY: 0.434, ceilY: 0.051
    },
    {
      id: 'quarto', label: 'QUARTO', asset: 'jun26-amb-quarto.webp',
      img: { w: 1600, h: 1993 },
      // anchorY = PÉ do quadro (logo acima da cabeceira em 0.58)
      cal: { pxPerCm: 7.5, anchorX: 0.42, anchorY: 0.55 },
      furnitureY: 0.58, ceilY: 0.07
    },
    {
      id: 'jantar', label: 'JANTAR', asset: 'jun26-amb-sala.jpg',
      img: { w: 1600, h: 1993 },
      // pé 0.675 acima da mesa (linha móveis 0.70). Zona da MESA removida
      // (redundante c/ a linha de móveis e estava alta demais); fica só a
      // zona da CORTINA (objeto pontual à direita).
      cal: { pxPerCm: 7.8, anchorX: 0.436, anchorY: 0.675 },
      furnitureY: 0.588, ceilY: 0.08,
      noTouch: [{ x0: 0.729, y0: 0.056, x1: 0.879, y1: 0.689 }]
    }
  ];
  // Cor da madeira por opção (face plana amostrada das pranchas). hi/lo
  // derivados em runtime pro bevel/miter.
  // base = face plana; hi/lo derivados pro bevel (perspectiva). clara usa o
  // par #CAA06E/#D0A36D que o usuário pediu (madeira mais quente/dourada).
  var AMB_WOOD = {
    marrom: [101, 74, 49],   // #654a31 — mel / madeira escura (ajuste do usuário)
    preta: [46, 46, 46],     // #2e2e2e
    clara: [202, 160, 110],  // #CAA06E — pinus / madeira clara
    branca: [183, 183, 183]  // #b7b7b7
  };
  var AMB_COR_SLUG = { 'mel': 'marrom', 'preta': 'preta', 'pinus': 'clara', 'branca': 'branca' };
  // Geometria por TIPO, em cm. canvas: moldura flutuante (perfil fino + vão
  // escuro, arte recuada). depth = profundidade (projeta a sombra).
  // padrao/caixa: specs provisórias (o usuário passa as exatas depois).
  // Specs reais (usuário): padrão/caixa = 2 cm de largura de perfil; padrão e
  // padrão-com-paspatur = 1 cm de profundidade; caixa = 3 cm. canvas flutuante.
  var AMB_GEO = {
    canvas: { profile: 0.7, gap: 1.0, depth: 4.0, glass: false, gapDark: true, innerR: 0.15 },
    padrao: { profile: 2.0, gap: 0.0, depth: 1.0, glass: true, gapDark: false, innerR: 0 },
    caixa: { profile: 2.0, gap: 0.0, depth: 3.0, glass: true, gapDark: false, innerR: 0 }
  };
  var AMB_PASPATUR_CM = 5; // margem branca por lado quando paspatur ativo
  // Ajuste de cor da FOTO do ambiente (por ambiente). brilho/contraste/saturação
  // em % (100 = neutro); calor = sepia ×100 (4 = sepia 0.04, calor amarelado
  // mínimo). Editável no ?ambedit e no bloco do editor de tema.
  var AMB_FX_DEF = { brilho: 100, contraste: 100, saturacao: 100, calor: 4 };
  // Transparência da trama do canvas (GLOBAL, todas as molduras ambientadas).
  var AMB_TEX_OP = 0.6;
  function ambPhotoFilter(fx) {
    var f = fx || AMB_FX_DEF;
    return 'brightness(' + (f.brilho / 100) + ') contrast(' + (f.contraste / 100) +
      ') saturate(' + (f.saturacao / 100) + ') sepia(' + (f.calor / 100) + ')';
  }
  function ambShade(c, d) {
    return 'rgb(' + Math.max(0, Math.min(255, c[0] + d)) + ',' +
      Math.max(0, Math.min(255, c[1] + d)) + ',' + Math.max(0, Math.min(255, c[2] + d)) + ')';
  }

  function setupAmbientado(root) {
    var slide = root.querySelector('.pp26__slide--perspective');
    if (!slide || root.querySelector('.jun26-amb')) return;
    // O overlay cobre a COLUNA DE MÍDIA inteira (não só o slide) — sem isso a
    // foto termina num corte seco no meio da parede quando o painel é mais
    // alto que o stage (era o "quebrado" do desktop largo).
    var mediaCol = root.querySelector('.pp26-product-grid__media') || slide;

    // Ambientes vindos do EDITOR DE TEMA (blocos jun26_ambiente) têm prioridade
    // sobre o fallback hardcoded AMB_ENVS. O Liquid injeta um <script
    // class="jun26-amb-envs"> com o JSON (assetUrl = imagem do tema). Se não
    // houver blocos, segue o hardcoded (assets/*.webp).
    try {
      var envEl = document.querySelector('.jun26-amb-envs');
      if (envEl) {
        var fromTheme = JSON.parse(envEl.textContent);
        if (fromTheme && fromTheme.length) AMB_ENVS = fromTheme;
      }
    } catch (e) { /* mantém o hardcoded */ }

    // Calibração persistida pelo ?ambedit — POR AMBIENTE (jun26_amb_cal_<id>).
    // (Não lemos a chave antiga jun26_amb_cal: ela podia ter um valor de
    // inspeção do ?ambedit que estourava o quadro.)
    // O localStorage do ?ambedit é SANDBOX de calibração: só aplica DENTRO do
    // ?ambedit. Na visualização normal (= o que vai pro ar) usa SEMPRE o código,
    // pra o navegador do usuário nunca divergir da loja no ar.
    var ambeditOn = /[?&]ambedit/.test(location.search) && root.dataset.ambedit !== 'false';
    AMB_ENVS.forEach(function (env) {
      if (ambeditOn) {
        try {
          var sv = JSON.parse(localStorage.getItem('jun26_amb_cal_' + env.id) || 'null');
          if (sv && sv.pxPerCm) env.cal = sv;
        } catch (e) { /* noop */ }
        try {
          var sf = JSON.parse(localStorage.getItem('jun26_amb_fx_' + env.id) || 'null');
          if (sf && sf.brilho != null) env.fx = sf;
        } catch (e) { /* noop */ }
        try {
          var snt = JSON.parse(localStorage.getItem('jun26_amb_nt_' + env.id) || 'null');
          if (snt && snt.length != null) env.noTouch = snt;
        } catch (e) { /* noop */ }
        try {
          var sl = JSON.parse(localStorage.getItem('jun26_amb_lines_' + env.id) || 'null');
          if (sl) { if (sl.furnitureY != null) env.furnitureY = sl.furnitureY; if (sl.ceilY != null) env.ceilY = sl.ceilY; }
        } catch (e) { /* noop */ }
      }
      if (!env.fx) env.fx = Object.assign({}, AMB_FX_DEF);
      if (!env.noTouch) env.noTouch = [];
    });
    // Cores das molduras (AMB_WOOD) são GLOBAIS (mesma madeira em todo ambiente).
    // Override do ?ambedit só no sandbox; na visualização normal usa o código.
    if (ambeditOn) {
      try {
        var sw = JSON.parse(localStorage.getItem('jun26_amb_wood') || 'null');
        if (sw) Object.keys(sw).forEach(function (k) { if (AMB_WOOD[k]) AMB_WOOD[k] = sw[k]; });
      } catch (e) { /* noop */ }
      try {
        var sto = parseFloat(localStorage.getItem('jun26_amb_tex'));
        if (!isNaN(sto)) AMB_TEX_OP = sto;
      } catch (e) { /* noop */ }
    }
    var curEnv = AMB_ENVS[0];

    var cssLink = document.querySelector('link[href*="jun26"]');
    var base = cssLink ? cssLink.href.replace(/jun26[^\/]*\.css.*$/, '') : '';
    // Versão do tema (o ?v=hash que o Shopify põe no CSS) — anexada na URL da foto
    // pra BUSTAR o cache do CDN quando a foto é sobrescrita com o mesmo nome. Sem
    // isso, o CDN serve a versão velha (URL idêntica). Muda a cada deploy.
    var ver = '';
    if (cssLink) { var vm = cssLink.href.match(/[?&]v=([^&]+)/); if (vm) ver = '?v=' + vm[1]; }
    // URL da foto do ambiente: do tema (assetUrl do bloco, já versionada) ou do
    // assets/ (hardcoded) + ?v do tema pra cache-bust.
    function envSrc(env) { return env.assetUrl || (base + env.asset + ver); }

    var amb = document.createElement('div');
    amb.className = 'jun26-amb';
    var photo = document.createElement('img');
    photo.className = 'jun26-amb-photo';
    photo.src = envSrc(curEnv);
    // Filtro de cor por ambiente (inline > regra CSS). Reaplica ao trocar pill.
    function applyPhotoFilter() { photo.style.filter = ambPhotoFilter(curEnv.fx); }
    applyPhotoFilter();
    photo.alt = '';
    photo.draggable = false;
    // Moldura RENDERIZADA via CSS (sem PNG — escala perfeita).
    // quadro (sombra projetada) > wood (perfil, cantos com miter) >
    // artwin (vão/paspatur + abertura arredondada) > art (+glass do vidro).
    var quadro = document.createElement('div');
    quadro.className = 'jun26-amb-quadro';
    var wood = document.createElement('div');
    wood.className = 'jun26-amb-wood';
    var artwin = document.createElement('div');
    artwin.className = 'jun26-amb-artwin';
    var art = document.createElement('img');
    art.className = 'jun26-amb-art';
    art.alt = '';
    art.draggable = false;
    // Vidro: cobre TODA a área envidraçada (mat + arte), por isso é filho do
    // quadro (inset = perfil), acima da artwin — não só sobre a arte.
    var glass = document.createElement('div');
    glass.className = 'jun26-amb-glass';
    // Grão da madeira/paspatur: overlay sutil (cobre a moldura + o mat; a artwin
    // por cima mantém a arte limpa). Textura via SVG turbulence.
    var grain = document.createElement('div');
    grain.className = 'jun26-amb-grain';
    // Textura da TELA (trama do canvas) — overlay sobre a arte, só no canvas.
    // Recortada pela artwin (overflow hidden).
    var tex = document.createElement('div');
    tex.className = 'jun26-amb-tex';
    // Vão preto do canvas POR CIMA da textura (cobre os cantos da trama). Só no
    // canvas; borda dark, centro transparente.
    var vao = document.createElement('div');
    vao.className = 'jun26-amb-vao';
    // Sombra projetada na parede: cópia borrada+deslocada+mascarada (cast
    // shadow direcional), ATRÁS de tudo (primeiro filho do quadro).
    var cast = document.createElement('div');
    cast.className = 'jun26-amb-cast';
    artwin.appendChild(art);
    artwin.appendChild(tex);
    artwin.appendChild(vao);
    quadro.appendChild(cast);
    quadro.appendChild(wood);
    quadro.appendChild(grain);
    quadro.appendChild(artwin);
    quadro.appendChild(glass);
    amb.appendChild(photo);
    amb.appendChild(quadro);
    mediaCol.appendChild(amb);

    // Toggle de 2 NÍVEIS: nível 1 = QUADRO | AMBIENTE (compacto). Ao entrar no
    // AMBIENTE, aparece a sub-linha com os ambientes (SALA/QUARTO/JANTAR). O
    // QUADRO continua visível no nível 1 → é por ele que se VOLTA pro quadro.
    var tg = document.createElement('div');
    tg.className = 'jun26-stage-toggle';
    [['quadro', 'QUADRO'], ['ambiente', 'AMBIENTE']].forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.mode = m[0];
      b.textContent = m[1];
      if (m[0] === 'quadro') b.classList.add('is-on');
      // AMBIENTE abre o ambiente ATIVO (último usado, default = 1º pill).
      b.addEventListener('click', function () {
        setMode(m[0] === 'ambiente' ? curEnv.id : 'quadro');
      });
      tg.appendChild(b);
    });
    // Sub-linha dos ambientes (só aparece no modo ambiente, via CSS .jun26-amb-on).
    var envRow = document.createElement('div');
    envRow.className = 'jun26-stage-envs';
    AMB_ENVS.forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.mode = e.id;
      b.textContent = e.label;
      b.addEventListener('click', function () { setMode(e.id); });
      envRow.appendChild(b);
    });
    // Toggle vai na COLUNA DE MÍDIA (não no slide): o slide tem z-index:3 e
    // cria contexto de empilhamento — dentro dele o toggle ficaria ATRÁS do
    // overlay amb (z:4). Na media ele fica acima de tudo (z:6).
    mediaCol.appendChild(tg);
    mediaCol.appendChild(envRow);

    var mode = 'quadro';
    var lastGeo = null; // geometria do último layout (pro arrasto direto)
    var ambeditSync = function () { /* setado no ?ambedit */ };
    var zonesRender = function () { /* setado no ?ambedit (zonas no-touch) */ };
    var guidesRender = function () { /* setado no ?ambedit (linhas móveis/teto) */ };
    function setMode(m) {
      mode = m;
      var on = m !== 'quadro';
      if (on) {
        var env = AMB_ENVS.filter(function (e) { return e.id === m; })[0];
        if (env) {
          curEnv = env;
          var newSrc = envSrc(env);
          // só troca o src se mudou (evita reload/flash ao re-clicar o mesmo pill)
          if (photo.getAttribute('src') !== newSrc) photo.src = newSrc;
          // aspect do stage: formato fixo do ambiente (env.aspect) OU a proporção
          // da foto (fallback). Com formato fixo + zoom/foco, a foto é recortada.
          mediaCol.style.setProperty('--amb-aspect', env.aspect ? String(env.aspect) : (env.img.w + ' / ' + env.img.h));
          applyPhotoFilter();
        }
      }
      mediaCol.classList.toggle('jun26-amb-on', on);
      slide.classList.toggle('jun26-amb-on', on);
      // marca o container raiz → CSS esconde o grabber do sheet no ambientado
      // (mobile) e dá o stage maior.
      root.classList.toggle('jun26-amb-active', on);
      // Estado dos botões: QUADRO ativo no modo quadro; AMBIENTE (meta) ativo em
      // qualquer ambiente; cada pill de ambiente ativo só no seu id.
      var allBtns = [].slice.call(tg.querySelectorAll('button'))
        .concat([].slice.call(envRow.querySelectorAll('button')));
      allBtns.forEach(function (b) {
        var dm = b.dataset.mode;
        b.classList.toggle('is-on', dm === 'ambiente' ? on : dm === m);
      });
      ambeditSync();
      if (on) layout();
    }

    function getArtSrc() {
      var a = slide.querySelector('.pp26__art');
      return a ? (a.currentSrc || a.src) : '';
    }

    function curSize() {
      var s = document.querySelector('[data-handle="escolha-o-tamanho-(cm)"] input[type="radio"]:checked');
      return s ? s.value : null;
    }

    // Fonte da verdade do estado da moldura = .pp26__frame do stage QUADRO
    // (data-frame-type/color resolvidos pelo pp26-gallery, INCLUSIVE caixa de
    // série em 100x100, slim e *-com-paspatur — coisas que pills/checkboxes
    // não mostram). Cores vêm no formato curto: mel/preta/pinus/branca.
    function curState() {
      var frame = slide.querySelector('.pp26__frame');
      return {
        type: (frame && frame.dataset.frameType) || 'padrao',
        color: (frame && frame.dataset.frameColor) || 'mel'
      };
    }

    function frameGeo(st) {
      if (/sem.?moldura/.test(st.type)) return null;
      var tipo = /canvas/.test(st.type) ? 'canvas' : (/caixa/.test(st.type) ? 'caixa' : 'padrao');
      var geo = AMB_GEO[tipo];
      if (/slim/.test(st.type)) geo = Object.assign({}, geo, { profile: 1.4 });
      var cor = AMB_COR_SLUG[st.color] || 'marrom';
      return Object.assign({ tipo: tipo, cor: cor, wood: AMB_WOOD[cor] }, geo);
    }

    function layout() {
      var cw = amb.clientWidth, ch = amb.clientHeight;
      if (!cw || !ch) return;
      var d = parseTamanho(curSize() || '');
      if (!d) return;
      var orient = slide.dataset.orientation || 'vertical';
      if (orient === 'horizontal' && d.h > d.w) { var t = d.w; d.w = d.h; d.h = t; }

      var st = curState();
      var g = frameGeo(st);
      var profCm = g ? g.profile : 0;
      // paspatur (padrão) some no vão branco; canvas tem vão escuro fixo.
      var paspCm = (g && !g.gapDark && /paspatur/.test(st.type)) ? AMB_PASPATUR_CM : 0;
      var gapCm = g ? (g.gapDark ? g.gap : paspCm) : 0;
      var depthCm = g ? g.depth : 0;

      // Geometria COVER + CROP (zoom/foco). A foto cobre o stage e o ENQUADRAMENTO
      // é controlado por cal.zoom (≥1) e cal.focalX/focalY (0..1) — espelhado no
      // CSS da foto (object-position + transform scale, mesmo foco). O quadro usa
      // a MESMA transformação (ax = dx + anchorX*imgW etc.) → fica grudado na
      // parede em qualquer zoom/foco. Defaults (1, 0.5, 0.5) = comportamento antigo.
      var img = curEnv.img, cal = curEnv.cal;
      var zoom = cal.zoom || 1;
      var fx = cal.focalX != null ? cal.focalX : 0.5;
      var fy = cal.focalY != null ? cal.focalY : 0.5;
      var s = Math.max(cw / img.w, ch / img.h) * zoom;
      var imgW = img.w * s, imgH = img.h * s;
      var dx = (cw - imgW) * fx;
      var dy = (ch - imgH) * fy;
      var scale = cal.pxPerCm * s; // px renderizados por cm
      // espelha o crop na foto (mesmo foco/zoom que a matemática acima)
      photo.style.objectPosition = (fx * 100).toFixed(1) + '% ' + (fy * 100).toFixed(1) + '%';
      photo.style.transformOrigin = (fx * 100).toFixed(1) + '% ' + (fy * 100).toFixed(1) + '%';
      photo.style.transform = zoom !== 1 ? 'scale(' + zoom + ')' : '';

      var wcm = d.w + 2 * gapCm + 2 * profCm;
      var hcm = d.h + 2 * gapCm + 2 * profCm;
      var w = wcm * scale, h = hcm * scale;
      var ax = dx + cal.anchorX * imgW;
      // PENDURA POR BAIXO (bom senso de como se pendura quadro): cal.anchorY = a
      // fração da parede onde fica o PÉ do quadro — um gap fixo acima do móvel
      // (cabeceira/mesa). Assim os tamanhos PEQUENOS ficam baixos, perto do
      // móvel, e os GRANDES crescem PRA CIMA (em direção ao teto). O pé é o mesmo
      // pra todos os tamanhos — só a altura muda.
      var baseY = dy + cal.anchorY * imgH;  // linha do pé do quadro
      var ay = baseY - h / 2;               // centro = pé − meia-altura
      // Teto: se o topo do MAIOR tamanho passar do teto, desce só o necessário
      // (a maior arte fica encaixada entre o móvel e o teto).
      var ceilY = dy + curEnv.ceilY * imgH + 0.02 * imgH;
      if (ay - h / 2 < ceilY) ay = ceilY + h / 2;
      // Segurança: o pé nunca invade o móvel NEM as zonas "no-touch". Cada zona é
      // uma caixa (fração da imagem); se o quadro cruza a caixa na horizontal, o
      // pé tem que ficar ACIMA do topo dela. Limite = menor entre a linha de
      // móveis e os topos das caixas cruzadas.
      var furnY = dy + curEnv.furnitureY * imgH;
      var pL = ax - w / 2, pR = ax + w / 2;
      (curEnv.noTouch || []).forEach(function (b) {
        var bx0 = dx + b.x0 * imgW, bx1 = dx + b.x1 * imgW, by0 = dy + b.y0 * imgH;
        if (pR > bx0 && pL < bx1) furnY = Math.min(furnY, by0);
      });
      if (ay + h / 2 > furnY) ay = furnY - h / 2;

      quadro.style.width = w.toFixed(1) + 'px';
      quadro.style.height = h.toFixed(1) + 'px';
      quadro.style.left = (ax - w / 2).toFixed(1) + 'px';
      quadro.style.top = (ay - h / 2).toFixed(1) + 'px';
      quadro.classList.toggle('jun26-amb-quadro--poster', !g);
      // geometria atual (pro arrasto direto do ?ambedit converter px↔fração/escala)
      lastGeo = { dx: dx, dy: dy, imgW: imgW, imgH: imgH, w: w, h: h, s: s };
      zonesRender(); // redesenha as caixas no-touch (só ativo no ?ambedit)
      guidesRender(); // redesenha as linhas móveis/teto (só ?ambedit)

      if (g) {
        wood.style.display = '';
        grain.style.display = '';
        var fw = profCm * scale;
        var gw = gapCm * scale;
        var c = g.wood;
        // Bevel/miter MUITO SUAVE na face (usuário: "diferença de cor não tão
        // grande"): top+left quase iguais à base, right+bottom levemente mais
        // escuros. O risquinho de quina (miter) continua via contraste mínimo.
        var c = g.wood;
        // Canvas PRETO mais ACINZENTADO: a madeira preta (~#2e2e2e) ficava igual
        // ao vão escuro e o vão sumia. Cinza-escuro contrasta e o vão aparece.
        if (g.gapDark && g.cor === 'preta') c = [64, 64, 64];
        // Bevel SEM realce claro: nenhum lado fica mais claro que a face (senão
        // vira "fininho branco" na dobra). Os lados/dobras ficam um tom MAIS
        // ESCURO (pedido do usuário); risquinho de quina = seam escuro.
        wood.style.borderWidth = fw.toFixed(1) + 'px';
        wood.style.borderTopColor = ambShade(c, 0);
        wood.style.borderLeftColor = ambShade(c, -3);
        wood.style.borderRightColor = ambShade(c, -11);
        wood.style.borderBottomColor = ambShade(c, -16);
        // Fundo atrás da arte: vão escuro (canvas) · mat branco fosco (SÓ
        // paspatur) · escuro neutro no padrão/caixa sem mat (senão o branco do
        // fundo vaza como LINHA FINA nos cantos do perfil).
        var isPaspBg = paspCm > 0 && !g.gapDark;
        // Vão do canvas = PRETO (1cm, recesso flutuante); mat branco fosco no
        // paspatur; escuro neutro no padrão/caixa sem mat.
        wood.style.background = g.gapDark ? '#0c0b0a' : (isPaspBg ? '#F9F8F4' : '#2c2723');
        // Vão do canvas com PROFUNDIDADE 3D: o perfil projeta sombra DENTRO do
        // vão (recesso), deixando de parecer cinza chapado.
        wood.classList.toggle('jun26-amb-wood--canvasgap', g.gapDark);
        // artwin é filha do QUADRO → inset = perfil + vão (não só o vão)
        artwin.style.inset = (fw + gw).toFixed(1) + 'px';
        artwin.style.borderRadius = (g.innerR * scale).toFixed(1) + 'px';
        var isPasp = paspCm > 0 && !g.gapDark;
        var isFramed = !g.gapDark;
        artwin.classList.toggle('jun26-amb-artwin--float', g.gapDark);
        // Abertura da arte: padrão/caixa = sombra da aba do perfil ("dobrinha");
        // PASPATUR = sombra EVIDENTE da espessura de 0,5cm do mat projetando na
        // arte recuada (a beirada do paspatur fica acima da arte). innerR 0.
        artwin.classList.toggle('jun26-amb-artwin--framed', isFramed && !isPasp);
        artwin.classList.toggle('jun26-amb-artwin--pasp', isPasp);
        // Espessura do mat em px (0,5 cm) → sombra do mat projetada na arte.
        if (isPasp) artwin.style.setProperty('--mth', (0.5 * scale).toFixed(1) + 'px');
        // Alcance da sombra do RABBET (aba do perfil) na arte = proporcional à
        // PROFUNDIDADE da moldura → caixa (3cm) projeta bem mais que padrão (1cm).
        if (isFramed && !isPasp) {
          artwin.style.setProperty('--rsh', Math.max(2, depthCm * 0.5 * scale).toFixed(1) + 'px');
        }
        // Sombra interna do PERFIL (a aba da moldura recuando p/ o vão) — UNIFORME
        // (não só top-left, senão a borda de baixo fica clara). Aprovada no
        // paspatur; agora vale pra padrão e caixa também.
        wood.classList.toggle('jun26-amb-wood--recess', isFramed);
        if (isFramed) {
          wood.style.setProperty('--psh', (0.5 * scale).toFixed(1) + 'px');
          // PAREDE INTERNA da moldura = faixa do MESMO tom porém mais escuro
          // (o "marrom mais escuro" que o usuário esperava no lugar do branco).
          wood.style.setProperty('--lip', ambShade(c, -42));
          wood.style.setProperty('--lipw', Math.max(1, 0.18 * scale).toFixed(1) + 'px');
        }
        // Grão da MOLDURA (veta/PET). No PASPATUR o grão SOME (o usuário quer o
        // mat limpo) — fica só na moldura dos outros acabamentos.
        var isPet = (g.cor === 'preta' || g.cor === 'branca');
        grain.classList.toggle('jun26-amb-grain--pet', isPet);
        grain.style.opacity = isPasp ? '0' : (g.gapDark
          ? (isPet ? '0.14' : '0.10')
          : (isPet ? '0.11' : '0.07'));
        // Sombra na PAREDE — duas técnicas combinadas:
        // (a) CONTATO: drop-shadow curtíssimo e escuro (onde a moldura toca a
        //     parede — nítido, não difunde).
        // (b) PROJETADA: elemento .cast = cópia deslocada no ângulo da luz,
        //     borrada e MASCARADA (penumbra cresce com a distância). Mais
        //     realista que blur simétrico. Tudo escala com a profundidade.
        // Luz vem da DIREITA na foto → sombra cai pra ESQUERDA (x negativo) +
        // pra baixo. Contato curto + cast direcional mascarado.
        var sd = depthCm * scale;
        quadro.style.filter =
          'drop-shadow(' + (-sd * 0.05).toFixed(1) + 'px ' + (sd * 0.12).toFixed(1) + 'px ' + (sd * 0.16).toFixed(1) + 'px rgba(0,0,0,0.20))';
        cast.style.display = 'block';
        cast.style.transform =
          'translate(' + (-sd * 0.18).toFixed(1) + 'px,' + (sd * 0.5).toFixed(1) + 'px) scale(1.012)';
        cast.style.filter = 'blur(' + Math.max(2, sd * 0.6).toFixed(1) + 'px)';
        cast.style.borderRadius = '2px';
        // Vidro (reflexo) — cobre TODA a área envidraçada (mat + arte): inset =
        // perfil. Só acabamentos com vidro (padrão/caixa).
        if (g.glass) {
          glass.style.display = '';
          glass.style.inset = fw.toFixed(1) + 'px';
          glass.style.backgroundImage = 'url(' + base + 'reflexo-' + orient + '.webp)';
        } else {
          glass.style.display = 'none';
        }
        // Textura da TELA (trama do canvas) — tileável 1024² (~10cm por tile),
        // repetida na escala física (multiply 0.4). Só no canvas.
        if (g.tipo === 'canvas') {
          tex.style.display = '';
          tex.style.backgroundImage = 'url(' + base + 'jun26-amb-canvas-tex.webp)';
          tex.style.backgroundSize = (10 * scale).toFixed(1) + 'px'; // ~10cm/tile
          tex.style.opacity = AMB_TEX_OP; // transparência editável (?ambedit)
          vao.style.display = 'none';
        } else {
          tex.style.display = 'none';
          vao.style.display = 'none';
        }
      } else {
        // Sem moldura (pôster): impressão rente à parede — SEM sombra projetada
        // (cast). Só um fio de contato bem fininho (a folha encostada).
        wood.style.display = 'none';
        grain.style.display = 'none';
        glass.style.display = 'none';
        tex.style.display = 'none';
        vao.style.display = 'none';
        cast.style.display = 'none';
        quadro.style.filter = 'drop-shadow(0 0.5px 1px rgba(0,0,0,0.14))';
        // ZERA o inset/classes que sobram da moldura anterior — senão a impressão
        // fica recuada e MENOR que as emolduradas (a arte tem que ocupar o quadro
        // inteiro = mesmo tamanho da arte das com moldura).
        artwin.style.inset = '0px';
        artwin.style.borderRadius = '0px';
        artwin.classList.remove('jun26-amb-artwin--framed', 'jun26-amb-artwin--pasp', 'jun26-amb-artwin--float');
      }

      if (!art.src) art.src = getArtSrc();
    }

    // Clique no tamanho → mostra AMBIENTADO (decisão 12/jun) + atualiza medidas.
    // Qualquer outro change (inclusive renormalização do resolveAndSync) também
    // re-roda o layout — o dataset do frame pode levar ~300ms pra assentar.
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-handle="escolha-o-tamanho-(cm)"]')) {
        // ao escolher tamanho, abre no ambiente ATIVO (default = primeiro pill)
        setMode(curEnv.id);
      }
      if (mode !== 'quadro') setTimeout(layout, 400);
    }, true);
    // Fonte primária de atualização: o pp26-gallery troca data-frame-type/color
    // no .pp26__frame (variant change E simulações tipo slim/caixa-paspatur).
    var frameImg = slide.querySelector('.pp26__frame');
    if (frameImg) {
      new MutationObserver(function () {
        if (mode !== 'quadro') layout();
      }).observe(frameImg, { attributes: true, attributeFilter: ['data-frame-type', 'data-frame-color'] });
    }
    window.addEventListener('resize', function () {
      if (mode !== 'quadro') requestAnimationFrame(layout);
    });
    photo.addEventListener('load', function () { if (mode !== 'quadro') layout(); });

    // --- Editor de calibração: ?ambedit (edita o ambiente ATIVO) ---
    // Troca de pill = troca o cômodo editado; cada um salva em
    // jun26_amb_cal_<id>. "copiar valores" emite a entrada pronta pra colar
    // dentro de AMB_ENVS (cal/furnitureY/ceilY do ambiente atual).
    // Gate: só abre o ?ambedit se a seção habilitar (data-ambedit). Default =
    // habilitado (atributo ausente → !== 'false'). Desligue o checkbox da seção
    // pra blindar na loja no ar.
    if (ambeditOn) {
      setMode(curEnv.id);
      var panel = document.createElement('div');
      panel.className = 'jun26-ambedit';
      panel.innerHTML =
        '<strong>AMBIENTADO · <em data-env></em><button type="button" class="jun26-ambedit-min" data-act="min" aria-label="minimizar">–</button></strong>' +
        '<details class="jun26-ambedit-sec" open><summary>escala & posição</summary>' +
        '<label>escala do quadro <input type="range" min="3" max="14" step="0.05" data-k="pxPerCm"><span></span></label>' +
        '<label>âncora X <input type="range" min="0.2" max="0.8" step="0.005" data-k="anchorX"><span></span></label>' +
        '<label>pé do quadro Y <input type="range" min="0.15" max="0.85" step="0.005" data-k="anchorY"><span></span></label>' +
        '<label>móveis Y <input type="range" min="0.3" max="0.95" step="0.005" data-k="furnitureY"><span></span></label>' +
        '<label>teto Y <input type="range" min="0" max="0.4" step="0.005" data-k="ceilY"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>enquadramento</summary>' +
        '<label>zoom <input type="range" min="1" max="2.5" step="0.01" data-k="zoom"><span></span></label>' +
        '<label>foco X <input type="range" min="0" max="1" step="0.005" data-k="focalX"><span></span></label>' +
        '<label>foco Y <input type="range" min="0" max="1" step="0.005" data-k="focalY"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>cores da foto</summary>' +
        '<label>brilho <input type="range" min="50" max="150" step="1" data-fx="brilho"><span></span></label>' +
        '<label>contraste <input type="range" min="50" max="150" step="1" data-fx="contraste"><span></span></label>' +
        '<label>saturação <input type="range" min="0" max="200" step="1" data-fx="saturacao"><span></span></label>' +
        '<label>calor (amarelo) <input type="range" min="0" max="30" step="1" data-fx="calor"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec"><summary>cores das molduras</summary>' +
        '<label>madeira escura <input type="color" data-wood="marrom"></label>' +
        '<label>preta <input type="color" data-wood="preta"></label>' +
        '<label>madeira clara <input type="color" data-wood="clara"></label>' +
        '<label>branca <input type="color" data-wood="branca"></label>' +
        '<label>trama do canvas <input type="range" min="0" max="60" step="1" data-tex="op"><span></span></label>' +
        '</details>' +
        '<details class="jun26-ambedit-sec" open data-sec="zonas"><summary>zonas no-touch (<span data-ntcount>0</span>)</summary>' +
        '<div class="jun26-ambedit-ntlist" data-ntlist></div>' +
        '</details>' +
        '<button type="button" data-act="copy">copiar valores</button>' +
        '<button type="button" data-act="reset">reset</button>' +
        '<textarea class="jun26-ambedit-out" readonly></textarea>';
      document.body.appendChild(panel);
      var outBox = panel.querySelector('.jun26-ambedit-out');
      // Arrastar o painel pela barra de título (move em volta da tela).
      (function () {
        var header = panel.querySelector('strong');
        if (!header) return;
        header.style.cursor = 'move';
        var drag = false, sx, sy, startLeft, startTop;
        header.addEventListener('mousedown', function (e) {
          if (e.target.dataset.act === 'min') return; // o botão – não arrasta
          var r = panel.getBoundingClientRect();
          panel.style.left = r.left + 'px';
          panel.style.top = r.top + 'px';
          panel.style.right = 'auto';
          panel.style.bottom = 'auto';
          drag = true; sx = e.clientX; sy = e.clientY; startLeft = r.left; startTop = r.top;
          e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!drag) return;
          // clampa o topo e ajusta o max-height pro painel NUNCA sair da tela
          // (senão o fundo fica inalcançável e parece que "não rola").
          var nt = Math.max(0, Math.min(window.innerHeight - 80, startTop + e.clientY - sy));
          panel.style.left = Math.max(0, startLeft + e.clientX - sx) + 'px';
          panel.style.top = nt + 'px';
          panel.style.maxHeight = (window.innerHeight - nt - 14) + 'px';
        });
        window.addEventListener('mouseup', function () { drag = false; });
      })();
      var CALDEF = { zoom: 1, focalX: 0.5, focalY: 0.5 };
      var envVal = function (k) {
        if (k === 'furnitureY' || k === 'ceilY') return curEnv[k];
        var v = curEnv.cal[k];
        return v != null ? v : (CALDEF[k] != null ? CALDEF[k] : 0);
      };
      var rgbToHex = function (a) { return '#' + a.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); };
      var hexToRgb = function (h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; };
      var syncPanel = function () {
        var lbl = panel.querySelector('[data-env]');
        if (lbl) lbl.textContent = curEnv.label;
        panel.querySelectorAll('input[data-k]').forEach(function (inp) {
          var k = inp.dataset.k;
          inp.value = envVal(k);
          inp.nextElementSibling.textContent = (+envVal(k)).toFixed(k === 'pxPerCm' ? 2 : 3);
        });
        if (!curEnv.fx) curEnv.fx = Object.assign({}, AMB_FX_DEF);
        panel.querySelectorAll('input[data-fx]').forEach(function (inp) {
          var k = inp.dataset.fx;
          var v = curEnv.fx[k] != null ? curEnv.fx[k] : AMB_FX_DEF[k];
          inp.value = v;
          inp.nextElementSibling.textContent = v;
        });
        panel.querySelectorAll('input[data-wood]').forEach(function (inp) {
          if (AMB_WOOD[inp.dataset.wood]) inp.value = rgbToHex(AMB_WOOD[inp.dataset.wood]);
        });
        var texInp = panel.querySelector('input[data-tex]');
        if (texInp) { texInp.value = Math.round(AMB_TEX_OP * 100); texInp.nextElementSibling.textContent = Math.round(AMB_TEX_OP * 100); }
      };
      ambeditSync = syncPanel; // setMode re-sincroniza ao trocar de pill
      syncPanel();

      // --- MANIPULAÇÃO DIRETA: arrastar o quadro p/ mover + alças p/ redimensionar
      // (escala). Mexe nas mesmas cal.anchorX/anchorY/pxPerCm e sincroniza o painel.
      root.classList.add('jun26-amb-editing');
      ['nw', 'ne', 'sw', 'se'].forEach(function (pos) {
        var hd = document.createElement('div');
        hd.className = 'jun26-amb-handle jun26-amb-handle--' + pos;
        hd.dataset.handle = pos;
        quadro.appendChild(hd);
      });
      var dragState = null;
      quadro.addEventListener('mousedown', function (e) {
        if (mode === 'quadro' || !lastGeo) return;
        if (e.target.dataset && e.target.dataset.handle) {
          var r = quadro.getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          dragState = {
            type: 'resize', cx: cx, cy: cy,
            d0: Math.hypot(e.clientX - cx, e.clientY - cy) || 1,
            px0: curEnv.cal.pxPerCm
          };
        } else {
          dragState = {
            type: 'move', x0: e.clientX, y0: e.clientY,
            ax0: curEnv.cal.anchorX, ay0: curEnv.cal.anchorY
          };
        }
        e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragState || !lastGeo) return;
        if (dragState.type === 'move') {
          curEnv.cal.anchorX = Math.max(0.05, Math.min(0.95, dragState.ax0 + (e.clientX - dragState.x0) / lastGeo.imgW));
          curEnv.cal.anchorY = Math.max(0.1, Math.min(0.95, dragState.ay0 + (e.clientY - dragState.y0) / lastGeo.imgH));
        } else {
          var d = Math.hypot(e.clientX - dragState.cx, e.clientY - dragState.cy);
          curEnv.cal.pxPerCm = Math.max(3, Math.min(14, dragState.px0 * d / dragState.d0));
        }
        localStorage.setItem('jun26_amb_cal_' + curEnv.id, JSON.stringify(curEnv.cal));
        layout(); syncPanel();
      });
      window.addEventListener('mouseup', function () { dragState = null; });

      // --- ZONAS NO-TOUCH: caixas que o quadro não pode encostar (por ambiente).
      // Desenhadas sobre a foto; arrastar move, alça redimensiona, × remove.
      function ntClamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
      var zonesEl = document.createElement('div');
      zonesEl.className = 'jun26-amb-zones';
      amb.appendChild(zonesEl);
      function saveNT() { localStorage.setItem('jun26_amb_nt_' + curEnv.id, JSON.stringify(curEnv.noTouch || [])); }
      zonesRender = function () {
        var nt = curEnv.noTouch || [];
        // contagem + lista no painel (pra VER todas as zonas e remover)
        var cnt = panel.querySelector('[data-ntcount]'); if (cnt) cnt.textContent = nt.length;
        var list = panel.querySelector('[data-ntlist]');
        if (list) {
          list.innerHTML = '';
          nt.forEach(function (b, i) {
            var row = document.createElement('div');
            row.className = 'jun26-ambedit-ntrow';
            row.innerHTML = '<span>zona ' + (i + 1) + '</span>' +
              '<button type="button" data-ntsel="' + i + '">ver</button>' +
              '<button type="button" data-ntdel="' + i + '">×</button>';
            list.appendChild(row);
          });
        }
        if (!lastGeo) return;
        zonesEl.innerHTML = '';
        nt.forEach(function (b, i) {
          var el = document.createElement('div');
          el.className = 'jun26-amb-zone';
          el.dataset.i = i;
          el.style.left = (lastGeo.dx + b.x0 * lastGeo.imgW).toFixed(1) + 'px';
          el.style.top = (lastGeo.dy + b.y0 * lastGeo.imgH).toFixed(1) + 'px';
          el.style.width = ((b.x1 - b.x0) * lastGeo.imgW).toFixed(1) + 'px';
          el.style.height = ((b.y1 - b.y0) * lastGeo.imgH).toFixed(1) + 'px';
          var lbl = document.createElement('span');
          lbl.className = 'jun26-amb-zone-lbl'; lbl.textContent = i + 1;
          var rm = document.createElement('button');
          rm.className = 'jun26-amb-zone-x'; rm.type = 'button'; rm.textContent = '×'; rm.dataset.rm = i;
          var hd = document.createElement('div');
          hd.className = 'jun26-amb-zone-h'; hd.dataset.rz = i;
          el.appendChild(lbl); el.appendChild(rm); el.appendChild(hd);
          zonesEl.appendChild(el);
        });
      };
      var zDrag = null;
      zonesEl.addEventListener('mousedown', function (e) {
        var d = e.target.dataset;
        if (d.rm != null) { curEnv.noTouch.splice(+d.rm, 1); saveNT(); layout(); e.preventDefault(); e.stopPropagation(); return; }
        var i = d.rz != null ? +d.rz : (d.i != null ? +d.i : -1);
        if (i < 0) return;
        zDrag = { type: d.rz != null ? 'resize' : 'move', i: i, x0: e.clientX, y0: e.clientY, box: Object.assign({}, curEnv.noTouch[i]) };
        e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!zDrag || !lastGeo) return;
        var dxf = (e.clientX - zDrag.x0) / lastGeo.imgW, dyf = (e.clientY - zDrag.y0) / lastGeo.imgH;
        var b = curEnv.noTouch[zDrag.i], o = zDrag.box;
        if (zDrag.type === 'move') {
          var wv = o.x1 - o.x0, hv = o.y1 - o.y0;
          b.x0 = ntClamp(o.x0 + dxf, 0, 1 - wv); b.y0 = ntClamp(o.y0 + dyf, 0, 1 - hv);
          b.x1 = b.x0 + wv; b.y1 = b.y0 + hv;
        } else {
          b.x1 = ntClamp(o.x1 + dxf, b.x0 + 0.03, 1); b.y1 = ntClamp(o.y1 + dyf, b.y0 + 0.03, 1);
        }
        saveNT(); layout();
      });
      window.addEventListener('mouseup', function () { zDrag = null; });

      // --- GUIAS VISUAIS: linhas de MÓVEIS e TETO arrastáveis na foto ---
      var guidesEl = document.createElement('div');
      guidesEl.className = 'jun26-amb-guides';
      amb.appendChild(guidesEl);
      guidesRender = function () {
        if (!lastGeo) return;
        guidesEl.innerHTML = '';
        [['furnitureY', 'móveis'], ['ceilY', 'teto']].forEach(function (g) {
          var el = document.createElement('div');
          el.className = 'jun26-amb-guide jun26-amb-guide--' + g[0];
          el.dataset.guide = g[0];
          el.style.top = (lastGeo.dy + curEnv[g[0]] * lastGeo.imgH).toFixed(1) + 'px';
          el.innerHTML = '<span class="jun26-amb-guide-lbl">' + g[1] + '</span>';
          guidesEl.appendChild(el);
        });
      };
      var gDrag = null;
      guidesEl.addEventListener('mousedown', function (e) {
        var t = e.target;
        var k = t.dataset.guide || (t.parentElement && t.parentElement.dataset.guide);
        if (!k) return;
        gDrag = k; e.preventDefault(); e.stopPropagation();
      });
      window.addEventListener('mousemove', function (e) {
        if (!gDrag || !lastGeo) return;
        var r = amb.getBoundingClientRect();
        var frac = Math.max(0, Math.min(0.98, (e.clientY - r.top - lastGeo.dy) / lastGeo.imgH));
        curEnv[gDrag] = +frac.toFixed(3);
        localStorage.setItem('jun26_amb_lines_' + curEnv.id, JSON.stringify({ furnitureY: curEnv.furnitureY, ceilY: curEnv.ceilY }));
        layout(); syncPanel();
      });
      window.addEventListener('mouseup', function () { gDrag = null; });

      // botão "+ zona" DENTRO da seção de zonas
      var addZ = document.createElement('button');
      addZ.type = 'button'; addZ.textContent = '+ zona (no-touch)';
      (panel.querySelector('[data-sec="zonas"]') || panel).appendChild(addZ);
      addZ.addEventListener('click', function () {
        curEnv.noTouch = curEnv.noTouch || [];
        curEnv.noTouch.push({ x0: 0.36, y0: 0.45, x1: 0.64, y1: 0.6 });
        saveNT(); layout();
      });
      // lista de zonas: "ver" rola até a caixa (pisca) · "×" remove
      var ntList = panel.querySelector('[data-ntlist]');
      if (ntList) ntList.addEventListener('click', function (e) {
        var d = e.target.dataset;
        if (d.ntdel != null) { curEnv.noTouch.splice(+d.ntdel, 1); saveNT(); layout(); }
        else if (d.ntsel != null) {
          var z = zonesEl.children[+d.ntsel];
          if (z) { z.classList.add('jun26-amb-zone--flash'); setTimeout(function () { z.classList.remove('jun26-amb-zone--flash'); }, 900); }
        }
      });

      panel.addEventListener('input', function (e) {
        var t = e.target;
        if (t.dataset.k) {
          var k = t.dataset.k, v = parseFloat(t.value);
          if (k === 'furnitureY' || k === 'ceilY') {
            curEnv[k] = v;
            localStorage.setItem('jun26_amb_lines_' + curEnv.id, JSON.stringify({ furnitureY: curEnv.furnitureY, ceilY: curEnv.ceilY }));
          } else {
            curEnv.cal[k] = v;
            localStorage.setItem('jun26_amb_cal_' + curEnv.id, JSON.stringify(curEnv.cal));
          }
          t.nextElementSibling.textContent = v.toFixed(k === 'pxPerCm' ? 2 : 3);
          layout();
        } else if (t.dataset.fx) {
          var fk = t.dataset.fx, fv = parseFloat(t.value);
          if (!curEnv.fx) curEnv.fx = Object.assign({}, AMB_FX_DEF);
          curEnv.fx[fk] = fv;
          t.nextElementSibling.textContent = fv;
          localStorage.setItem('jun26_amb_fx_' + curEnv.id, JSON.stringify(curEnv.fx));
          applyPhotoFilter();
        } else if (t.dataset.wood) {
          // cor da moldura (GLOBAL, vale pra todos os ambientes)
          AMB_WOOD[t.dataset.wood] = hexToRgb(t.value);
          localStorage.setItem('jun26_amb_wood', JSON.stringify(AMB_WOOD));
          layout();
        } else if (t.dataset.tex) {
          // transparência da trama do canvas (GLOBAL)
          AMB_TEX_OP = parseFloat(t.value) / 100;
          t.nextElementSibling.textContent = t.value;
          localStorage.setItem('jun26_amb_tex', AMB_TEX_OP);
          layout();
        }
      });
      // Copia robusta (o clipboard async falha no iframe do preview → textarea+exec)
      var copyText = function (t) {
        if (outBox) { outBox.value = t; outBox.focus(); outBox.select(); }
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t); } catch (e) { /* noop */ }
        return ok;
      };
      panel.addEventListener('click', function (e) {
        var act = e.target.dataset.act;
        if (act === 'min') {
          var min = panel.classList.toggle('jun26-ambedit--min');
          e.target.textContent = min ? '+' : '–';
          return;
        }
        if (act === 'copy') {
          var c = curEnv.cal, f = curEnv.fx || AMB_FX_DEF;
          // Valores prontos pro EDITOR DE TEMA (bloco "AMBIENTADO: Ambiente"):
          // escala = px/cm ×10; posições/linhas em %; cores como no painel.
          var editor = '— Editor de tema —' +
            '\nEscala do quadro: ' + Math.round(c.pxPerCm * 10) +
            '\nPosição horizontal: ' + Math.round(c.anchorX * 100) +
            '\nAltura do pé do quadro: ' + Math.round(c.anchorY * 100) +
            '\nLinha dos móveis: ' + Math.round(curEnv.furnitureY * 100) +
            '\nLinha do teto: ' + Math.round(curEnv.ceilY * 100) +
            '\nZoom: ' + Math.round((c.zoom || 1) * 100) +
            '  Foco X: ' + Math.round((c.focalX != null ? c.focalX : 0.5) * 100) +
            '  Foco Y: ' + Math.round((c.focalY != null ? c.focalY : 0.5) * 100) +
            '\nBrilho: ' + f.brilho + '  Contraste: ' + f.contraste +
            '  Saturação: ' + f.saturacao + '  Calor: ' + f.calor +
            '\nZonas no-touch: ' + ((curEnv.noTouch && curEnv.noTouch.length) || 0);
          var nt = curEnv.noTouch && curEnv.noTouch.length ? (',\n  noTouch: ' + JSON.stringify(curEnv.noTouch)) : '';
          var out = "{ id: '" + curEnv.id + "', label: '" + curEnv.label +
            "', asset: '" + (curEnv.asset || curEnv.assetUrl || '') + "',\n  img: { w: " + curEnv.img.w +
            ', h: ' + curEnv.img.h + ' },\n  cal: ' + JSON.stringify(c) +
            ',\n  furnitureY: ' + curEnv.furnitureY + ', ceilY: ' + curEnv.ceilY +
            ',\n  fx: ' + JSON.stringify(f) + nt + ' }\n\n' + editor +
            '\n\n// cores das molduras (GLOBAL — vale pra todos os ambientes):\nvar AMB_WOOD = ' + JSON.stringify(AMB_WOOD) + ';' +
            '\nvar AMB_TEX_OP = ' + AMB_TEX_OP + '; // transparência da trama do canvas';
          var ok = copyText(out);
          console.log('[ambedit ' + curEnv.id + ']\n' + out);
          e.target.textContent = ok ? 'copiado ✓' : 'copie do campo ↓';
          setTimeout(function () { e.target.textContent = 'copiar valores'; }, 1600);
        } else if (act === 'reset') {
          localStorage.removeItem('jun26_amb_cal_' + curEnv.id);
          localStorage.removeItem('jun26_amb_fx_' + curEnv.id);
          localStorage.removeItem('jun26_amb_nt_' + curEnv.id);
          curEnv.fx = Object.assign({}, AMB_FX_DEF);
          curEnv.noTouch = [];
          syncPanel();
          layout();
          applyPhotoFilter();
        }
      });
    }
  }

  function inferStateFromSelection(molduraFs) {
    var current = molduraFs.querySelector('input:checked');
    return inferStateFromVariant(current ? current.value : 'padrão');
  }

  function inferStateFromVariant(value) {
    var s = { primario: 'padrão', profundidade: false, fino: false, paspatur: false };
    switch (value) {
      case 'canvas': s.primario = 'canvas'; break;
      case 'sem moldura': s.primario = 'sem moldura'; break;
      case 'padrão': break;
      case 'padrão com paspatur': s.paspatur = true; break;
      case 'caixa': s.profundidade = true; break;
      case 'caixa com paspatur': s.profundidade = true; s.paspatur = true; break;
      case 'slim': s.fino = true; break;
      case 'slim com paspatur': s.fino = true; s.paspatur = true; break;
    }
    return s;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
